import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { isRtl, LOCALES } from "@jornado/shared";

/**
 * Vier Sprachen von Anfang an. Arabisch laeuft von rechts nach links, deshalb
 * wird die Richtung am Dokument gesetzt und nicht in einzelnen Ansichten.
 * Nachtraeglich einzubauen waere ein Umbau jeder Seite.
 *
 * Arabisch hat sechs Mehrzahlformen statt zwei. Fehlt eine davon, faellt
 * i18next still auf Deutsch zurueck und mitten im arabischen Satz steht ein
 * deutsches Wort. Deshalb sind dort alle sechs Formen ausgeschrieben.
 */
const resources = {
  de: {
    translation: {
      "objektzahlen.titel": "Zahlen aus den Berichten",
      "objektzahlen.hinweis": "Übernommen aus den freigegebenen Berichten, in der Regel einer je Woche.",
      "objektzahlen.jeTag": "Verbrauch je Tag, damit sich die Zeiträume vergleichen lassen",
      "objektzahlen.tag": "Tag",
      "objektzahlen.dieseWoche": "Letzte 7 Tage",
      "objektzahlen.dieserMonat": "Dieser Monat",
      "objektzahlen.vormonat": "Monat davor",
      "objektzahlen.grundlast": "wenn leer",
      "objektzahlen.letzterWert": "Zuletzt gemessen",
      "objektzahlen.legendeVerbrauch": "Verbrauch je Tag in {{einheit}}",
      "objektzahlen.legendeWert": "Gemessener Wert",
      "objektzahlen.legendeUeblich": "Üblich an diesem Haus: {{wert}}",
      "objektzahlen.legendeZiel": "Zielbereich {{min}} bis {{max}}",
      "objektzahlen.legendeMehr": "Deutlich mehr als üblich",
      "objektzahlen.legendeAusserhalb": "Außerhalb des Zielbereichs",
      "objektzahlen.mengeUeberTage_one": "({{menge}} {{einheit}} in {{count}} Tag)",
      "objektzahlen.mengeUeberTage_other": "({{menge}} {{einheit}} in {{count}} Tagen)",
      "objektzahlen.auffaellig": "Zuletzt {{wert}} {{einheit}} am Tag, sonst sind es hier etwa {{basis}}. In dieser Zeit war jemand im Haus, das erklärt den Unterschied meistens.",
      "objektzahlen.leckverdacht": "Zuletzt {{wert}} {{einheit}} am Tag, obwohl niemand im Haus war. Bei leerem Haus sind hier sonst etwa {{basis}}. Das deutet auf eine undichte Stelle hin.",
      "objektzahlen.tabelleAuf": "Zahlen anzeigen",
      "objektzahlen.tabelleZu": "Zahlen ausblenden",
      "objektzahlen.ausserhalb": "außerhalb",
      "einrichtung.ansprache_one": "{{count}} Kunde ohne Anrede und Nachname, im Kalender steht dann nur der Anzeigename",
      "einrichtung.ansprache_other": "{{count}} Kunden ohne Anrede und Nachname, im Kalender steht dann nur der Anzeigename",
      "objekte.helferStarten_one": "Für {{count}} Objekt Koordinaten vorschlagen",
      "objekte.helferStarten_other": "Für alle {{count}} Objekte Koordinaten vorschlagen",
      "objekte.helferStand": "{{geprueft}} von {{gesamt}} geprüft",
      "objekte.helferBeenden": "Fertig",
      "objekte.helferWartet": "wartet",
      "objekte.helferUebernommen": "Koordinate übernommen",
      "einrichtung.titel": "Noch einzurichten",
      "einrichtung.hinweis": "Das kann keine Software für dich tun. Erledigtes verschwindet von selbst aus dieser Liste.",
      "einrichtung.hin": "hin",
      "einrichtung.vertrag_one": "{{count}} Mitarbeiter ohne Wochenstunden oder Eintrittsdatum",
      "einrichtung.vertrag_other": "{{count}} Mitarbeiter ohne Wochenstunden oder Eintrittsdatum",
      "einrichtung.urlaub_one": "{{count}} Mitarbeiter ohne Urlaubsanspruch für dieses Jahr",
      "einrichtung.urlaub_other": "{{count}} Mitarbeiter ohne Urlaubsanspruch für dieses Jahr",
      "einrichtung.baukasten": "Noch kein Prüfpunkt angelegt, ohne den bleibt der Bericht am Objekt leer",
      "einrichtung.fahrzeug": "Kein Fahrzeug angelegt, deshalb kann niemand Tanken eintragen",
      "einrichtung.handbuch": "Noch kein Handbuchartikel geschrieben",
      "einrichtung.koordinate_one": "{{count}} Objekt ohne Koordinate",
      "einrichtung.koordinate_other": "{{count}} Objekte ohne Koordinate",
      "einrichtung.zugang_one": "{{count}} Objekt ohne hinterlegte Zugangsdaten",
      "einrichtung.zugang_other": "{{count}} Objekte ohne hinterlegte Zugangsdaten",
      "einrichtung.ortung": "Die Ortung ist eingeschaltet. Die unterschriebene Mitarbeiterinformation nach Art. 90 LOPDGDD muss vorliegen",
      "einrichtung.firmenangaben_one": "{{count}} Pflichtangabe zur Firma fehlt, solange steht das Impressum unvollständig da",
      "einrichtung.firmenangaben_other": "{{count}} Pflichtangaben zur Firma fehlen, solange steht das Impressum unvollständig da",
      "zeit.empfangenAm": "Beim Server eingegangen am {{zeit}}",
      "netz.abmeldenTrotzWartend_one": "{{count}} Eingabe wurde noch nicht übertragen. Beim Abmelden geht sie verloren. Trotzdem abmelden?",
      "netz.abmeldenTrotzWartend_other": "{{count}} Eingaben wurden noch nicht übertragen. Beim Abmelden gehen sie verloren. Trotzdem abmelden?",
      "tag.stempel.tag.start": "Arbeitstag begonnen",
      "tag.stempel.tag.ende": "Arbeitstag beendet",
      "tag.stempel.einsatz.start": "Einsatz begonnen",
      "tag.stempel.einsatz.ende": "Einsatz beendet",
      "tag.stempel.pause": "Pause begonnen",
      "tag.stempel.pause.ende": "Pause beendet",
      "zeit.ohneNetz": "Ohne Netz gestempelt",
      "netz.ohneNetz": "Ohne Netz. Was du eingibst, bleibt auf dem Gerät und geht später von selbst raus.",
      "netz.wartet_one": "{{count}} Eingabe wartet",
      "netz.wartet_other": "{{count}} Eingaben warten",
      "netz.sendet": "Wird übertragen",
      "netz.jetztSenden": "Jetzt übertragen",
      "netz.abgelehnt_one": "{{count}} Eingabe wurde abgelehnt",
      "netz.abgelehnt_other": "{{count}} Eingaben wurden abgelehnt",
      "netz.abgelehntTitel": "Abgelehnte Eingaben",
      "netz.nichtsAbgelehnt": "Nichts mehr offen.",
      "netz.anzeigen": "Ansehen",
      "netz.schliessen": "Schließen",
      "netz.nochmal": "Nochmal versuchen",
      "netz.verwerfen": "Verwerfen",
      "netz.verwerfenFrage": "Diese Eingabe endgültig verwerfen? Sie ist danach weg.",
      "netz.versuche_one": "{{count}} Versuch",
      "netz.versuche_other": "{{count}} Versuche",
      "netz.ausAblage": "Ohne Netz. Angezeigt wird der Stand vom {{zeit}}.",
      "netz.gemerkt": "Ohne Netz gespeichert, geht später raus.",
      "app.neueFassung": "Eine neue Fassung liegt bereit.",
      "app.neueFassungLaden": "Jetzt übernehmen",
      "nav.pruefungen": "Reports",
      "nav.notizen": "Notizen",
      "pruefung.titel": "Reports",
      "pruefung.neu": "Neuer Report",
      "pruefung.neuHinweis": "Objekt und Checkliste wählen. Die Liste wird beim Start eingefroren.",
      "pruefung.starten": "Report starten",
      "pruefung.status": "Status",
      "pruefung.alleStatus": "Alle",
      "pruefung.leer": "Noch keine Reports.",
      "pruefung.zurFreigabe_one": "{{count}} Report wartet auf Freigabe",
      "pruefung.zurFreigabe_other": "{{count}} Reports warten auf Freigabe",
      "pruefung.leerBeiObjekt": "Für dieses Objekt gibt es noch keinen Report.",
      "pruefung.keineCheckliste": "Für dieses Objekt ist keine aktive Checkliste hinterlegt.",
      "pruefung.anzahl_one": "{{count}} Report",
      "pruefung.anzahl_other": "{{count}} Reports",
      "pruefung.nummer": "Report {{nummer}}",
      "pruefung.fortschritt": "{{erledigt}} von {{gesamt}} erfasst",
      "pruefung.maengel_one": "{{count}} Mangel",
      "pruefung.maengel_other": "{{count}} Mängel",
      "pruefung.status.draft": "Entwurf",
      "pruefung.status.submitted": "Eingereicht",
      "pruefung.status.changes_requested": "Zurückgegeben",
      "pruefung.status.approved": "Freigegeben",
      "pruefung.status.sent": "Versandt",
      "pruefung.status.cancelled": "Zurückgenommen",
      "pruefung.einreichen": "Einreichen",
      "pruefung.freigeben": "Freigeben",
      "pruefung.zurueckgeben": "Zurückgeben",
      "pruefung.zuruecknehmen": "Zurücknehmen",
      "pruefung.loeschen": "Endgültig löschen",
      "pruefung.loeschenFrage": "Wirklich endgültig löschen? Das lässt sich nicht rückgängig machen.",
      "pruefung.loeschenJa": "Ja, löschen",
      "pruefung.loeschenFehler": "Der Report konnte nicht gelöscht werden",
      "pruefung.pdf": "PDF",
      "pruefung.pdfFehler": "Das PDF konnte nicht erzeugt werden",
      "sprache.de": "DE",
      "sprache.en": "EN",
      "pruefung.rueckgabeGrund": "Was fehlt oder muss nachgebessert werden?",
      "pruefung.zurueckgegeben": "Zurückgegeben von der Geschäftsleitung",
      "pruefung.nochOffen": "Das fehlt noch",
      "pruefung.grund.offen": "noch nicht erfasst",
      "pruefung.grund.mangel_ohne_kommentar": "Mangel ohne Kommentar",
      "pruefung.grund.wert_ohne_kommentar": "Wert außerhalb des Ziels ohne Kommentar",
      "pruefung.grund.foto_fehlt": "Mangel ohne Foto",
      "foto.aufnehmen": "Foto",
      "foto.galerie": "Aus der Galerie",
      "foto.laedtAnzahl_one": "{{count}} Bild wird hochgeladen",
      "foto.laedtAnzahl_other": "{{count}} Bilder werden hochgeladen",
      "foto.anderes": "Anderes Foto",
      "foto.belegAufnehmen": "Beleg fotografieren",
      "foto.belegPflicht": "Ohne Foto lässt sich nicht speichern",
      "foto.laedt": "Lädt hoch",
      "foto.entfernen": "Foto entfernen",
      "foto.pflicht": "Bei diesem Punkt ist ein Foto Pflicht",
      "foto.fehler": "Das Foto konnte nicht gespeichert werden",
      "pruefung.ergebnis.done": "Erledigt",
      "pruefung.ergebnis.ok": "Kontrolliert, in Ordnung",
      "pruefung.ergebnis.fault": "Kontrolliert, nicht in Ordnung",
      "pruefung.ergebnis.na": "Nicht kontrolliert",
      "pruefung.ja": "Erledigt",
      "pruefung.nein": "Entfällt",
      "pruefung.wert": "Wert",
      "pruefung.ausserhalb": "Außerhalb des Ziels",
      "pruefung.kommentar": "Kommentar",
      "pruefung.kommentarPflicht": "Kommentar erforderlich",
      "pruefung.kommentarFehlt": "Ohne Kommentar lässt sich der Report nicht einreichen.",
      "pruefung.kundentext": "Text für den Kunden",
      "pruefung.kundentextHinweis": "Dieser Text steht im PDF, das der Eigentümer bekommt.",
      "pruefung.gespeichert": "Gespeichert",
      "ki.vorschlag": "Vorschlag von Claude",
      "ki.denkt": "Claude schreibt",
      "ki.marke": "Vorschlag von Claude",
      "ki.markeBearbeitet": "Von Claude, bearbeitet",
      "ki.hinweis": "Der Vorschlag wird nicht gespeichert und nicht verschickt. Erst Lesen, dann Speichern.",
      "ki.uebersetzen": "Übersetzen",
      "ki.fehler": "Claude konnte gerade nicht helfen",
      "ki.rest": "noch {{n}} mal",
      "ki.aufgebraucht": "Aufgebraucht. Der Text lässt sich weiter von Hand ändern.",
      "versand.titel": "Versand an den Eigentümer",
      "versand.hinweis": "Der Jornado Report geht als PDF an den Kunden. Erst hier verlässt er das Haus.",
      "versand.an": "An",
      "versand.kopie": "Blinde Kopie",
      "versand.betreff": "Betreff",
      "versand.anhang": "Anhang",
      "versand.anhangPdf": "Jornado Report als PDF ({{sprache}})",
      "versand.senden": "An den Kunden senden",
      "versand.erneut": "Erneut senden",
      "versand.frage": "Wirklich an {{an}} senden?",
      "versand.ja": "Ja, senden",
      "versand.laeuft": "Wird gesendet",
      "versand.bereits": "Versandt am {{datum}} an {{an}}",
      "versand.fehler": "Der Report konnte nicht versandt werden",
      "versand.letzterFehler": "Letzter Versuch am {{datum}}: {{fehler}}",
      "nav.auftraege": "Aufträge",
      "auftraege.titel": "Arbeitsaufträge",
      "auftraege.anzahl_one": "{{count}} Auftrag",
      "auftraege.anzahl_other": "{{count}} Aufträge",
      "auftraege.leer": "Keine Aufträge in diesem Zustand.",
      "auftraege.loeschenSicher": "Diesen Auftrag endgültig löschen? Verlauf und Fotos gehen mit. Gebuchte Zeiten bleiben, sie verlieren nur den Verweis.",
      "auftraege.geloesteZeiten_one": "{{count}} gebuchte Zeit hing an diesem Auftrag. Sie bleibt im Register, ohne Auftrag.",
      "auftraege.geloesteZeiten_other": "{{count}} gebuchte Zeiten hingen an diesem Auftrag. Sie bleiben im Register, ohne Auftrag.",
      "auftraege.neu": "Neuer Auftrag",
      "auftraege.nummer": "Auftrag {{nummer}}",
      "auftraege.offen": "Offen",
      "auftraege.alle": "Alle",
      "auftraege.zustand": "Zustand",
      "auftraege.objekt": "Objekt",
      "auftraege.titel1": "Titel",
      "auftraege.beschreibung": "Beschreibung",
      "auftraege.prioritaet": "Dringlichkeit",
      "auftraege.termin": "Termin",
      "auftraege.zugewiesen": "Zugewiesen an",
      "auftraege.ohneZuweisung": "Nicht zugewiesen",
      "auftraege.fotos": "Fotos",
      "auftraege.keineFotos": "Noch keine Fotos.",
      "auftraege.verlauf": "Verlauf",
      "auftraege.notiz": "Notiz speichern",
      "auftraege.notizPlatzhalter": "Kurze Notiz für die Kollegen",
      "auftraege.zurueckZurListe": "Zurück zur Liste",
      "auftraege.ausMangel": "Auftrag aus diesem Mangel",
      "auftraege.status.open": "Offen",
      "auftraege.status.scheduled": "Terminiert",
      "auftraege.status.in_progress": "In Bearbeitung",
      "auftraege.status.waiting": "Wartet",
      "auftraege.status.done": "Erledigt",
      "auftraege.status.cancelled": "Zurückgezogen",
      "auftraege.prio.low": "Niedrig",
      "auftraege.prio.normal": "Normal",
      "auftraege.prio.high": "Hoch",
      "auftraege.prio.urgent": "Dringend",
      "auftraege.fotoart.before": "Vorher",
      "auftraege.fotoart.after": "Nachher",
      "auftraege.fotoart.receipt": "Beleg",
      "auftraege.fotoart.other": "Sonstiges",
      "auftraege.fotoHinzu.before": "Vorher hinzufügen",
      "auftraege.fotoHinzu.after": "Nachher hinzufügen",
      "auftraege.fotoHinzu.receipt": "Beleg hinzufügen",
      "auftraege.ereignis.created": "Angelegt",
      "auftraege.ereignis.assigned": "Zuweisung geändert",
      "auftraege.ereignis.status_changed": "Zustand geändert",
      "auftraege.ereignis.note": "Notiz",
      "system.titel": "Zustand der Anlage",
      "nav.zeiten": "Zeit",
      "nav.meinTag": "Mein Tag",
      "nav.meineWoche": "Meine Woche",
      "nav.meineZeit": "Meine Zeit",
      "nav.antraege": "Anträge",
      "nav.team": "Team",
      "nav.fuhrpark": "Tankbuch",
      "nav.handbuch": "Handbuch",
      "nav.hinweis": "Hinweise an Chef",
      "fuhrpark.titel": "Tankbuch",
      "fuhrpark.hinweis": "Fahrzeug, Kilometerstand, Foto vom Beleg.",
      "fuhrpark.neuerEintrag": "Tanken eintragen",
      "fuhrpark.neuesFahrzeug": "Fahrzeug anlegen",
      "fuhrpark.fahrzeug": "Fahrzeug",
      "fuhrpark.kilometerstand": "Kilometerstand",
      "fuhrpark.kmHinweis": "Der Wert, den man vergisst, sobald man weggefahren ist.",
      "fuhrpark.literLabel": "Liter",
      "fuhrpark.betrag": "Betrag in Euro",
      "fuhrpark.notiz": "Notiz",
      "fuhrpark.beleg": "Beleg",
      "fuhrpark.belegHinweis": "Foto vom Kassenzettel, freiwillig.",
      "fuhrpark.dreiAngaben": "Drei Angaben genügen. Liter und Betrag werden vom Beleg gelesen.",
      "fuhrpark.belegPflicht": "Foto vom Kassenzettel. Ohne Beleg lässt sich nichts eintragen.",
      "fuhrpark.betragOffen": "Betrag folgt",
      "fuhrpark.vomBeleg": "vom Beleg gelesen",
      "fuhrpark.berichtigen": "Zahlen berichtigen",
      "fuhrpark.nochmalLesen": "Beleg noch einmal lesen",
      "fuhrpark.ohneBetrag_one": "{{count}} Beleg ohne Betrag",
      "fuhrpark.ohneBetrag_other": "{{count}} Belege ohne Betrag",
      "fuhrpark.belegZeigen": "Beleg ansehen",
      "fuhrpark.summe": "Summe",
      "fuhrpark.liter": "Getankt",
      "fuhrpark.kmStand": "{{km}} km",
      "fuhrpark.leer": "In diesem Monat wurde nichts eingetragen.",
      "fuhrpark.keineFahrzeuge": "Es ist noch kein Fahrzeug angelegt. Sag im Büro Bescheid.",
      "fuhrpark.keineFahrzeugeChef": "Leg zuerst ein Fahrzeug an, sonst kann niemand tanken eintragen.",
      "fuhrpark.kennzeichen": "Kennzeichen",
      "fuhrpark.bezeichnung": "Bezeichnung",
      "fuhrpark.bezeichnungHinweis": "Wie ihr das Auto nennt, etwa \"Transporter weiß\".",
      "fuhrpark.modell": "Modell",
      "fuhrpark.kraftstoff": "Kraftstoff",
      "handbuch.titel": "Handbuch",
      "handbuch.hinweis": "Betriebsanleitungen und Anordnungen.",
      "handbuch.suche": "Suchen",
      "handbuch.kategorie": "Kategorie",
      "handbuch.alleKategorien": "alle",
      "handbuch.leer": "Dazu gibt es nichts.",
      "handbuch.neu": "Artikel anlegen",
      "handbuch.kennung": "Kennung",
      "handbuch.kennungHinweis": "Kurz und ohne Leerzeichen, etwa winterschliessung-pool.",
      "handbuch.sichtbarkeit": "Sichtbar für",
      "handbuch.fuerAlle": "alle Mitarbeiter",
      "handbuch.nurChef": "nur Geschäftsleitung",
      "handbuch.artikelTitel": "Titel",
      "handbuch.artikelText": "Text",
      "handbuch.archivieren": "Archivieren",
      "handbuch.ersatzsprache": "auf Deutsch, in deiner Sprache noch nicht vorhanden",
      "handbuch.deutschPflicht": "Titel und Text auf Deutsch sind Pflicht, der Rest ist freiwillig.",
      "rechte.nurBuero": "Diese Seite ist für das Büro.",
      "rechte.nurBueroHinweis": "Dein Zugang deckt sie nicht ab. Wenn du etwas davon brauchst, sag im Büro Bescheid.",
      "rechte.zurueck": "Zurück zu meinem Tag",
      "einladung.titel": "Willkommen",
      "einladung.hinweis": "Setz dir ein Passwort, mindestens zwölf Zeichen.",
      "einladung.passwort": "Passwort",
      "einladung.wiederholen": "Passwort wiederholen",
      "einladung.ungleich": "Die beiden Passwörter sind nicht gleich.",
      "einladung.ungueltig": "Dieser Link ist ungültig, abgelaufen oder wurde schon benutzt.",
      "einladung.starten": "Loslegen",
      "meinezeit.titel": "Meine Zeit",
      "meinezeit.ist": "Gearbeitet",
      "meinezeit.soll": "Soll",
      "meinezeit.saldoMonat": "Saldo im Monat",
      "meinezeit.tage": "Tage",
      "meinezeit.nichtGestempelt": "nicht gestempelt",
      "meinezeit.saldoGesamt": "Überstunden insgesamt, seit {{seit}}",
      "meinezeit.rechnung": "{{wochenstunden}} Stunden die Woche · gearbeitet {{ist}} · Soll {{soll}}",
      "meinezeit.ohneSoll": "Für dich sind noch keine Wochenstunden hinterlegt. Ohne die lässt sich kein Saldo rechnen. Sag im Büro Bescheid.",
      "antrag.titel": "Anträge",
      "antrag.hinweis": "Urlaub, Krankmeldung und Korrektur einer Zeit.",
      "antrag.hinweisChef": "Offene Anträge deiner Mitarbeiter.",
      "antrag.neuAbwesenheit": "Urlaub oder Krankmeldung",
      "antrag.neuKorrektur": "Zeitkorrektur",
      "antrag.abwesenheiten": "Urlaub und Abwesenheit",
      "antrag.korrekturen": "Zeitkorrekturen",
      "antrag.leer": "Nichts vorhanden.",
      "antrag.artLabel": "Art",
      "antrag.art.vacation": "Urlaub",
      "antrag.art.sick": "Krank",
      "antrag.art.unpaid": "Unbezahlt",
      "antrag.art.special": "Sonderurlaub",
      "antrag.art.training": "Schulung",
      "antrag.von": "Von",
      "antrag.bis": "Bis",
      "antrag.bisHinweis": "Leer lassen für einen einzelnen Tag.",
      "antrag.halberErster": "Erster Tag nur halb",
      "antrag.halberLetzter": "Letzter Tag nur halb",
      "antrag.grund": "Anmerkung",
      "antrag.datum": "Datum",
      "antrag.einreichen": "Einreichen",
      "antrag.genehmigen": "Genehmigen",
      "antrag.ablehnen": "Ablehnen",
      "antrag.zurueckziehen": "Zurückziehen",
      "antrag.entschieden": "Entschieden am {{am}} von {{von}}",
      "antrag.tage_one": "{{count}} Tag",
      "antrag.tage_other": "{{count}} Tage",
      "antrag.status.requested": "offen",
      "antrag.status.approved": "genehmigt",
      "antrag.status.rejected": "abgelehnt",
      "antrag.status.cancelled": "zurückgezogen",
      "antrag.korrekturHinweis": "Trag ein, wann du wirklich gearbeitet hast. Das Büro entscheidet, erst dann ändert sich das Register.",
      "antrag.keineBuchung": "An diesem Tag steht keine Buchung. Der Antrag legt dann einen ganzen Arbeitstag an.",
      "antrag.korrigiertBuchung": "Korrigiert wird die Buchung von {{von}} bis {{bis}}.",
      "antrag.welcheBuchung": "Welche Buchung",
      "antrag.buchungWaehlen": "Bitte wählen",
      "team.titel": "Team",
      "team.hinweis": "Zugänge, Wochenstunden und Feiertage.",
      "team.einladen": "Mitarbeiter einladen",
      "team.name": "Name",
      "team.email": "E-Mail",
      "team.emailHinweis": "Damit meldet er sich an. Ändern, wenn die Adresse nicht mehr erreichbar ist; alle Daten bleiben an diesem Menschen.",
      "team.zugangHinweis": "Kommt jemand nicht mehr herein, weil er Passwort oder Postfach verloren hat: Adresse oben berichtigen, speichern, dann hier eine neue Einladung schicken. Er vergibt selbst ein neues Passwort. Es entsteht kein zweites Konto, Zeiten und Berichte bleiben stehen.",
      "team.zugangNeu": "Zugang neu einrichten",
      "team.zugangGesendet": "Einladung an {{an}} verschickt. Sie gilt sieben Tage.",
      "team.zugangOhneMail": "Kein Mailserver eingerichtet. Diesen Link weitergeben, er gilt sieben Tage:",
      "team.rolleLabel": "Rolle",
      "team.rolle.admin": "Geschäftsleitung",
      "team.rolle.lead": "Vorarbeiter",
      "team.rolle.employee": "Mitarbeiter",
      "team.einladungSenden": "Einladung senden",
      "team.einladenHinweis": "Er bekommt einen Link per E-Mail und setzt sein Passwort selbst. Du erfährst es nicht.",
      "team.keinVersand": "Es geht keine Post raus. Gib ihm diesen Link persönlich, er gilt sieben Tage.",
      "team.wochenstunden": "Wochenstunden",
      "team.wochenstundenHinweis": "Aus dem Vertrag. Ohne diesen Wert gibt es keine Überstunden.",
      "team.wochenstundenWert": "{{stunden}} Stunden die Woche",
      "team.ohneWochenstunden": "Keine Wochenstunden hinterlegt",
      "team.eintritt": "Eintritt",
      "team.eintrittHinweis": "Ab hier zählt der Gesamtsaldo.",
      "team.faehrtMit": "Fährt mit",
      "team.faehrtMitHinweis": "Für Mitarbeiter ohne eigenes Auto. Der Wochenvorschlag plant sie nie allein, sondern auf die Termine ihres Fahrers.",
      "team.faehrtSelbst": "Fährt selbst",
      "team.wohnort": "Wohnort",
      "team.wohnortHinweis": "Nur der Ort, keine Anschrift. Der Weg dorthin ist Freizeit und zählt nicht als Arbeitszeit; er entscheidet nur, an welchem Ende die optimierte Route beginnt. Die Koordinate wird beim Speichern gesucht.",
      "team.planPosition": "Reihenfolge im Dienstplan",
      "team.planPositionHinweis": "Kleine Zahl steht links. Leer heißt hinten, dort nach Namen. Reine Anzeige: die Zahl sagt nichts über Rang oder Qualifikation.",
      "team.imDienstplan": "Spalte im Dienstplan",
      "team.imDienstplanHinweis": "Wer nie eingeplant wird, braucht keine leere Spalte. Ausblenden sperrt nichts: bekommt er doch einen Termin, erscheint die Spalte an dem Tag wieder.",
      "team.imDienstplanAn": "Eigene Spalte anzeigen",
      "team.wohnortOhneTreffer": "Zu diesem Ort wurde keine Koordinate gefunden. Die Richtung der Route bleibt dann, wie sie ist.",
      "team.faehrtMitWert": "fährt mit {{name}}",
      "team.nurAushilfe": "{{abteilung}}: hilft nur aus",
      "team.abteilungAushilfe": "{{abteilung}} (Aushilfe)",
      "team.seit": "seit {{datum}}",
      "team.bis": "bis {{datum}}",
      "team.austritt": "Austritt",
      "team.austrittHinweis": "Beendet das Arbeitsverhältnis und sperrt den Zugang.",
      "team.austrittWarnung": "Der Zugang wird gesperrt, alle angemeldeten Geräte werden abgemeldet, künftige Dienste fallen weg und offene Aufträge werden zur Neuvergabe freigegeben. Arbeitszeiten und Reports bleiben vollständig erhalten.",
      "team.austrittDatum": "Letzter Arbeitstag",
      "team.austrittGrund": "Grund",
      "team.austrittGrundHinweis": "Freiwillig, steht nur im Protokoll",
      "team.austrittBestaetigen": "Austritt durchführen",
      "team.austrittFertig": "{{name}} ist ausgetreten",
      "team.bilanzGeraete_one": "Ein Gerät abgemeldet",
      "team.bilanzGeraete_other": "{{count}} Geräte abgemeldet",
      "team.bilanzDienste_one": "Ein geplanter Dienst entfernt",
      "team.bilanzDienste_other": "{{count}} geplante Dienste entfernt",
      "team.bilanzAuftraege_one": "Ein Auftrag wartet auf Neuvergabe",
      "team.bilanzAuftraege_other": "{{count}} Aufträge warten auf Neuvergabe",
      "team.bilanzZeiten": "Arbeitszeiten und Reports bleiben erhalten.",
      "team.wiedereintritt": "Wieder einstellen",
      "team.aktiv": "Zugang aktiv",
      "team.stillgelegt": "stillgelegt",
      "team.zustand.arbeitet": "arbeitet seit {{zeit}}",
      "team.zustand.pause": "in Pause",
      "team.zustand.vergessen": "Ausstempeln vergessen",
      "team.zustand.nichtDa": "nicht eingestempelt",
      "team.feiertage": "Feiertage",
      "leistung.titel": "Sollstunden je Woche",
      "leistung.gesamt": "{{stunden}} gesamt",
      "leistung.leer": "Noch keine Sollstunden hinterlegt.",
      "wochentag.1": "Montag",
      "wochentag.2": "Dienstag",
      "wochentag.3": "Mittwoch",
      "wochentag.4": "Donnerstag",
      "wochentag.5": "Freitag",
      "wochentag.6": "Samstag",
      "wochentag.7": "Sonntag",
      "leistung.festerTag": "Fester Wochentag",
      "leistung.festerTagHinweis": "Nur setzen, wenn der Tag wirklich nicht verschiebbar ist.",
      "leistung.festeZeit": "Feste Uhrzeit",
      "leistung.festeZeitHinweis": "Nur zusammen mit einem festen Tag. Leer heißt: Tag fest, Uhrzeit frei.",
      "leistung.rhythmus": "Rhythmus",
      "leistung.rhythmusHinweis": "Für zwei Häuser nebeneinander, die abwechselnd drankommen. Was diese Woche nicht dran ist, steht auch nicht im Bedarf. In der Kundenauswertung zählt der Schnitt: alle zwei Wochen sind im Monat die halbe Zeit.",
      "leistung.jedeWoche": "Jede Woche",
      "leistung.alleWochen": "Alle {{wochen}} Wochen",
      "leistung.rhythmusAb": "Erste fällige Woche",
      "leistung.rhythmusAbHinweis": "Ab dieser Woche wird gezählt. Ein beliebiger Tag genügt, die Anlage nimmt den Montag dieser Woche.",
      "leistung.rhythmusZeile": "Alle {{wochen}} Wochen, gezählt ab der Woche vom {{ab}}",
      "leistung.freiPlanbar": "Frei planbar",
      "leistung.festTagZeit": "Fest: {{tag}} um {{zeit}}",
      "leistung.festNurTag": "Fest: {{tag}}, Uhrzeit frei",
      "leistung.neu": "Sollzeit anlegen",
      "leistung.loeschenSicher": "Diese Sollzeit löschen?",
      "leistung.stundenProWoche": "Stunden je Woche",
      "leistung.stundenHinweis": "Arbeitsstunden, nicht Kalenderzeit: vier Stunden Garten sind auch zwei Gärtner zwei Stunden.",
      "leistung.von": "Gültig ab",
      "leistung.bis": "Gültig bis",
      "leistung.zeitraumHinweis": "Leer heißt: gilt immer. Für Sommer und Winter je eine Zeile anlegen.",
      "leistung.abDatum": "ab {{datum}}",
      "leistung.bisDatum": "bis {{datum}}",
      "team.abteilungen": "Abteilungen",
      "team.abteilungenHinweis": "Wofür dieser Mensch eingeteilt werden kann. Aushelfen darf er trotzdem überall, der Dienstplan weist dann darauf hin.",
      "team.abteilungenListeHinweis": "Garten, Pool, Reinigung, Technik. Eine Abteilung wird nie gelöscht, sondern stillgelegt: an ihr hängen Termine und Sollstunden der Vergangenheit.",
      "team.abteilungName": "Name der Abteilung",
      "team.abteilungHinzu": "Abteilung anlegen",
      "team.abteilungBelegt": "{{menschen}} Mitarbeiter · {{objekte}} Objekte",
      "team.stilllegen": "Stilllegen",
      "team.wiederAufnehmen": "Wieder aufnehmen",
      "team.jahr": "Jahr",
      "team.feiertagName": "Name",
      "team.feiertagHinzu": "Eintragen",
      "team.feiertageHinweis": "Eine gepflegte Liste, weil auf Mallorca national, balearisch und örtlich nebeneinander gelten. Ein Feiertag senkt das Soll um einen Arbeitstag.",
      "aktion.fertig": "Fertig",
      "nav.plan": "Dienstplan",
      "tag.titel": "Hallo {{name}}",
      "tag.nichtBegonnen": "Dein Arbeitstag hat noch nicht begonnen.",
      "tag.beginnen": "Arbeitstag beginnen",
      "tag.beenden": "Arbeitstag beenden",
      "tag.termine": "Heute",
      "tag.keineTermine": "Für heute ist nichts eingeplant.",
      "tag.navigieren": "Navigieren",
      "tag.einsatzStart": "Einsatz beginnen",
      "tag.einsatzEnde": "Einsatz beenden",
      "tag.checkliste": "Checkliste",
      "tag.checklisteWaehlen": "Welche Checkliste?",
      "tag.wegfahrtTitel": "Noch ein Einsatz offen",
      "tag.wegfahrtText": "Bei {{objekt}} läuft seit {{seit}} ein Einsatz. Wann bist du dort weggefahren?",
      "tag.wegfahrtFahrt_one": "Etwa {{count}} Minute Fahrt von dort hierher",
      "tag.wegfahrtFahrt_other": "Etwa {{count}} Minuten Fahrt von dort hierher",
      "tag.wegfahrtFrage": "Weggefahren um",
      "tag.wegfahrtUebernehmen": "Übernehmen und beginnen",
      "tag.wegfahrtEben": "War bis eben dort",
      "tag.wegfahrtUngueltig": "Die Uhrzeit muss nach dem Beginn und darf nicht in der Zukunft liegen.",
      "tag.laeuft": "läuft",
      "tag.erledigt": "erledigt",
      "tag.imEinsatz": "Im Einsatz bei {{objekt}}, seit {{seit}}",
      "tag.gestempelt": "Heute gestempelt",
      "tag.ungeplant": "ungeplant",
      "tag.ungeplantOeffnen": "Ungeplanter Einsatz",
      "tag.ungeplantHinweis": "Nur, wenn kein Termin dafür im Plan steht. Das Büro sieht es als ungeplant.",
      "tag.ungeplantLaeuft": "Ungeplanter Einsatz bei {{objekt}}, seit {{seit}}",
      "tag.keineCheckliste": "Für dieses Objekt ist keine Checkliste hinterlegt.",
      "plan.titel": "Dienstplan",
      "plan.ansichtTag": "Tag",
      "plan.ansichtWoche": "Woche",
      "plan.terminAendern": "Termin ändern",
      "plan.datum": "Datum",
      "plan.frei": "frei",
      "plan.loeschenSicher": "Diesen Termin löschen?",
      "plan.ziehenHinweis": "Ziehen verschiebt einen Termin: zur Seite zu einem anderen Mitarbeiter, nach oben oder unten auf eine andere Uhrzeit, auf einen Tag in der Leiste auf einen anderen Tag. Klicken öffnet ihn zum Ändern oder Löschen.",
      "plan.termineZahl_one": "{{count}} Termin",
      "plan.termineZahl_other": "{{count}} Termine",
      "plan.konflikteZahl_one": "{{count}} Konflikt",
      "plan.konflikteZahl_other": "{{count}} Konflikte",
      "plan.hinweis": "Was hier steht, sehen die Mitarbeiter als ihren Tag.",
      "plan.zurueck": "Woche zurück",
      "plan.vor": "Woche vor",
      "plan.heute": "Diese Woche",
      "plan.neu": "Termin",
      "plan.neuerTermin": "Neuer Termin am {{tag}}",
      "plan.wiederholungen": "Wochen",
      "plan.wiederholungenHinweis": "1 heißt einmalig. 12 legt zwölf Wochen im Voraus an.",
      "plan.notiz": "Notiz für den Mitarbeiter",
      "plan.konfliktAbwesenheit": "Genehmigt abwesend: {{art}}",
      "plan.konfliktUeberschneidung": "Überschneidet sich mit einem anderen Termin",
      "plan.konfliktFeiertag": "Feiertag: {{name}}",
      "plan.ohneKoordinate": "Objekt ohne Koordinate, keine Abstandsprüfung",
      "plan.gestempelt": "Hier wurde schon gestempelt",
      "plan.ansichtBedarf": "Bedarf",
      "plan.abteilung": "Abteilung",
      "plan.ohneAbteilung": "Ohne Abteilung",
      "plan.team": "Team",
      "plan.teamHinweis": "Mehrere möglich. Vier Stunden Garten sind zwei Gärtner zwei Stunden.",
      "plan.teamZahl_one": "{{count}} Person",
      "plan.teamZahl_other": "{{count}} Personen",
      "plan.gemeinsamMit": "Gemeinsam mit {{namen}}",
      "plan.arbeitsstunden_one": "{{stunden}} Arbeitszeit, eine Person",
      "plan.arbeitsstunden_other": "{{stunden}} Arbeitszeit, {{count}} Personen zusammen",
      "plan.konfliktFachfremd": "Nicht für {{abteilung}} eingetragen",
      "plan.bedarfLeer": "Für kein Objekt sind Sollstunden hinterlegt.",
      "plan.bedarfOffen_one": "{{count}} Leistung ist diese Woche noch nicht vollständig geplant.",
      "plan.bedarfOffen_other": "{{count}} Leistungen sind diese Woche noch nicht vollständig geplant.",
      "plan.bedarfObjekt": "Objekt",
      "plan.bedarfSoll": "Soll",
      "plan.bedarfGeplant": "Geplant",
      "plan.bedarfRest": "Offen",
      "plan.farbeLaeuft": "Lila: jemand ist gerade eingestempelt",
      "plan.farbeBeendet": "Grün: Besuch beendet",
      "plan.notizHinweis": "Dauerhaft am Objekt. Der Mitarbeiter sieht sie in Schwarz.",
      "plan.aenderung": "Änderung für diesen Tag",
      "plan.aenderungHinweis": "Steht beim Mitarbeiter rot ganz oben am Termin. Leer lassen, wenn heute nichts anders ist.",
      "plan.aenderungGelesen": "Gelesen von {{name}} am {{zeit}}.",
      "plan.aenderungUngelesen": "Noch nicht gelesen.",
      "plan.aenderungUngelesenKurz": "ungelesen",
      "tag.aenderung": "Heute anders",
      "tag.aenderungGelesen": "Gelesen",
      "tag.aenderungQuittiert": "Als gelesen gemeldet.",
      "notiz.titel": "Interne Notiz",
      "pruefung.team": "Ihr füllt diesen Bericht gemeinsam aus: {{namen}}. Teilt die Liste auf, sonst überschreibt einer den anderen.",
      "pruefung.nichtGespeichert": "Nicht gespeichert. Prüfe die Eingabe und tippe noch einmal daneben.",
      "pruefung.fortschrittGesamt": "im ganzen Bericht {{erledigt}} von {{gesamt}}",
      "pruefung.nurMeineBereiche": "Sie sehen die Bereiche Ihrer Abteilung an diesem Tag. Die übrigen Punkte trägt Ihr Kollege ein.",
      "pruefung.weitereFotos": "Weitere Fotos",
      "pruefung.weitereFotosHinweis": "Bilder, die zu keinem einzelnen Punkt gehören: Rundgang, Zufahrt, Gesamteindruck. Sie stehen im Bericht am Ende, ohne Überschrift.",
      "team.abteilungBereich": "Bereiche im Bericht",
      "team.abteilungBereichHinweis": "Welche Prüfpunkte diese Abteilung im Bericht sieht. Nichts angehakt heißt: alle.",
      "muster.titel": "Musterberichte",
      "wasser.titel": "Wasserverbrauch",
      "wasser.ruhig": "Kein Objekt verbraucht gerade auffällig mehr als sonst.",
      "wasser.auffaellige_one": "{{count}} Objekt verbraucht deutlich mehr als sonst. Prüfen lohnt sich.",
      "wasser.auffaellige_other": "{{count}} Objekte verbrauchen deutlich mehr als sonst. Prüfen lohnt sich.",
      "wasser.objekt": "Kunde und Objekt",
      "wasser.proTag": "m³ je Tag",
      "wasser.ueblich": "sonst",
      "wasser.woche": "letzte 7 Tage",
      "wasser.monat": "Monat je Tag",
      "wasser.vormonat": "Vormonat",
      "wasser.abgelesen": "Abgelesen",
      "wasser.marke": "auffällig",
      "wasser.tage_one": "über {{count}} Tag",
      "wasser.tage_other": "über {{count}} Tage",
      "wasser.alleZeigen": "Alle {{count}} Objekte zeigen",
      "wasser.hinweis": "Verglichen wird der Verbrauch je Tag mit dem, was an diesem Objekt üblich ist: ein leeres Haus mit früheren leeren Wochen, ein belegtes mit belegten. Rot mit Marke heißt leer und trotzdem deutlich mehr als sonst, und das ist der Fall, dem man nachgeht. Bernstein heißt nur mehr als sonst. Ein Objekt ohne gepflegte Aufenthalte gilt als leer.",
      "wasser.verdacht_one": "{{count}} Objekt stand leer und hat trotzdem deutlich mehr verbraucht als sonst. Das ist der Fall, dem man nachgeht.",
      "wasser.verdacht_other": "{{count}} Objekte standen leer und haben trotzdem deutlich mehr verbraucht als sonst. Das sind die Fälle, denen man nachgeht.",
      "wasser.haus": "Haus",
      "wasser.hausLeer": "leer",
      "wasser.hausBelegt_one": "belegt, {{count}} Tag",
      "wasser.hausBelegt_other": "belegt, {{count}} Tage",
      "wasser.grundlast": "leer sonst",
      "wasser.markeMehr": "mehr als sonst",
      "wasser.vergleich.leer": "leere Wochen",
      "wasser.vergleich.belegt": "belegte Wochen",
      "wasser.vergleich.alle": "alle Wochen",
      "muster.hinweis": "Legt für einen Kunden mit genau einem Objekt vollständige, freigegebene Berichte an, zwei je Woche, mit Wasserzähler und Poolwerten. Damit hat der Verlauf am Objekt etwas zu zeigen und eine Vorführung sieht aus wie der echte Betrieb. Sie werden nie versandt, tragen im Büro den Vermerk \"Musterbericht\" und lassen sich jederzeit wieder entfernen.",
      "muster.kunde": "Kunde",
      "muster.kundeWaehlen": "Bitte wählen",
      "muster.monat": "Monat",
      "muster.anzahl": "Anzahl",
      "muster.anzahlHinweis": "Dienstag und Freitag, höchstens zwölf",
      "muster.anlegen": "Musterberichte anlegen",
      "muster.entfernen": "Musterberichte entfernen",
      "muster.angelegt_one": "{{count}} Musterbericht für {{kunde}} angelegt, je {{punkte}} Prüfpunkte. Termine: {{tage}}",
      "muster.angelegt_other": "{{count}} Musterberichte für {{kunde}} angelegt, je {{punkte}} Prüfpunkte. Termine: {{tage}}",
      "muster.entfernt_one": "{{count}} Musterbericht entfernt.",
      "muster.entfernt_other": "{{count}} Musterberichte entfernt.",
      "notiz.hinweis": "Sieht nur das Büro. Nicht im Bericht für den Eigentümer.",
      "notiz.platzhalter": "Was das Büro wissen sollte und der Kunde nicht.",
      "notiz.reiter": "Interne Notizen",
      "notiz.reiterHinweis": "Was die Mitarbeiter am Objekt notiert haben. Abgehakt heißt archiviert, nicht gelöscht.",
      "notiz.zeigeErledigte": "Erledigte anzeigen",
      "notiz.zeigeOffene": "Offene anzeigen",
      "notiz.keineOffenen": "Keine offenen Notizen.",
      "notiz.keineErledigten": "Noch nichts abgehakt.",
      "notiz.von": "{{name}}, Bericht {{nummer}}",
      "notiz.zumBericht": "Zum Bericht",
      "notiz.erledigt": "Erledigt",
      "notiz.wiederOeffnen": "Wieder öffnen",
      "notiz.abgehakt": "Abgehakt von {{name}} am {{datum}}.",
      "plan.ablage": "Offene Leistungen",
      "plan.ablageHinweis": "Auf eine Spalte ziehen. Die Wahl 1 oder 2 gilt für alle Zeilen derselben Abteilung.",
      "plan.ablageLeer": "Diese Woche ist alles verplant.",
      "plan.ablageZeile": "{{offen}} offen, {{dauer}} vor Ort",
      "plan.ablageEiner": "Einer fährt hin",
      "plan.ablageZwei": "Zwei fahren hin",
      "plan.ablageKeinBeifahrer": "Für {{name}} ist kein Beifahrer hinterlegt. Zu zweit geht nur, wo jemand mitfährt.",
      "plan.ablageErgaenzt": "Bereich beim bestehenden Termin ergänzt: {{objekt}}.",
      "plan.ansichtVorschlag": "Vorschlag",
      "plan.vorschlagHinweis": "Ein Entwurf, sortiert nach Nähe. Übernommen wird nur, was Sie übernehmen.",
      "plan.vorschlagAlle_one": "{{count}} Termin übernehmen",
      "plan.vorschlagAlle_other": "{{count}} Termine übernehmen",
      "plan.vorschlagLeer": "Für diese Woche gibt es nichts vorzuschlagen.",
      "plan.vorschlagUebernehmen": "Übernehmen",
      "plan.vorschlagVerwerfen": "Verwerfen",
      "plan.vorschlagOffen": "Bleibt offen",
      "plan.grundKeineFachkraft": "Niemand ist für diese Abteilung eingetragen",
      "plan.grundKeinPlatz": "Kein freier Platz in dieser Woche",
      "plan.grundFesttermin": "Fester Termin passt nicht: Tag oder Uhrzeit sind belegt",
      "plan.grundNurMitfahrt": "Zu kurz für eine eigene Anfahrt, kein Besuch zum Anhängen",
      "plan.tagAusrichten": "Tag ausrichten",
      "plan.routeOptimieren": "Route optimieren",
      "plan.ausrichtenKurz": "Ausrichten",
      "plan.routeKurz": "Route",
      "plan.vorschlagNurFuer": "Entwurf nur für {{name}}. Wer mitfährt, ist dabei.",
      "plan.routeKuerzer_one": "{{count}} Minute Fahrt weniger",
      "plan.routeKuerzer_other": "{{count}} Minuten Fahrt weniger",
      "plan.routeSchonKurz": "Die Reihenfolge war schon die kürzeste",
      "plan.routeFest_one": "{{count}} Termin blieb stehen",
      "plan.routeFest_other": "{{count}} Termine blieben stehen",
      "plan.ausgerichtet_one": "{{count}} Termin verschoben",
      "plan.ausgerichtet_other": "{{count}} Termine verschoben",
      "plan.pauseGesetzt": "Pause {{von}} bis {{bis}}",
      "plan.pauseImTermin": "Ein Termin ist zu lang für eine Pause dazwischen. Sie liegt im Termin, die Arbeitszeit wird dafür angehalten.",
      "plan.ueberzug_one": "{{count}} Minute über den Feierabend hinaus",
      "plan.ueberzug_other": "{{count}} Minuten über den Feierabend hinaus",
      "plan.pause": "Pause",
      "plan.pauseHinweis": "Geplant, nicht gestempelt",
      "tag.pausePlan": "So ist es geplant. Gestempelt wird die Pause oben mit dem Pausenknopf.",
      "plan.bereiche": "Bereiche an diesem Besuch",
      "plan.bereicheHinweis": "Mehrere möglich. Pool und Hauskontrolle an einer Fahrt sind ein Termin.",
      "plan.minuten": "Minuten",
      "plan.bereicheSumme": "{{summe}} von {{dauer}} Minuten verteilt",
      "plan.bereichMinuten_one": "{{count}} Min",
      "plan.bereichMinuten_other": "{{count}} Min",
      "plan.wieGewohnt": "wie gewohnt {{tag}}",
      "plan.abweichendVomGewohnten": "abweichend, sonst {{tag}}",
      "plan.grundOhneKoordinate": "Objekt ohne Koordinate, Fahrzeit unbekannt",
      "plan.anfahrtMinuten_one": "{{count}} Minute Anfahrt",
      "plan.anfahrtMinuten_other": "{{count}} Minuten Anfahrt",
      "plan.fahrtKurz": "{{minuten}} min",
      "plan.fahrtLang": "Fahrt etwa {{km}} km, {{minuten}} min",
      "plan.fahrtTitel": "Geschätzte Fahrt: {{km}} km, {{minuten}} Minuten",
      "plan.fahrtZuKnapp_one": "nur {{count}} Minute Luft",
      "plan.fahrtZuKnapp_other": "nur {{count}} Minuten Luft",
      "auswertung.nachMitarbeiter": "Nach Mitarbeiter",
      "auswertung.nachKunden": "Nach Kunden",
      "auswertung.kunde": "Kunde",
      "auswertung.soll": "Vereinbart",
      "auswertung.ist": "Geleistet",
      "auswertung.differenz": "Abweichung",
      "auswertung.einsaetze": "Einsätze",
      "auswertung.summe": "Summe",
      "auswertung.leer": "Für diesen Monat gibt es weder Sollstunden noch Einsätze.",
      "auswertung.ohneSoll": "Stunden ohne hinterlegte Vereinbarung",
      "auswertung.keineEinsaetze": "In diesem Monat war niemand vor Ort.",
      "auswertung.ungeplant": "ohne Termin",
      "auswertung.kosten": "Kosten",
      "auswertung.material": "Material",
      "auswertung.fremd": "Fremdleistung",
      "auswertung.belege": "Material und Fremdkosten",
      "auswertung.export": "Als Excel",
      "auswertung.exportHinweis": "Abrechnung, Einsätze und Belege in einer Mappe für die Buchhaltung.",
      "schnittstelle.titel": "Schnittstelle",
      "schnittstelle.hinweis": "Ein Schlüssel gibt einem anderen Programm lesenden Zugriff auf Kunden, Objekte, Einsätze, Kosten und die Abrechnungsgrundlage. Geschrieben wird über die Schnittstelle nichts.",
      "schnittstelle.name": "Wofür ist der Schlüssel?",
      "schnittstelle.nameHinweis": "Zum Beispiel Gestoría oder Rechnungsprogramm. Ein Schlüssel je Abnehmer, dann lässt sich einer widerrufen, ohne die anderen abzuschalten.",
      "schnittstelle.anlegen": "Schlüssel anlegen",
      "schnittstelle.einmalig": "Diesen Schlüssel jetzt kopieren. Er wird nie wieder angezeigt.",
      "schnittstelle.verstanden": "Kopiert",
      "schnittstelle.leer": "Noch kein Schlüssel angelegt.",
      "schnittstelle.angelegt": "Angelegt",
      "schnittstelle.benutzt": "Zuletzt benutzt",
      "schnittstelle.nieBenutzt": "Noch nie benutzt",
      "schnittstelle.widerrufen": "Widerrufen",
      "schnittstelle.widerrufenAm": "Widerrufen am",
      "demo.titel": "Jornado ansehen",
      "demo.einstiegHinweis": "Eine vollständig eingerichtete Anlage mit erfundenen Daten. Ohne Anmeldung, nichts wird verschickt.",
      "demo.code": "Zugangscode",
      "demo.alsBuero": "Als Büro öffnen",
      "demo.alsMitarbeiter": "Als Mitarbeiter öffnen",
      "demo.fehler": "Die Demo lässt sich gerade nicht öffnen.",
      "demo.marke": "Vorführung",
      "demo.balken": "Alle Daten hier sind erfunden. Bereiche, Prüfpunkte, Abteilungen, Logo und Farben werden für jeden Betrieb eigens eingerichtet: was Sie sehen, ist ein Beispiel und keine Vorgabe.",
      "demo.zuruecksetzen": "Demo zurücksetzen",
      "demo.setztZurueck": "Wird zurückgesetzt …",
      "nav.kosten": "Kosten",
      "kosten.titel": "Material und Fremdkosten",
      "kosten.hinweis": "Was an einem Objekt verbraucht oder eingekauft wurde. Beleg fotografieren genügt.",
      "kosten.neuerEintrag": "Neuer Eintrag",
      "kosten.objekt": "Objekt",
      "kosten.alleObjekte": "Alle Objekte",
      "kosten.summe": "Summe",
      "kosten.material": "Material",
      "kosten.fremd": "Fremdleistung",
      "kosten.leer": "In diesem Monat wurde nichts erfasst.",
      "kosten.nichtWeiter": "nicht weiterberechenbar",
      "kosten.belegZeigen": "Beleg ansehen",
      "kosten.wirklichWeg": "Diesen Eintrag löschen?",
      "kosten.datum": "Datum",
      "kosten.datumHinweis": "Wann gekauft oder geleistet. Vorbelegt mit heute, kann zurückdatiert werden.",
      "kosten.bezeichnung": "Was",
      "kosten.bezeichnungHinweis": "Kurz und wiedererkennbar, zum Beispiel Poolsalz oder Elektriker Notdienst.",
      "kosten.betrag": "Betrag",
      "kosten.betragHinweis": "In Euro, so wie er auf dem Beleg steht.",
      "kosten.abteilung": "Abteilung",
      "kosten.abteilungHinweis": "Damit die Kosten in der Auswertung neben den richtigen Stunden stehen.",
      "kosten.ohneAbteilung": "Keine",
      "kosten.menge": "Menge",
      "kosten.einheit": "Einheit",
      "kosten.einheitHinweis": "Stück, kg, Liter, Stunden. Freiwillig.",
      "kosten.lieferant": "Lieferant",
      "kosten.notiz": "Notiz",
      "kosten.beleg": "Beleg",
      "kosten.belegHinweis": "Ein Foto vom Kassenbon oder der Rechnung. Ohne geht es auch.",
      "kosten.weiterberechenbar": "Wird dem Eigentümer weiterberechnet",
      "zeit.einsaetze": "Einsätze",
      "zeit.abstand": "{{meter}} m vom Objekt",
      "zeit.zuWeit": "{{meter}} m vom Objekt entfernt",
      "zeit.ohnePosition": "ohne Position",
      "zeit.ohneKoordinate": "Objekt ohne Koordinate",
      "zeit.arbeitstag": "Arbeitstag",
      "zeit.einsatz": "Einsatz",
      "zeit.ungeplant": "ungeplant",
      "zeit.titel": "Arbeitszeit",
      "zeit.hinweis": "Das Register nach Art. 34.9 ET, vier Jahre aufzubewahren. Gestempelt wird auf Mein Tag.",
      "zeit.nichtGestempelt": "Du bist nicht eingestempelt.",
      "zeit.kommen": "Kommen",
      "zeit.gehen": "Gehen",
      "zeit.pause": "Pause",
      "zeit.pauseFaellig_one": "Seit {{count}} Stunde ohne Pause. Zeit für die Pause.",
      "zeit.pauseFaellig_other": "Seit {{count}} Stunden ohne Pause. Zeit für die Pause.",
      "zeit.pauseEnde": "Pause beenden",
      "zeit.inPause": "in Pause",
      "zeit.seit": "seit {{zeit}}",
      "zeit.heuteBisher": "Heute bisher {{dauer}}",
      "zeit.objektOptional": "Objekt",
      "zeit.ohneObjekt": "ohne Objekt",
      "zeit.wechselAuf": "Objekt wechseln auf",
      "zeit.wechseln": "Wechseln",
      "zeit.vergessenTitel": "Da steht noch eine Schicht offen",
      "zeit.vergessenText": "Begonnen am {{beginn}}, aber nie beendet. Trage den echten Feierabend nach, es wird nichts geraten.",
      "zeit.echtesEnde": "Feierabend war",
      "zeit.grund": "Grund",
      "zeit.grundPflicht": "Pflicht. Steht später im Register.",
      "zeit.nachtragen": "Nachtragen",
      "zugang.titel": "Zugang",
      "zugang.hinweis": "Schlüssel, Tor, Alarm. Jeder Abruf wird protokolliert.",
      "zugang.neu": "Eintrag anlegen",
      "zugang.leer": "Für dieses Objekt ist nichts hinterlegt.",
      "zugang.anzeigen": "Anzeigen",
      "zugang.verbergen": "Verbergen",
      "zugang.verstecktGleich": "Wird nach anderthalb Minuten wieder ausgeblendet.",
      "zugang.artLabel": "Art",
      "zugang.bezeichnung": "Bezeichnung",
      "zugang.bezeichnungHinweis": "Wofür, zum Beispiel Tor Einfahrt Nord",
      "zugang.wert": "Nummer oder Code",
      "zugang.wertUnveraendert": "Leer lassen, dann bleibt der bisherige Code stehen",
      "zugang.art.key": "Schlüssel",
      "zugang.art.alarm": "Alarm",
      "zugang.art.gate": "Tor",
      "zugang.art.wifi": "WLAN",
      "zugang.art.safe": "Tresor",
      "zugang.art.other": "Sonstiges",
      "zeit.auszug": "Auszug für die Gestoría",
      "zeit.register": "Register drucken",
      "zeit.monat": "Monat",
      "zeit.orte.titel": "Wo gestempelt wurde",
      "zeit.orte.hinweis": "Gezählt wird das Einstempeln am Einsatz. Grün heißt innerhalb von {{meter}} Metern um das Objekt, Rot weiter weg, Grau ohne Position vom Telefon.",
      "zeit.orte.amObjekt": "Am Objekt",
      "zeit.orte.zuWeit": "Zu weit weg",
      "zeit.orte.ohnePosition": "Ohne Position",
      "zeit.mitarbeiter": "Mitarbeiter",
      "zeit.alle": "alle",
      "zeit.summe": "Summe",
      "zeit.leer": "In diesem Monat wurde nichts erfasst.",
      "zeit.beginn": "Beginn",
      "zeit.ende": "Ende",
      "zeit.korrigieren": "Korrigieren",
      "zeit.korrekturHinweis": "Der ursprüngliche Wert bleibt erhalten und wird an der Zeile angezeigt.",
      "zeit.korrigiertAm": "Korrigiert am {{am}} von {{von}}",
      "zeit.vorher": "vorher",
      "zeit.manuell": "nachgetragen",
      "zeit.pausenSumme": "davon {{dauer}} Pause",
      "zeit.stornieren": "Stornieren",
      "zeit.storniert": "storniert",
      "zeit.storniertAm": "Storniert am {{am}} von {{von}}",
      "zeit.stornoHinweis": "Die Zeile bleibt im Register stehen und wird durchgestrichen. Sie zählt nicht mehr mit. Rückgängig geht das nicht, eine falsche Stornierung wird durch einen Nachtrag geheilt.",
      "system.sicherung": "Nächtliche Sicherung",
      "system.sicherungSchutz": "Schutz der Sicherung",
      "system.verschluesselt": "verschlüsselt",
      "system.unverschluesselt": "unverschlüsselt, Passwort fehlt",
      "system.sicherungStand": "zuletzt {{zeit}} · {{groesse}}",
      "system.sicherung.keine": "Es liegt keine Sicherung im Speicher.",
      "system.sicherung.unbekannt": "Nicht abrufbar, Speicher antwortet nicht.",
      "system.speicher": "Dateispeicher",
      "system.standortdaten": "Standortdaten",
      "system.standortStand": "{{anzahl}} Punkte, Löschung nach {{tage}} Tagen",
      "system.standortUeberfaellig": "Punkte älter als {{tage}} Tage sind noch da. Die Löschung läuft nicht.",
      "team.auskunft": "Auskunft herunterladen",
      "team.auskunftHinweis": "Alle gespeicherten Daten dieser Person als Datei, nach Art. 15 DSGVO.",
      "system.post": "Postversand",
      "system.eingerichtet": "eingerichtet",
      "system.fehlt": "nicht eingerichtet",
      "nav.uebernahme": "Übernahme",
      "uebernahme.titel": "Übernahme aus der Altanwendung",
      "uebernahme.hinweis": "Kunden und Objekte einlesen. Erst ein Probelauf, danach entscheidest du.",
      "uebernahme.dateiWaehlen": "Datei aus der Altanwendung wählen",
      "uebernahme.gelesen": "{{datei}} · {{count}} Datensätze gelesen",
      "uebernahme.falscheDatei": "Diese Datei enthält keine Kundendaten der Altanwendung.",
      "uebernahme.probe": "Probelauf",
      "uebernahme.probeErgebnis": "Probelauf, es wurde nichts geschrieben",
      "uebernahme.uebernehmen": "Jetzt übernehmen",
      "uebernahme.fertig": "Übernommen",
      "uebernahme.zusammenfassung": "{{gelesen}} gelesen, {{neu}} neu, {{aktualisiert}} aktualisiert, {{uebersprungen}} übersprungen",
      "uebernahme.spalteKunde": "Kunde",
      "uebernahme.spalteObjekt": "Objekt",
      "uebernahme.spalteZustand": "Zustand",
      "uebernahme.spalteHinweise": "Hinweise",
      "uebernahme.zustand.neu": "Neu",
      "uebernahme.zustand.aktualisiert": "Aktualisiert",
      "uebernahme.zustand.uebersprungen": "Übersprungen",
      "nav.einstellungen": "Einstellungen",
      "einstellungen.titel": "Einstellungen",
      "einstellungen.hinweis": "Diese Angaben stehen in Berichten und Mails an den Eigentümer.",
      "einstellungen.firma": "Firma",
      "einstellungen.telefon": "Telefon",
      "einstellungen.email": "E-Mail",
      "einstellungen.emailHinweis": "Diese Adresse steht im Impressum und bekommt die Hinweise aus dem Hinweisgeberkanal, solange dafür keine eigene hinterlegt ist.",
      "einstellungen.rechtTitel": "Pflichtangaben für Impressum und Datenschutz",
      "einstellungen.rechtWarnung": "Diese Angaben stehen im Impressum und in der Datenschutzerklärung. Was hier leer bleibt, fehlt dort, und Art. 10 LSSI verlangt sie vollständig.",
      "einstellungen.firmierung": "Vollständige Firmierung",
      "einstellungen.firmierungHinweis": "Wie im Handelsregister eingetragen, mit Rechtsform. Leer heißt: es gilt der Firmenname von oben.",
      "einstellungen.nif": "NIF",
      "einstellungen.anschrift": "Anschrift des Sitzes",
      "einstellungen.anschriftHinweis": "Mehrzeilig erlaubt, so wie sie auf einem Brief steht.",
      "einstellungen.register": "Eintrag im Registro Mercantil",
      "einstellungen.registerHinweis": "Register, Tomo, Folio, Hoja. Steht in der Gründungsurkunde.",
      "einstellungen.datenschutzEmail": "Adresse für Datenschutzanfragen",
      "einstellungen.datenschutzEmailHinweis": "An diese Adresse richten sich Auskunfts- und Löschverlangen. Leer heißt: es gilt die E-Mail von oben.",
      "betrieb.urlaubEinheit": "Urlaub zählen in",
      "betrieb.urlaubEinheitHinweis": "Kalendertage sind der gesetzliche Mindestanspruch von 30 Tagen. Arbeitstage entsprechen üblicherweise 22.",
      "betrieb.planTitel": "Planung und Fahrzeit",
      "betrieb.planHinweis": "Der Rahmen, in dem der Wochenvorschlag plant, und die Annahmen hinter der geschätzten Fahrzeit.",
      "betrieb.planBeginn": "Arbeitsbeginn",
      "betrieb.planEnde": "Feierabend",
      "betrieb.planTeamAb": "Team ab (Minuten)",
      "betrieb.planTeamAbHinweis": "Ab dieser Größe schlägt der Plan zwei Personen vor: eine Fahrt statt zweier.",
      "betrieb.fahrtTempo": "Durchschnittstempo (km/h)",
      "betrieb.planPauseNach": "Pause fällig nach (Minuten)",
      "betrieb.planPauseNachHinweis": "Nach so vielen gearbeiteten Minuten setzt der Plan die Pause. Sie liegt zwischen zwei Terminen; passt keiner, fällt sie in den laufenden Termin und die Arbeitszeit wird dafür angehalten.",
      "betrieb.planPause": "Pausenlänge (Minuten)",
      "betrieb.planPauseHinweis": "Hausregel, kein Gesetz. Art. 34.4 ET verlangt die Ruhezeit erst ab mehr als sechs Stunden am Stück und dann fünfzehn Minuten. Weniger als fünfzehn ist deshalb nicht einstellbar.",
      "betrieb.fahrtTempoHinweis": "Grundlage der Schätzung. Ob 45 auf dieser Insel stimmen, zeigt sich nach einem Sommer.",
      "betrieb.fahrtUmweg": "Umwegfaktor",
      "betrieb.fahrtUmwegHinweis": "Luftlinie mal diesem Faktor ergibt die angenommene Fahrstrecke.",
      "betrieb.startOrt": "Startpunkt der Route",
      "betrieb.streckenKeine": "Fahrzeiten werden geschätzt: Luftlinie mal Umwegfaktor. Gemessene Strecken liegen noch keine vor.",
      "betrieb.eichung": "Nach {{paare}} gemessenen Strecken von zwei bis dreißig Kilometern, also der Länge, die zwischen zwei Terminen eines Tages liegt, wären es {{tempo}} km/h und Faktor {{umweg}}.",
      "betrieb.eichungUebernehmen": "Übernehmen",
      "betrieb.streckenStand": "{{anzahl}} von {{moeglich}} Strecken echt gemessen, zuletzt am {{datum}}. Wo keine Messung vorliegt, wird geschätzt.",
      "betrieb.startOrtHinweis": "Der Ort, an dem der Arbeitstag beginnt und endet, etwa Sineu. Er zählt nicht als Arbeitszeit; der Weg zum ersten Kunden ist Freizeit. Gebraucht wird er nur für die Richtung: bei gleich langer Strecke fängt der Tag beim näheren Kunden an. Die Koordinate wird beim Speichern gesucht.",
      "urlaub.titel": "Urlaubskonto {{jahr}}",
      "urlaub.einheit.natural": "in Kalendertagen",
      "urlaub.einheit.laboral": "in Arbeitstagen",
      "urlaub.anspruch": "Anspruch",
      "urlaub.anspruchHinweis": "Tage in diesem Jahr",
      "urlaub.anspruchTitel": "Urlaubsanspruch",
      "urlaub.anspruchSpeichern": "Anspruch speichern",
      "urlaub.uebertrag": "Übertrag",
      "urlaub.uebertragHinweis": "Aus dem Vorjahr übernommene Tage",
      "urlaub.genommen": "Genommen",
      "urlaub.beantragt": "Beantragt",
      "urlaub.verbleibend": "Verbleibend",
      "urlaub.standChef": "{{genommen}} genommen, {{rest}} verbleibend.",
      "urlaub.ohneAnspruch": "Für dieses Jahr ist kein Anspruch hinterlegt. Das Büro trägt ihn ein.",
      "urlaub.ohneAnspruchChef": "Für dieses Jahr ist kein Anspruch hinterlegt. Im Team je Mitarbeiter eintragen.",
      "betrieb.titel": "Betrieb",
      "betrieb.hinweis": "Wie die Anlage arbeitet. Nur für die Geschäftsleitung sichtbar.",
      "betrieb.ortung": "Dauerhafte Ortung während der Arbeitszeit",
      "betrieb.ortungWarnung": "Art. 90 LOPDGDD erlaubt Ortung am Arbeitsplatz nur, wenn die Beschäftigten vorher ausdrücklich und eindeutig informiert wurden. Deshalb verlangt das Einschalten das Datum, an dem die unterschriebene Information vorlag. Die Umstellung wird protokolliert.",
      "betrieb.ortungTage": "Standortdaten löschen nach",
      "betrieb.ortungTageHinweis": "Tagen. Danach bleibt nur der Abstand in Metern an der Buchung.",
      "betrieb.ortungInfoAm": "Unterschriebene Mitarbeiterinformation liegt vor seit",
      "betrieb.ortungInfoAmHinweis": "Ohne dieses Datum lässt sich die Ortung nicht einschalten. Die unterschriebenen Blätter bleiben im Personalordner, hier steht nur der Tag.",
      "betrieb.maxAbstand": "Auffälliger Abstand ab",
      "betrieb.maxAbstandHinweis": "Metern. Weiter entfernt gestempelt erscheint im Register rot.",
      "betrieb.kiAn": "Textvorschläge von Claude",
      "betrieb.verbrauch": "Verbraucht in diesem Monat",
      "betrieb.verbrauchStand": "{{verbraucht}} von {{grenze}}",
      "betrieb.kiLimit": "Monatsbudget",
      "betrieb.kiLimitHinweis": "Euro im Monat. Ist es aufgebraucht, entstehen keine Vorschläge mehr.",
      "betrieb.kiVorschlaege": "Vorschläge je Report",
      "betrieb.kiVorschlaegeHinweis": "Wie oft Claude für denselben Report gefragt werden darf.",
      "betrieb.bueroKopie": "Blindkopie ins Büro",
      "betrieb.bueroKopieHinweis": "Adresse, die jede Kundenmail als Kopie erhält. Leer heißt: keine Kopie.",
      "einstellungen.gespeichert": "Gespeichert.",
      "nav.baukasten": "Baukasten",
      "baukasten.titel": "Prüfpunkte",
      "baukasten.hinweis": "Hier baust du deinen Bericht: erst ein Bereich als große Überschrift, darunter die Prüfpunkte. Eine Änderung erreicht sofort alle Objekte, abweichen kannst du am einzelnen Objekt.",
      "baukasten.gruppe": "Zwischenüberschrift",
      "baukasten.gruppeHinweis": "Freiwillig. Gleiche Überschrift bei aufeinanderfolgenden Punkten ergibt einen Abschnitt in der App und im Bericht.",
      "baukasten.gruppeBeispiel": "Außen",
      "baukasten.hilfetext": "Hilfetext für Mitarbeiter",
      "baukasten.hilfetextHinweis": "Freiwillig. Steht in der App unter dem Prüfpunkt, für alle Objekte gleich.",
      "baukasten.hoch": "Nach oben",
      "baukasten.runter": "Nach unten",
      "checkliste.bereiche": "Bereiche an diesem Objekt",
      "checkliste.bereicheHinweis": "Nur was hier angehakt ist, wird geprüft. Was es an diesem Objekt nicht gibt, nimmst du heraus.",
      "checkliste.mindestensEinBereich": "Mindestens ein Bereich muss bleiben.",
      "checkliste.ohneBezeichnung": "Objektkontrolle",
      "checkliste.punktErgaenzen": "Einzelnen Prüfpunkt ergänzen",
      "checkliste.punktErgaenzenHinweis": "Für den Einzelfall, etwa ein Bootssteg. Ein ganzer Bereich lohnt dafür nicht.",
      "checkliste.fotoStandard": "Wie im Standard",
      "baukasten.punkte": "Prüfpunkte",
      "baukasten.punktNeu": "Neuer Prüfpunkt",
      "baukasten.punkteAnzahl_one": "{{count}} Prüfpunkt",
      "baukasten.punkteAnzahl_other": "{{count}} Prüfpunkte",
      "baukasten.keinePunkte": "Noch keine Prüfpunkte.",
      "baukasten.bereichNeu": "Neuer Bereich",
      "baukasten.bereichUmbenennen": "Umbenennen",
      "baukasten.bereichName": "Name des Bereichs",
      "baukasten.bereichNameHinweis": "Die große Überschrift im Bericht, etwa Immobilie, Küche, Fuhrpark. Nur Deutsch eintragen, den Rest übersetzt Claude.",
      "baukasten.bereichBeispiel": "Immobilie",
      "baukasten.keineBereiche": "Noch kein Bereich angelegt. Ein Bereich ist eine große Überschrift im Bericht, darunter kommen die Prüfpunkte.",
      "vorlage.titel": "Berichtsvorlagen",
      "vorlage.hinweis": "Für Aufträge ohne wiederkehrenden Rundgang. Der Mitarbeiter wählt die Vorlage am Termin, das Objekt kommt vom Termin. Kein Eintrag am Objekt nötig.",
      "vorlage.neu": "Neue Vorlage",
      "vorlage.keine": "Noch keine Vorlage. Wer nur wiederkehrende Rundgänge fährt, braucht auch keine.",
      "vorlage.bereiche": "Bereiche in diesem Bericht",
      "vorlage.bezeichnung": "Bezeichnung",
      "vorlage.bezeichnungHinweis": "Der Mitarbeiter sieht am Termin nur diesen Namen. Er muss daran erkennen, welchen Bericht er beginnt.",
      "vorlage.beispiel": "Fenstermontage",
      "vorlage.ohneBereich": "kein Bereich gewählt",
      "unterschrift.titel": "Abnahme durch den Kunden",
      "unterschrift.hinweis": "Freiwillig. Bei einer Montage bestätigt der Kunde damit, dass die Arbeit gemacht ist. Sie steht im PDF unter dem Bericht.",
      "unterschrift.keine": "Noch nicht unterschrieben.",
      "unterschrift.leisten": "Unterschreiben lassen",
      "unterschrift.erneut": "Neu unterschreiben",
      "unterschrift.name": "Name in Druckbuchstaben",
      "unterschrift.nameHinweis": "Eine Unterschrift auf dem Display ist oft nicht zu lesen. Ohne Namen weiß später niemand, wer unterschrieben hat.",
      "unterschrift.nameFehlt": "Bitte den Namen in Druckbuchstaben eintragen.",
      "unterschrift.leer": "Bitte im Feld unterschreiben.",
      "unterschrift.leeren": "Nochmal",
      "baukasten.vorlagenTitel": "Mit einer Beispielliste anfangen",
      "baukasten.vorlagenHinweis": "Spart die erste Stunde. Alles Geladene gehört danach dir: umbenennen, ergänzen, löschen. Das Angebot verschwindet, sobald der erste Prüfpunkt steht.",
      "baukasten.vorlagenUmfang": "{{bereiche}} Bereiche, {{punkte}} Prüfpunkte",
      "baukasten.vorlageLaden": "Laden",
      "checkliste.keineBereiche": "Es gibt noch keine Bereiche. Erst im Baukasten anlegen, dann hier anhaken.",
      "team.keineBereiche": "Noch keine Bereiche im Baukasten.",
      "baukasten.stilllegen": "Stilllegen",
      "baukasten.wiederAktiv": "Wieder aktiv",
      "baukasten.stillgelegt": "Stillgelegt",
      "baukasten.schluessel": "Schlüssel",
      "baukasten.schluesselHinweis": "Technischer Name, später nicht mehr änderbar. Kleinbuchstaben und Unterstrich.",
      "baukasten.punktSchluesselHinweis": "Technischer Name, später nicht mehr änderbar. Bereich und Punkt, etwa pool.abdeckung.",
      "baukasten.beschriftung": "Beschriftung",
      "baukasten.eingabeart": "Eingabeart",
      "baukasten.eingabeartHinweis": "Bestimmt, was der Mitarbeiter am Objekt anhaken oder eintragen kann.",
      "baukasten.art.status": "Kontrolle: erledigt, in Ordnung, Mangel, nicht kontrolliert",
      "baukasten.art.number": "Zahl",
      "baukasten.art.boolean": "Abhaken: erledigt oder nicht",
      "baukasten.art.text": "Freitext",
      "baukasten.art.photo": "Nur Foto",
      "baukasten.einheit": "Einheit",
      "baukasten.zielVon": "Zielwert von",
      "baukasten.zielBis": "Zielwert bis",
      "baukasten.zielHinweis": "Liegt der Wert daneben, verlangt die App sofort einen Kommentar.",
      "baukasten.fotoPflicht": "Foto Pflicht",
      "baukasten.fotoPflichtLang": "Zu diesem Punkt muss der Mitarbeiter ein Foto hochladen, außer er wählt Entfällt",
      "baukasten.uebersetztHinweis": "Nur Deutsch eintragen. Englisch, Spanisch und Arabisch übersetzt Claude beim Speichern.",
      "checkliste.titel": "Checklisten",
      "checkliste.keine": "Für dieses Objekt ist noch keine Checkliste hinterlegt.",
      "checkliste.hinzufuegen": "Checkliste hinzufügen",
      "checkliste.bezeichnung": "Bezeichnung",
      "checkliste.bezeichnungHinweis": "Freiwillig, zum Beispiel Wöchentlich.",
      "checkliste.zurueckZumObjekt": "Zum Objekt",
      "checkliste.vorschau": "Das sieht der Mitarbeiter",
      "checkliste.vorschauHinweis": "Aus den Bereichen plus den Abweichungen dieses Objekts.",
      "checkliste.leer": "Hier bleibt kein einziger Prüfpunkt übrig.",
      "checkliste.ergaenzt": "ergänzt",
      "checkliste.angepasst": "angepasst",
      "checkliste.anpassen": "Anpassen",
      "checkliste.abwaehlen": "Abwählen",
      "checkliste.abgewaehltePunkte": "Hier abgewählte Prüfpunkte",
      "checkliste.wiederAufnehmen": "wieder aufnehmen",
      "checkliste.fotoPflicht": "Foto Pflicht",
      "checkliste.fotoFrei": "Kein Foto nötig",
      "checkliste.fotoHinweis": "Wie im Standard heißt: ändert sich der Standard, ändert sich dieses Objekt mit.",
      "checkliste.objekthinweis": "Objekthinweis",
      "checkliste.objekthinweisHinweis": "Steht beim Prüfpunkt und ersetzt die Einarbeitung am Objekt.",
      "checkliste.objekthinweisBeispiel": "Filteranlage im Technikraum hinter dem Poolhaus, Schlüssel Nummer 4",
      "checkliste.anpassungZuruecknehmen": "Anpassung zurücknehmen",
      "aktion.speichern": "Speichern",
      "aktion.speichert": "Speichert",
      "aktion.abbrechen": "Abbrechen",
      "aktion.bearbeiten": "Bearbeiten",
      "aktion.loeschen": "Löschen",
      "aktion.ja": "Ja",
      "aktion.nein": "Nein",
      "archiv.zeigen": "Archivierte anzeigen",
      "archiv.marke": "Archiviert",
      "archiv.archivieren": "Archivieren",
      "archiv.zurueckholen": "Zurückholen",
      "archiv.kundeMitObjekten_one": "Zu diesem Kunden gehört noch {{count}} aktives Objekt. Es wird mit archiviert. Fortfahren?",
      "archiv.kundeMitObjekten_other": "Zu diesem Kunden gehören noch {{count}} aktive Objekte. Sie werden mit archiviert. Fortfahren?",
      "fehler.laden": "Daten konnten nicht geladen werden",
      "hinweis.hinweis": "Geht als E-Mail an die Geschäftsleitung und wird nirgends gespeichert.",
      "hinweis.platzhalter": "Was sollte der Chef wissen?",
      "hinweis.diktieren": "Zum Diktieren die Mikrofontaste der Tastatur benutzen.",
      "hinweis.senden": "Hinweis senden",
      "hinweis.gesendet": "Der Hinweis ist raus. Danke.",
      "hinweis.nochEiner": "Noch einen Hinweis schreiben",
      "fehler.speichern": "Speichern nicht möglich",
      "fehler.seite": "Diese Seite gibt es nicht.",
      "kunden.titel": "Kunden",
      "kunden.neu": "Neuer Kunde",
      "kunden.bearbeiten": "Kunde bearbeiten",
      "kunden.suche": "Suchen nach Name, E-Mail oder Telefon",
      "kunden.leer": "Noch keine Kunden angelegt.",
      "kunden.ausgewaehlt_one": "{{count}} Kunde ausgewählt",
      "kunden.ausgewaehlt_other": "{{count}} Kunden ausgewählt",
      "kunden.auswahlAufheben": "Auswahl aufheben",
      "kunden.sammelArchivFrage_one": "{{count}} Kunde und {{objekte}} zugehörige Objekte archivieren? Die Objekte gehen mit.",
      "kunden.sammelArchivFrage_other": "{{count}} Kunden und {{objekte}} zugehörige Objekte archivieren? Die Objekte gehen mit.",
      "kunden.sammelZurueckFrage_one": "{{count}} Kunde zurückholen?",
      "kunden.sammelZurueckFrage_other": "{{count}} Kunden zurückholen?",
      "kunden.anzahl_one": "{{count}} Kunde",
      "kunden.anzahl_other": "{{count}} Kunden",
      "kunden.objekte_one": "{{count}} Objekt",
      "kunden.objekte_other": "{{count}} Objekte",
      "kunden.kontakt": "Kontakt",
      "kunden.rechnungsadresse": "Rechnungsadresse",
      "kunden.notizen": "Notizen",
      "kunden.art": "Art",
      "kunden.art.private": "Privat",
      "kunden.art.company": "Firma",
      "kunden.name": "Name",
      "kunden.nameHinweis": "So erscheint der Kunde in Listen und Reports.",
      "kunden.firma": "Firmenname",
      "kunden.steuernummer": "NIF oder USt-IdNr",
      "kunden.anrede": "Anrede",
      "kunden.briefanrede": "Anrede im Brief",
      "kunden.briefanredeHinweis": "So beginnt der Text im Report. Bleibt es neutral, wird niemand falsch angesprochen.",
      "kunden.anredeHelferStarten_one": "Bei {{count}} Kunden die Anrede ergänzen",
      "kunden.anredeHelferStarten_other": "Bei {{count}} Kunden die Anrede ergänzen",
      "kunden.anredeHelferStand": "{{fertig}} von {{gesamt}} übernommen",
      "kunden.anredeHelferBeenden": "Fertig",
      "kunden.anredeHelferHinweis": "Vorgeschlagen ist das letzte Wort des Anzeigenamens. Die Anrede wird nicht geraten, die wählst du. Bleibt sie neutral, steht im Kalender der bloße Name.",
      "kunden.anredeUebernommen": "übernommen",
      "kunden.anredeKeinVorschlag": "Kein Vorschlag, bitte selbst eintragen.",
      "kunden.anredename": "Name für die Anrede",
      "kunden.anredenameHinweis": "Bei Sie der Nachname, bei du der Vorname. Steht auch als Überschrift des Termins im Kalender.",
      "kunden.anredeNeutral": "Sehr geehrte Damen und Herren,",
      "kunden.salutation.herr": "Herr",
      "kunden.salutation.frau": "Frau",
      "kunden.salutation.familie": "Familie",
      "kunden.salutation.neutral": "Neutral",
      "kunden.anrede.du": "Du",
      "kunden.anrede.sie": "Sie",
      "kunden.sprache": "Sprache",
      "kunden.spracheHinweis": "Sprache der Reports an diesen Kunden.",
      "kunden.email": "E-Mail",
      "kunden.emailHinweis": "Mehrere Adressen mit Semikolon trennen. Der Bericht geht dann an alle.",
      "kunden.telefon": "Telefon",
      "objekte.titel": "Objekte",
      "objekte.alle": "Alle Objekte",
      "objekte.neu": "Neues Objekt",
      "objekte.bearbeiten": "Objekt bearbeiten",
      "objekte.suche": "Suchen nach Objekt, Ort oder Kunde",
      "objekte.leer": "Noch keine Objekte angelegt.",
      "objekte.leerBeiKunde": "Für diesen Kunden ist noch kein Objekt angelegt.",
      "objekte.anzahl_one": "{{count}} Objekt",
      "objekte.anzahl_other": "{{count}} Objekte",
      "objekte.name": "Bezeichnung",
      "objekte.nameHinweis": "Zum Beispiel Villa Son Vida oder Finca Andratx.",
      "objekte.kunde": "Kunde",
      "objekte.kundeWaehlen": "Bitte wählen",
      "objekte.ohneKoordinate": "ohne Koordinate",
      "objekte.nurOhneKoordinate": "nur ohne Koordinate",
      "objekte.koordinateFehlt": "Für dieses Objekt ist keine Koordinate hinterlegt. Ohne sie lässt sich der Abstand beim Stempeln nicht berechnen.",
      "objekte.koordinateSuchen": "Koordinate suchen",
      "objekte.koordinateNichts": "Zu dieser Anschrift wurde auf Mallorca nichts gefunden. Bitte von Hand eintragen.",
      "objekte.nurStrasse": "Treffer ohne Hausnummer, der Punkt liegt an der Straße. Für die Abstandsprüfung reicht das.",
      "objekte.koordinateUebernehmen": "Übernehmen",
      "objekte.koordinateAnsehen": "Auf der Karte ansehen",
      "objekte.zumKunden": "Zum Kunden",
      "objekte.lage": "Lage",
      "objekte.vertrag": "Vertrag",
      "objekte.gemeinde": "Gemeinde",
      "objekte.gemeindeHinweis": "Calvia, Andratx, Pollenca und so weiter.",
      "objekte.breite": "Breitengrad",
      "objekte.laenge": "Längengrad",
      "objekte.koordinatenHinweis": "Freiwillig. Erlaubt später die Navigation zum Objekt.",
      "objekte.route": "Route starten",
      "objekte.leistung": "Leistung",
      "objekte.leistungHinweis": "Zum Beispiel Rundum Vollbetreuung.",
      "objekte.beginn": "Vertragsbeginn",
      "objekte.ende": "Vertragsende",
      "objekte.poolheizung": "Poolheizung vorhanden",
      "objekte.poolheizungHinweis": "Hält am Objekt fest, dass eine Poolheizung vereinbart ist und zu einer Belegung eingeschaltet werden kann.",
      "objekte.anfahrt": "Anfahrt und Zugang",
      "objekte.anfahrtHinweis": "Hinweise für Mitarbeiter. Keine Alarmcodes, keine Schlüsselverstecke.",
      "adresse.strasse": "Straße und Nummer",
      "adresse.plz": "Postleitzahl",
      "adresse.ort": "Ort",
      "adresse.land": "Land",
      "adresse.landHinweis": "Zwei Buchstaben, zum Beispiel ES oder DE.",
      "app.name": "Jornado",
      "recht.datenschutz": "Datenschutzerklärung",
      "recht.impressum": "Impressum",
      "recht.zurueck": "Zurück zur Anwendung",
      "recht.stand": "Stand {{datum}}",
      "login.title": "Anmeldung",
      "login.email": "E-Mail",
      "login.password": "Passwort",
      "login.zeigen": "Passwort anzeigen",
      "login.verbergen": "Passwort verbergen",
      "login.submit": "Anmelden",
      "login.pending": "Einen Moment",
      "login.failed": "E-Mail oder Passwort stimmt nicht",
      "nav.customers": "Kunden",
      "nav.password": "Passwort",
      "password.title": "Passwort ändern",
      "password.hint": "Nach dem Wechsel musst du dich neu anmelden.",
      "password.current": "Bisheriges Passwort",
      "password.new": "Neues Passwort",
      "password.rule": "Mindestens 12 Zeichen, mit Groß- und Kleinbuchstabe und Ziffer.",
      "password.save": "Ändern",
      "password.cancel": "Abbrechen",
      "password.failed": "Änderung nicht möglich",
      "nav.logout": "Abmelden",
    }
  },
  en: {
    translation: {
      "objektzahlen.titel": "Figures from the reports",
      "objektzahlen.hinweis": "Taken from the approved reports, usually one per week.",
      "objektzahlen.jeTag": "Consumption per day, so the periods can be compared",
      "objektzahlen.tag": "day",
      "objektzahlen.dieseWoche": "Last 7 days",
      "objektzahlen.dieserMonat": "This month",
      "objektzahlen.vormonat": "Month before",
      "objektzahlen.grundlast": "when empty",
      "objektzahlen.letzterWert": "Last measured",
      "objektzahlen.legendeVerbrauch": "Consumption per day in {{einheit}}",
      "objektzahlen.legendeWert": "Measured value",
      "objektzahlen.legendeUeblich": "Usual at this house: {{wert}}",
      "objektzahlen.legendeZiel": "Target range {{min}} to {{max}}",
      "objektzahlen.legendeMehr": "Considerably more than usual",
      "objektzahlen.legendeAusserhalb": "Outside the target range",
      "objektzahlen.mengeUeberTage_one": "({{menge}} {{einheit}} in {{count}} day)",
      "objektzahlen.mengeUeberTage_other": "({{menge}} {{einheit}} in {{count}} days)",
      "objektzahlen.auffaellig": "Lately {{wert}} {{einheit}} a day, where about {{basis}} is usual here. Someone was in the house during that time, which usually explains the difference.",
      "objektzahlen.leckverdacht": "Lately {{wert}} {{einheit}} a day although nobody was in the house. When it stands empty, about {{basis}} is usual here. That points to a leak.",
      "objektzahlen.tabelleAuf": "Show figures",
      "objektzahlen.tabelleZu": "Hide figures",
      "objektzahlen.ausserhalb": "out of range",
      "einrichtung.ansprache_one": "{{count}} customer without salutation and surname, the calendar then shows the display name only",
      "einrichtung.ansprache_other": "{{count}} customers without salutation and surname, the calendar then shows the display name only",
      "objekte.helferStarten_one": "Suggest coordinates for {{count}} property",
      "objekte.helferStarten_other": "Suggest coordinates for all {{count}} properties",
      "objekte.helferStand": "{{geprueft}} of {{gesamt}} checked",
      "objekte.helferBeenden": "Done",
      "objekte.helferWartet": "waiting",
      "objekte.helferUebernommen": "Coordinates saved",
      "einrichtung.titel": "Still to set up",
      "einrichtung.hinweis": "No software can do this for you. Items disappear from this list once they are done.",
      "einrichtung.hin": "go",
      "einrichtung.vertrag_one": "{{count}} employee without weekly hours or start date",
      "einrichtung.vertrag_other": "{{count}} employees without weekly hours or start date",
      "einrichtung.urlaub_one": "{{count}} employee without a holiday entitlement for this year",
      "einrichtung.urlaub_other": "{{count}} employees without a holiday entitlement for this year",
      "einrichtung.baukasten": "No checkpoint yet, without one the report at the property stays empty",
      "einrichtung.fahrzeug": "No vehicle set up, so nobody can log refuelling",
      "einrichtung.handbuch": "No handbook article written yet",
      "einrichtung.koordinate_one": "{{count}} property without coordinates",
      "einrichtung.koordinate_other": "{{count}} properties without coordinates",
      "einrichtung.zugang_one": "{{count}} property without access details",
      "einrichtung.zugang_other": "{{count}} properties without access details",
      "einrichtung.ortung": "Tracking is switched on. The signed employee notice under art. 90 LOPDGDD must be on file",
      "einrichtung.firmenangaben_one": "{{count}} mandatory company detail missing, the legal notice stays incomplete until it is filled in",
      "einrichtung.firmenangaben_other": "{{count}} mandatory company details missing, the legal notice stays incomplete until they are filled in",
      "zeit.empfangenAm": "Received by the server on {{zeit}}",
      "netz.abmeldenTrotzWartend_one": "{{count}} entry has not been sent yet. Logging out will lose it. Log out anyway?",
      "netz.abmeldenTrotzWartend_other": "{{count}} entries have not been sent yet. Logging out will lose them. Log out anyway?",
      "tag.stempel.tag.start": "Working day started",
      "tag.stempel.tag.ende": "Working day ended",
      "tag.stempel.einsatz.start": "Assignment started",
      "tag.stempel.einsatz.ende": "Assignment ended",
      "tag.stempel.pause": "Break started",
      "tag.stempel.pause.ende": "Break ended",
      "zeit.ohneNetz": "Stamped offline",
      "netz.ohneNetz": "No connection. What you enter stays on this device and is sent later.",
      "netz.wartet_one": "{{count}} entry waiting",
      "netz.wartet_other": "{{count}} entries waiting",
      "netz.sendet": "Sending",
      "netz.jetztSenden": "Send now",
      "netz.abgelehnt_one": "{{count}} entry was rejected",
      "netz.abgelehnt_other": "{{count}} entries were rejected",
      "netz.abgelehntTitel": "Rejected entries",
      "netz.nichtsAbgelehnt": "Nothing left.",
      "netz.anzeigen": "View",
      "netz.schliessen": "Close",
      "netz.nochmal": "Try again",
      "netz.verwerfen": "Discard",
      "netz.verwerfenFrage": "Discard this entry for good? It will be gone.",
      "netz.versuche_one": "{{count}} attempt",
      "netz.versuche_other": "{{count}} attempts",
      "netz.ausAblage": "No connection. Showing the state from {{zeit}}.",
      "netz.gemerkt": "Saved offline, will be sent later.",
      "app.neueFassung": "A new version is ready.",
      "app.neueFassungLaden": "Load it now",
      "nav.pruefungen": "Reports",
      "nav.notizen": "Notes",
      "pruefung.titel": "Reports",
      "pruefung.neu": "New report",
      "pruefung.neuHinweis": "Choose property and checklist. The list is frozen when you start.",
      "pruefung.starten": "Start report",
      "pruefung.status": "Status",
      "pruefung.alleStatus": "All",
      "pruefung.leer": "No reports yet.",
      "pruefung.zurFreigabe_one": "{{count}} report waiting for release",
      "pruefung.zurFreigabe_other": "{{count}} reports waiting for release",
      "pruefung.leerBeiObjekt": "No report for this property yet.",
      "pruefung.keineCheckliste": "This property has no active checklist.",
      "pruefung.anzahl_one": "{{count}} report",
      "pruefung.anzahl_other": "{{count}} reports",
      "pruefung.nummer": "Report {{nummer}}",
      "pruefung.fortschritt": "{{erledigt}} of {{gesamt}} recorded",
      "pruefung.maengel_one": "{{count}} fault",
      "pruefung.maengel_other": "{{count}} faults",
      "pruefung.status.draft": "Draft",
      "pruefung.status.submitted": "Submitted",
      "pruefung.status.changes_requested": "Sent back",
      "pruefung.status.approved": "Approved",
      "pruefung.status.sent": "Sent",
      "pruefung.status.cancelled": "Withdrawn",
      "pruefung.einreichen": "Submit",
      "pruefung.freigeben": "Approve",
      "pruefung.zurueckgeben": "Send back",
      "pruefung.zuruecknehmen": "Withdraw",
      "pruefung.loeschen": "Delete permanently",
      "pruefung.loeschenFrage": "Really delete for good? This cannot be undone.",
      "pruefung.loeschenJa": "Yes, delete",
      "pruefung.loeschenFehler": "The report could not be deleted",
      "pruefung.pdf": "PDF",
      "pruefung.pdfFehler": "The PDF could not be created",
      "sprache.de": "DE",
      "sprache.en": "EN",
      "pruefung.rueckgabeGrund": "What is missing or needs fixing?",
      "pruefung.zurueckgegeben": "Sent back by management",
      "pruefung.nochOffen": "Still missing",
      "pruefung.grund.offen": "not recorded yet",
      "pruefung.grund.mangel_ohne_kommentar": "fault without a comment",
      "pruefung.grund.wert_ohne_kommentar": "value outside the target without a comment",
      "pruefung.grund.foto_fehlt": "fault without a photo",
      "foto.aufnehmen": "Photo",
      "foto.galerie": "From the gallery",
      "foto.laedtAnzahl_one": "Uploading {{count}} photo",
      "foto.laedtAnzahl_other": "Uploading {{count}} photos",
      "foto.anderes": "Different photo",
      "foto.belegAufnehmen": "Photograph the receipt",
      "foto.belegPflicht": "Without a photo it cannot be saved",
      "foto.laedt": "Uploading",
      "foto.entfernen": "Remove photo",
      "foto.pflicht": "A photo is required for this checkpoint",
      "foto.fehler": "The photo could not be saved",
      "pruefung.ergebnis.done": "Done",
      "pruefung.ergebnis.ok": "Checked, in order",
      "pruefung.ergebnis.fault": "Checked, not in order",
      "pruefung.ergebnis.na": "Not checked",
      "pruefung.ja": "Done",
      "pruefung.nein": "Not applicable",
      "pruefung.wert": "Value",
      "pruefung.ausserhalb": "Outside the target",
      "pruefung.kommentar": "Comment",
      "pruefung.kommentarPflicht": "Comment required",
      "pruefung.kommentarFehlt": "The report cannot be submitted without a comment.",
      "pruefung.kundentext": "Text for the customer",
      "pruefung.kundentextHinweis": "This text appears in the PDF the owner receives.",
      "pruefung.gespeichert": "Saved",
      "ki.vorschlag": "Suggestion from Claude",
      "ki.denkt": "Claude is writing",
      "ki.marke": "Suggested by Claude",
      "ki.markeBearbeitet": "From Claude, edited",
      "ki.hinweis": "The suggestion is neither saved nor sent. Read it first, then save.",
      "ki.uebersetzen": "Translate",
      "ki.fehler": "Claude could not help just now",
      "ki.rest": "{{n}} left",
      "ki.aufgebraucht": "None left. The text can still be edited by hand.",
      "versand.titel": "Send to the owner",
      "versand.hinweis": "The Jornado Report goes to the customer as a PDF. This is where it leaves the house.",
      "versand.an": "To",
      "versand.kopie": "Blind copy",
      "versand.betreff": "Subject",
      "versand.anhang": "Attachment",
      "versand.anhangPdf": "Jornado Report as PDF ({{sprache}})",
      "versand.senden": "Send to the customer",
      "versand.erneut": "Send again",
      "versand.frage": "Really send to {{an}}?",
      "versand.ja": "Yes, send",
      "versand.laeuft": "Sending",
      "versand.bereits": "Sent on {{datum}} to {{an}}",
      "versand.fehler": "The report could not be sent",
      "versand.letzterFehler": "Last attempt on {{datum}}: {{fehler}}",
      "nav.auftraege": "Work orders",
      "auftraege.titel": "Work orders",
      "auftraege.anzahl_one": "{{count}} work order",
      "auftraege.anzahl_other": "{{count}} work orders",
      "auftraege.leer": "No work orders in this state.",
      "auftraege.loeschenSicher": "Delete this work order for good? History and photos go with it. Recorded hours remain, they only lose the link.",
      "auftraege.geloesteZeiten_one": "{{count}} recorded entry was linked to this work order. It stays in the register, without a work order.",
      "auftraege.geloesteZeiten_other": "{{count}} recorded entries were linked to this work order. They stay in the register, without a work order.",
      "auftraege.neu": "New work order",
      "auftraege.nummer": "Order {{nummer}}",
      "auftraege.offen": "Open",
      "auftraege.alle": "All",
      "auftraege.zustand": "State",
      "auftraege.objekt": "Property",
      "auftraege.titel1": "Title",
      "auftraege.beschreibung": "Description",
      "auftraege.prioritaet": "Priority",
      "auftraege.termin": "Date",
      "auftraege.zugewiesen": "Assigned to",
      "auftraege.ohneZuweisung": "Unassigned",
      "auftraege.fotos": "Photos",
      "auftraege.keineFotos": "No photos yet.",
      "auftraege.verlauf": "History",
      "auftraege.notiz": "Save note",
      "auftraege.notizPlatzhalter": "Short note for your colleagues",
      "auftraege.zurueckZurListe": "Back to the list",
      "auftraege.ausMangel": "Create a work order from this fault",
      "auftraege.status.open": "Open",
      "auftraege.status.scheduled": "Scheduled",
      "auftraege.status.in_progress": "In progress",
      "auftraege.status.waiting": "Waiting",
      "auftraege.status.done": "Done",
      "auftraege.status.cancelled": "Withdrawn",
      "auftraege.prio.low": "Low",
      "auftraege.prio.normal": "Normal",
      "auftraege.prio.high": "High",
      "auftraege.prio.urgent": "Urgent",
      "auftraege.fotoart.before": "Before",
      "auftraege.fotoart.after": "After",
      "auftraege.fotoart.receipt": "Receipt",
      "auftraege.fotoart.other": "Other",
      "auftraege.fotoHinzu.before": "Add before",
      "auftraege.fotoHinzu.after": "Add after",
      "auftraege.fotoHinzu.receipt": "Add receipt",
      "auftraege.ereignis.created": "Created",
      "auftraege.ereignis.assigned": "Assignment changed",
      "auftraege.ereignis.status_changed": "State changed",
      "auftraege.ereignis.note": "Note",
      "system.titel": "System status",
      "nav.zeiten": "Time",
      "nav.meinTag": "My day",
      "nav.meineWoche": "My week",
      "nav.meineZeit": "My hours",
      "nav.antraege": "Requests",
      "nav.team": "Team",
      "nav.fuhrpark": "Fuel log",
      "nav.handbuch": "Handbook",
      "nav.hinweis": "Note to the boss",
      "fuhrpark.titel": "Fuel log",
      "fuhrpark.hinweis": "Vehicle, odometer, photo of the receipt.",
      "fuhrpark.neuerEintrag": "Add refuelling",
      "fuhrpark.neuesFahrzeug": "Add vehicle",
      "fuhrpark.fahrzeug": "Vehicle",
      "fuhrpark.kilometerstand": "Odometer",
      "fuhrpark.kmHinweis": "The value you forget the moment you drive off.",
      "fuhrpark.literLabel": "Litres",
      "fuhrpark.betrag": "Amount in euros",
      "fuhrpark.notiz": "Note",
      "fuhrpark.beleg": "Receipt",
      "fuhrpark.belegHinweis": "Photo of the receipt, optional.",
      "fuhrpark.dreiAngaben": "Three entries are enough. Litres and amount are read from the receipt.",
      "fuhrpark.belegPflicht": "Photo of the receipt. Without it nothing can be recorded.",
      "fuhrpark.betragOffen": "amount to follow",
      "fuhrpark.vomBeleg": "read from the receipt",
      "fuhrpark.berichtigen": "Correct the figures",
      "fuhrpark.nochmalLesen": "Read the receipt again",
      "fuhrpark.ohneBetrag_one": "{{count}} receipt without an amount",
      "fuhrpark.ohneBetrag_other": "{{count}} receipts without an amount",
      "fuhrpark.belegZeigen": "Show receipt",
      "fuhrpark.summe": "Total",
      "fuhrpark.liter": "Fuelled",
      "fuhrpark.kmStand": "{{km}} km",
      "fuhrpark.leer": "Nothing recorded this month.",
      "fuhrpark.keineFahrzeuge": "No vehicle has been set up yet. Let the office know.",
      "fuhrpark.keineFahrzeugeChef": "Add a vehicle first, otherwise nobody can record refuelling.",
      "fuhrpark.kennzeichen": "Plate",
      "fuhrpark.bezeichnung": "Label",
      "fuhrpark.bezeichnungHinweis": "What you call the car, e.g. \"white van\".",
      "fuhrpark.modell": "Model",
      "fuhrpark.kraftstoff": "Fuel",
      "handbuch.titel": "Handbook",
      "handbuch.hinweis": "Operating instructions and standing orders.",
      "handbuch.suche": "Search",
      "handbuch.kategorie": "Category",
      "handbuch.alleKategorien": "all",
      "handbuch.leer": "Nothing here.",
      "handbuch.neu": "Add article",
      "handbuch.kennung": "Key",
      "handbuch.kennungHinweis": "Short, no spaces, e.g. pool-winter-shutdown.",
      "handbuch.sichtbarkeit": "Visible to",
      "handbuch.fuerAlle": "all employees",
      "handbuch.nurChef": "management only",
      "handbuch.artikelTitel": "Title",
      "handbuch.artikelText": "Text",
      "handbuch.archivieren": "Archive",
      "handbuch.ersatzsprache": "in German, not yet available in your language",
      "handbuch.deutschPflicht": "Title and text in German are required, the rest is optional.",
      "rechte.nurBuero": "This page is for the office.",
      "rechte.nurBueroHinweis": "Your account does not cover it. If you need something from here, let the office know.",
      "rechte.zurueck": "Back to my day",
      "einladung.titel": "Welcome",
      "einladung.hinweis": "Choose a password, at least twelve characters.",
      "einladung.passwort": "Password",
      "einladung.wiederholen": "Repeat password",
      "einladung.ungleich": "The two passwords do not match.",
      "einladung.ungueltig": "This link is invalid, expired or already used.",
      "einladung.starten": "Get started",
      "meinezeit.titel": "My hours",
      "meinezeit.ist": "Worked",
      "meinezeit.soll": "Target",
      "meinezeit.saldoMonat": "Balance this month",
      "meinezeit.tage": "Days",
      "meinezeit.nichtGestempelt": "not recorded",
      "meinezeit.saldoGesamt": "Overtime in total, since {{seit}}",
      "meinezeit.rechnung": "{{wochenstunden}} hours a week · worked {{ist}} · target {{soll}}",
      "meinezeit.ohneSoll": "No contracted weekly hours are set for you yet. Without them no balance can be calculated. Let the office know.",
      "antrag.titel": "Requests",
      "antrag.hinweis": "Holiday, sick leave and time corrections.",
      "antrag.hinweisChef": "Open requests from your team.",
      "antrag.neuAbwesenheit": "Holiday or sick leave",
      "antrag.neuKorrektur": "Time correction",
      "antrag.abwesenheiten": "Holiday and absence",
      "antrag.korrekturen": "Time corrections",
      "antrag.leer": "Nothing here.",
      "antrag.artLabel": "Type",
      "antrag.art.vacation": "Holiday",
      "antrag.art.sick": "Sick",
      "antrag.art.unpaid": "Unpaid",
      "antrag.art.special": "Special leave",
      "antrag.art.training": "Training",
      "antrag.von": "From",
      "antrag.bis": "To",
      "antrag.bisHinweis": "Leave empty for a single day.",
      "antrag.halberErster": "First day half",
      "antrag.halberLetzter": "Last day half",
      "antrag.grund": "Note",
      "antrag.datum": "Date",
      "antrag.einreichen": "Submit",
      "antrag.genehmigen": "Approve",
      "antrag.ablehnen": "Reject",
      "antrag.zurueckziehen": "Withdraw",
      "antrag.entschieden": "Decided on {{am}} by {{von}}",
      "antrag.tage_one": "{{count}} day",
      "antrag.tage_other": "{{count}} days",
      "antrag.status.requested": "open",
      "antrag.status.approved": "approved",
      "antrag.status.rejected": "rejected",
      "antrag.status.cancelled": "withdrawn",
      "antrag.korrekturHinweis": "Enter when you actually worked. The office decides; only then does the register change.",
      "antrag.keineBuchung": "There is no entry on that day. The request will then create a whole working day.",
      "antrag.korrigiertBuchung": "This corrects the entry from {{von}} to {{bis}}.",
      "antrag.welcheBuchung": "Which entry",
      "antrag.buchungWaehlen": "Please choose",
      "team.titel": "Team",
      "team.hinweis": "Accounts, weekly hours and public holidays.",
      "team.einladen": "Invite an employee",
      "team.name": "Name",
      "team.email": "Email",
      "team.emailHinweis": "This is how they sign in. Change it when the address is no longer reachable; all data stays with this person.",
      "team.zugangHinweis": "If someone can no longer get in because they lost their password or mailbox: correct the address above, save, then send a new invitation here. They choose a new password themselves. No second account is created, times and reports stay put.",
      "team.zugangNeu": "Set up access again",
      "team.zugangGesendet": "Invitation sent to {{an}}. It is valid for seven days.",
      "team.zugangOhneMail": "No mail server configured. Pass on this link, it is valid for seven days:",
      "team.rolleLabel": "Role",
      "team.rolle.admin": "Management",
      "team.rolle.lead": "Team lead",
      "team.rolle.employee": "Employee",
      "team.einladungSenden": "Send invitation",
      "team.einladenHinweis": "They receive a link by email and set their own password. You never see it.",
      "team.keinVersand": "No mail is being sent. Give them this link in person, it is valid for seven days.",
      "team.wochenstunden": "Weekly hours",
      "team.wochenstundenHinweis": "From the contract. Without this value there is no overtime.",
      "team.wochenstundenWert": "{{stunden}} hours a week",
      "team.ohneWochenstunden": "No weekly hours set",
      "team.eintritt": "Start date",
      "team.eintrittHinweis": "The total balance counts from here.",
      "team.faehrtMit": "Rides with",
      "team.faehrtMitHinweis": "For staff without their own car. The weekly suggestion never plans them alone, only onto their driver\u2019s appointments.",
      "team.faehrtSelbst": "Drives themselves",
      "team.wohnort": "Home town",
      "team.wohnortHinweis": "The town only, not a street address. The drive there is the employee\u2019s own time; it only decides which end the optimised route starts at. The coordinate is looked up when saving.",
      "team.planPosition": "Order in the duty roster",
      "team.planPositionHinweis": "A low number sits on the left. Empty means last, sorted by name there. Display only: the number says nothing about rank or qualification.",
      "team.imDienstplan": "Column in the duty roster",
      "team.imDienstplanHinweis": "Someone who is never scheduled does not need an empty column. Hiding blocks nothing: if they do get an appointment, the column reappears on that day.",
      "team.imDienstplanAn": "Show own column",
      "team.wohnortOhneTreffer": "No coordinate was found for this place. The direction of the route stays as it is.",
      "team.faehrtMitWert": "rides with {{name}}",
      "team.nurAushilfe": "{{abteilung}}: helps out only",
      "team.abteilungAushilfe": "{{abteilung}} (stand-in)",
      "team.seit": "since {{datum}}",
      "team.bis": "until {{datum}}",
      "team.austritt": "Leaving",
      "team.austrittHinweis": "Ends the employment and blocks the account.",
      "team.austrittWarnung": "The account is blocked, all signed-in devices are logged out, future shifts are removed and open work orders are released for reassignment. Working time and reports are kept in full.",
      "team.austrittDatum": "Last working day",
      "team.austrittGrund": "Reason",
      "team.austrittGrundHinweis": "Optional, kept in the audit log only",
      "team.austrittBestaetigen": "Complete leaving",
      "team.austrittFertig": "{{name}} has left",
      "team.bilanzGeraete_one": "One device signed out",
      "team.bilanzGeraete_other": "{{count}} devices signed out",
      "team.bilanzDienste_one": "One planned shift removed",
      "team.bilanzDienste_other": "{{count}} planned shifts removed",
      "team.bilanzAuftraege_one": "One work order awaits reassignment",
      "team.bilanzAuftraege_other": "{{count}} work orders await reassignment",
      "team.bilanzZeiten": "Working time and reports are kept.",
      "team.wiedereintritt": "Re-employ",
      "team.aktiv": "Account active",
      "team.stillgelegt": "deactivated",
      "team.zustand.arbeitet": "working since {{zeit}}",
      "team.zustand.pause": "on a break",
      "team.zustand.vergessen": "forgot to clock out",
      "team.zustand.nichtDa": "not clocked in",
      "team.feiertage": "Public holidays",
      "leistung.titel": "Target hours per week",
      "leistung.gesamt": "{{stunden}} in total",
      "leistung.leer": "No target hours on file yet.",
      "wochentag.1": "Monday",
      "wochentag.2": "Tuesday",
      "wochentag.3": "Wednesday",
      "wochentag.4": "Thursday",
      "wochentag.5": "Friday",
      "wochentag.6": "Saturday",
      "wochentag.7": "Sunday",
      "leistung.festerTag": "Fixed weekday",
      "leistung.festerTagHinweis": "Only set this if the day really cannot be moved.",
      "leistung.festeZeit": "Fixed time",
      "leistung.festeZeitHinweis": "Only together with a fixed day. Empty means: day fixed, time free.",
      "leistung.rhythmus": "Rhythm",
      "leistung.rhythmusHinweis": "For two houses side by side that take turns. What is not due this week does not appear in the demand list either. The customer report counts the average: every two weeks is half the time per month.",
      "leistung.jedeWoche": "Every week",
      "leistung.alleWochen": "Every {{wochen}} weeks",
      "leistung.rhythmusAb": "First week due",
      "leistung.rhythmusAbHinweis": "Counting starts from this week. Any day will do, the system takes the Monday of that week.",
      "leistung.rhythmusZeile": "Every {{wochen}} weeks, counted from the week of {{ab}}",
      "leistung.freiPlanbar": "Freely schedulable",
      "leistung.festTagZeit": "Fixed: {{tag}} at {{zeit}}",
      "leistung.festNurTag": "Fixed: {{tag}}, time free",
      "leistung.neu": "Add target hours",
      "leistung.loeschenSicher": "Delete these target hours?",
      "leistung.stundenProWoche": "Hours per week",
      "leistung.stundenHinweis": "Working hours, not calendar time: four hours of gardening is also two gardeners for two hours.",
      "leistung.von": "Valid from",
      "leistung.bis": "Valid until",
      "leistung.zeitraumHinweis": "Empty means: always valid. Add one row each for summer and winter.",
      "leistung.abDatum": "from {{datum}}",
      "leistung.bisDatum": "until {{datum}}",
      "team.abteilungen": "Departments",
      "team.abteilungenHinweis": "What this person can be assigned to. They may still help out anywhere; the schedule will point it out.",
      "team.abteilungenListeHinweis": "Garden, pool, cleaning, technical. A department is never deleted, only deactivated: past appointments and target hours hang on it.",
      "team.abteilungName": "Department name",
      "team.abteilungHinzu": "Add department",
      "team.abteilungBelegt": "{{menschen}} employees · {{objekte}} properties",
      "team.stilllegen": "Deactivate",
      "team.wiederAufnehmen": "Reactivate",
      "team.jahr": "Year",
      "team.feiertagName": "Name",
      "team.feiertagHinzu": "Add",
      "team.feiertageHinweis": "A maintained list, because on Mallorca national, Balearic and local holidays apply side by side. A holiday lowers the target by one working day.",
      "aktion.fertig": "Done",
      "nav.plan": "Schedule",
      "tag.titel": "Hello {{name}}",
      "tag.nichtBegonnen": "Your working day has not started yet.",
      "tag.beginnen": "Start working day",
      "tag.beenden": "End working day",
      "tag.termine": "Today",
      "tag.keineTermine": "Nothing scheduled for today.",
      "tag.navigieren": "Navigate",
      "tag.einsatzStart": "Start visit",
      "tag.einsatzEnde": "End visit",
      "tag.checkliste": "Checklist",
      "tag.checklisteWaehlen": "Which checklist?",
      "tag.wegfahrtTitel": "An assignment is still open",
      "tag.wegfahrtText": "An assignment at {{objekt}} has been running since {{seit}}. When did you leave?",
      "tag.wegfahrtFahrt_one": "About {{count}} minute drive from there to here",
      "tag.wegfahrtFahrt_other": "About {{count}} minutes drive from there to here",
      "tag.wegfahrtFrage": "Left at",
      "tag.wegfahrtUebernehmen": "Apply and start",
      "tag.wegfahrtEben": "I was there until just now",
      "tag.wegfahrtUngueltig": "The time must be after the start and not in the future.",
      "tag.laeuft": "running",
      "tag.erledigt": "done",
      "tag.imEinsatz": "On site at {{objekt}}, since {{seit}}",
      "tag.gestempelt": "Recorded today",
      "tag.ungeplant": "unplanned",
      "tag.ungeplantOeffnen": "Unplanned visit",
      "tag.ungeplantHinweis": "Only if there is no appointment for it. The office sees it as unplanned.",
      "tag.ungeplantLaeuft": "Unplanned visit at {{objekt}}, since {{seit}}",
      "tag.keineCheckliste": "No checklist is set up for this property.",
      "plan.titel": "Schedule",
      "plan.ansichtTag": "Day",
      "plan.ansichtWoche": "Week",
      "plan.terminAendern": "Edit appointment",
      "plan.datum": "Date",
      "plan.frei": "free",
      "plan.loeschenSicher": "Delete this appointment?",
      "plan.ziehenHinweis": "Dragging moves an appointment: sideways to another employee, up or down to another time, onto a day in the bar to another day. Clicking opens it for editing or deleting.",
      "plan.termineZahl_one": "{{count}} appointment",
      "plan.termineZahl_other": "{{count}} appointments",
      "plan.konflikteZahl_one": "{{count}} conflict",
      "plan.konflikteZahl_other": "{{count}} conflicts",
      "plan.hinweis": "What is here is what employees see as their day.",
      "plan.zurueck": "Previous week",
      "plan.vor": "Next week",
      "plan.heute": "This week",
      "plan.neu": "Appointment",
      "plan.neuerTermin": "New appointment on {{tag}}",
      "plan.wiederholungen": "Weeks",
      "plan.wiederholungenHinweis": "1 means once. 12 creates twelve weeks ahead.",
      "plan.notiz": "Note for the employee",
      "plan.konfliktAbwesenheit": "Approved absence: {{art}}",
      "plan.konfliktUeberschneidung": "Overlaps with another shift",
      "plan.konfliktFeiertag": "Public holiday: {{name}}",
      "plan.ohneKoordinate": "Property without coordinates, no distance check",
      "plan.gestempelt": "Time has already been recorded here",
      "plan.ansichtBedarf": "Workload",
      "plan.abteilung": "Department",
      "plan.ohneAbteilung": "No department",
      "plan.team": "Team",
      "plan.teamHinweis": "Several possible. Four hours of gardening is two gardeners for two hours.",
      "plan.teamZahl_one": "{{count}} person",
      "plan.teamZahl_other": "{{count}} people",
      "plan.gemeinsamMit": "Together with {{namen}}",
      "plan.arbeitsstunden_one": "{{stunden}} of work, one person",
      "plan.arbeitsstunden_other": "{{stunden}} of work, {{count}} people together",
      "plan.konfliktFachfremd": "Not assigned to {{abteilung}}",
      "plan.bedarfLeer": "No property has target hours on file.",
      "plan.bedarfOffen_one": "{{count}} service is not fully scheduled this week.",
      "plan.bedarfOffen_other": "{{count}} services are not fully scheduled this week.",
      "plan.bedarfObjekt": "Property",
      "plan.bedarfSoll": "Target",
      "plan.bedarfGeplant": "Scheduled",
      "plan.bedarfRest": "Open",
      "plan.farbeLaeuft": "Purple: someone is clocked in right now",
      "plan.farbeBeendet": "Green: visit finished",
      "plan.notizHinweis": "Permanent, tied to the property. The employee sees it in black.",
      "plan.aenderung": "Change for this day",
      "plan.aenderungHinweis": "Appears in red at the top of the appointment for the employee. Leave empty if nothing differs today.",
      "plan.aenderungGelesen": "Read by {{name}} on {{zeit}}.",
      "plan.aenderungUngelesen": "Not read yet.",
      "plan.aenderungUngelesenKurz": "unread",
      "tag.aenderung": "Different today",
      "tag.aenderungGelesen": "Read",
      "tag.aenderungQuittiert": "Marked as read.",
      "notiz.titel": "Internal note",
      "pruefung.team": "You are filling in this report together: {{namen}}. Split the list, otherwise one of you overwrites the other.",
      "pruefung.nichtGespeichert": "Not saved. Check the entry and tap outside the field again.",
      "pruefung.fortschrittGesamt": "{{erledigt}} of {{gesamt}} in the whole report",
      "pruefung.nurMeineBereiche": "You see the areas your department covers today. Your colleague fills in the rest.",
      "pruefung.weitereFotos": "More photos",
      "pruefung.weitereFotosHinweis": "Pictures that belong to no single item: the walk-around, the driveway, the overall impression. They appear at the end of the report, without a heading.",
      "team.abteilungBereich": "Areas in the report",
      "team.abteilungBereichHinweis": "Which checkpoints this department sees in the report. Nothing ticked means all of them.",
      "muster.titel": "Sample reports",
      "wasser.titel": "Water consumption",
      "wasser.ruhig": "No property is currently using noticeably more than usual.",
      "wasser.auffaellige_one": "{{count}} property is using considerably more than usual. Worth a look.",
      "wasser.auffaellige_other": "{{count}} properties are using considerably more than usual. Worth a look.",
      "wasser.objekt": "Customer and property",
      "wasser.proTag": "m³ per day",
      "wasser.ueblich": "usually",
      "wasser.woche": "last 7 days",
      "wasser.monat": "month per day",
      "wasser.vormonat": "prev. month",
      "wasser.abgelesen": "Read on",
      "wasser.marke": "unusual",
      "wasser.tage_one": "over {{count}} day",
      "wasser.tage_other": "over {{count}} days",
      "wasser.alleZeigen": "Show all {{count}} properties",
      "wasser.hinweis": "Daily consumption is compared with what is usual for this property: an empty house against earlier empty weeks, an occupied one against occupied weeks. Red with a badge means empty and still considerably more than usual, and that is the case to follow up. Amber means only more than usual. A property without recorded stays counts as empty.",
      "wasser.verdacht_one": "{{count}} property was empty and still used considerably more than usual. That is the case to follow up.",
      "wasser.verdacht_other": "{{count}} properties were empty and still used considerably more than usual. Those are the cases to follow up.",
      "wasser.haus": "House",
      "wasser.hausLeer": "empty",
      "wasser.hausBelegt_one": "occupied, {{count}} day",
      "wasser.hausBelegt_other": "occupied, {{count}} days",
      "wasser.grundlast": "empty usually",
      "wasser.markeMehr": "more than usual",
      "wasser.vergleich.leer": "empty weeks",
      "wasser.vergleich.belegt": "occupied weeks",
      "wasser.vergleich.alle": "all weeks",
      "muster.hinweis": "Creates complete, approved reports for a customer with exactly one property, two per week, with water meter and pool values. This gives the trend at the property something to show and makes a demonstration look like real operation. They are never sent, carry the note \"sample report\" inside the office, and can be removed again at any time.",
      "muster.kunde": "Customer",
      "muster.kundeWaehlen": "Please choose",
      "muster.monat": "Month",
      "muster.anzahl": "Count",
      "muster.anzahlHinweis": "Tuesday and Friday, twelve at most",
      "muster.anlegen": "Create sample reports",
      "muster.entfernen": "Remove sample reports",
      "muster.angelegt_one": "{{count}} sample report created for {{kunde}}, {{punkte}} checkpoints each. Dates: {{tage}}",
      "muster.angelegt_other": "{{count}} sample reports created for {{kunde}}, {{punkte}} checkpoints each. Dates: {{tage}}",
      "muster.entfernt_one": "{{count}} sample report removed.",
      "muster.entfernt_other": "{{count}} sample reports removed.",
      "notiz.hinweis": "Office only. Not in the owner report.",
      "notiz.platzhalter": "What the office should know and the customer should not.",
      "notiz.reiter": "Internal notes",
      "notiz.reiterHinweis": "What the crew noted on site. Ticked off means archived, not deleted.",
      "notiz.zeigeErledigte": "Show completed",
      "notiz.zeigeOffene": "Show open",
      "notiz.keineOffenen": "No open notes.",
      "notiz.keineErledigten": "Nothing ticked off yet.",
      "notiz.von": "{{name}}, report {{nummer}}",
      "notiz.zumBericht": "Open report",
      "notiz.erledigt": "Done",
      "notiz.wiederOeffnen": "Reopen",
      "notiz.abgehakt": "Ticked off by {{name}} on {{datum}}.",
      "plan.ablage": "Open services",
      "plan.ablageHinweis": "Drag onto a column. The choice of 1 or 2 applies to every row of the same department.",
      "plan.ablageLeer": "Everything is scheduled this week.",
      "plan.ablageZeile": "{{offen}} open, {{dauer}} on site",
      "plan.ablageEiner": "One person goes",
      "plan.ablageZwei": "Two people go",
      "plan.ablageKeinBeifahrer": "No passenger is on file for {{name}}. Two people only works where someone rides along.",
      "plan.ablageErgaenzt": "Service added to the existing appointment: {{objekt}}.",
      "plan.ansichtVorschlag": "Proposal",
      "plan.vorschlagHinweis": "A draft, sorted by proximity. Nothing is booked until you accept it.",
      "plan.vorschlagAlle_one": "Accept {{count}} appointment",
      "plan.vorschlagAlle_other": "Accept {{count}} appointments",
      "plan.vorschlagLeer": "Nothing to propose for this week.",
      "plan.vorschlagUebernehmen": "Accept",
      "plan.vorschlagVerwerfen": "Discard",
      "plan.vorschlagOffen": "Left open",
      "plan.grundKeineFachkraft": "Nobody is assigned to this department",
      "plan.grundKeinPlatz": "No free slot this week",
      "plan.grundFesttermin": "Fixed appointment does not fit: day or time is taken",
      "plan.grundNurMitfahrt": "Too short for its own trip, no visit to attach it to",
      "plan.tagAusrichten": "Align day",
      "plan.routeOptimieren": "Optimise route",
      "plan.ausrichtenKurz": "Align",
      "plan.routeKurz": "Route",
      "plan.vorschlagNurFuer": "Draft for {{name}} only. Whoever rides along is included.",
      "plan.routeKuerzer_one": "{{count}} minute less driving",
      "plan.routeKuerzer_other": "{{count}} minutes less driving",
      "plan.routeSchonKurz": "The order was already the shortest",
      "plan.routeFest_one": "{{count}} appointment stayed put",
      "plan.routeFest_other": "{{count}} appointments stayed put",
      "plan.ausgerichtet_one": "{{count}} appointment moved",
      "plan.ausgerichtet_other": "{{count}} appointments moved",
      "plan.pauseGesetzt": "Break {{von}} to {{bis}}",
      "plan.pauseImTermin": "One appointment is too long for a break in between. It falls inside, and the working time is paused for it.",
      "plan.ueberzug_one": "{{count}} minute past the end of the day",
      "plan.ueberzug_other": "{{count}} minutes past the end of the day",
      "plan.pause": "Break",
      "plan.pauseHinweis": "Planned, not clocked",
      "tag.pausePlan": "That is the plan. Clock the break with the break button above.",
      "plan.bereiche": "Areas on this visit",
      "plan.bereicheHinweis": "Several possible. Pool and house check on one trip are one appointment.",
      "plan.minuten": "minutes",
      "plan.bereicheSumme": "{{summe}} of {{dauer}} minutes allocated",
      "plan.bereichMinuten_one": "{{count}} min",
      "plan.bereichMinuten_other": "{{count}} min",
      "plan.wieGewohnt": "as usual on {{tag}}",
      "plan.abweichendVomGewohnten": "different, usually {{tag}}",
      "plan.grundOhneKoordinate": "Property without coordinates, travel time unknown",
      "plan.anfahrtMinuten_one": "{{count}} minute travel",
      "plan.anfahrtMinuten_other": "{{count}} minutes travel",
      "plan.fahrtKurz": "{{minuten}} min",
      "plan.fahrtLang": "Travel about {{km}} km, {{minuten}} min",
      "plan.fahrtTitel": "Estimated travel: {{km}} km, {{minuten}} minutes",
      "plan.fahrtZuKnapp_one": "only {{count}} minute to spare",
      "plan.fahrtZuKnapp_other": "only {{count}} minutes to spare",
      "auswertung.nachMitarbeiter": "By employee",
      "auswertung.nachKunden": "By customer",
      "auswertung.kunde": "Customer",
      "auswertung.soll": "Agreed",
      "auswertung.ist": "Delivered",
      "auswertung.differenz": "Difference",
      "auswertung.einsaetze": "Assignments",
      "auswertung.summe": "Total",
      "auswertung.leer": "No target hours and no assignments for this month.",
      "auswertung.ohneSoll": "Hours without an agreement on file",
      "auswertung.keineEinsaetze": "Nobody was on site this month.",
      "auswertung.ungeplant": "no appointment",
      "auswertung.kosten": "Costs",
      "auswertung.material": "Material",
      "auswertung.fremd": "Subcontracted",
      "auswertung.belege": "Material and subcontracted costs",
      "auswertung.export": "As Excel",
      "auswertung.exportHinweis": "Billing, assignments and receipts in one workbook for accounting.",
      "schnittstelle.titel": "Interface",
      "schnittstelle.hinweis": "A key gives another program read access to customers, properties, assignments, costs and the billing basis. Nothing can be written through the interface.",
      "schnittstelle.name": "What is the key for?",
      "schnittstelle.nameHinweis": "For example the accountant or an invoicing program. One key per recipient, so one can be revoked without switching off the others.",
      "schnittstelle.anlegen": "Create key",
      "schnittstelle.einmalig": "Copy this key now. It will never be shown again.",
      "schnittstelle.verstanden": "Copied",
      "schnittstelle.leer": "No key created yet.",
      "schnittstelle.angelegt": "Created",
      "schnittstelle.benutzt": "Last used",
      "schnittstelle.nieBenutzt": "Never used",
      "schnittstelle.widerrufen": "Revoke",
      "schnittstelle.widerrufenAm": "Revoked on",
      "demo.titel": "Take a look at Jornado",
      "demo.einstiegHinweis": "A fully set up installation with invented data. No sign-in, nothing is sent out.",
      "demo.code": "Access code",
      "demo.alsBuero": "Open as office",
      "demo.alsMitarbeiter": "Open as field staff",
      "demo.fehler": "The demo cannot be opened right now.",
      "demo.marke": "Demo",
      "demo.balken": "Every piece of data here is invented. Areas, checkpoints, departments, logo and colours are set up individually for each business: what you see is an example, not a default.",
      "demo.zuruecksetzen": "Reset demo",
      "demo.setztZurueck": "Resetting …",
      "nav.kosten": "Costs",
      "kosten.titel": "Material and subcontracted costs",
      "kosten.hinweis": "What was used or bought for a property. A photo of the receipt is enough.",
      "kosten.neuerEintrag": "New entry",
      "kosten.objekt": "Property",
      "kosten.alleObjekte": "All properties",
      "kosten.summe": "Total",
      "kosten.material": "Material",
      "kosten.fremd": "Subcontracted",
      "kosten.leer": "Nothing was recorded this month.",
      "kosten.nichtWeiter": "not rechargeable",
      "kosten.belegZeigen": "View receipt",
      "kosten.wirklichWeg": "Delete this entry?",
      "kosten.datum": "Date",
      "kosten.datumHinweis": "When it was bought or done. Today by default, can be backdated.",
      "kosten.bezeichnung": "What",
      "kosten.bezeichnungHinweis": "Short and recognisable, for example pool salt or electrician call-out.",
      "kosten.betrag": "Amount",
      "kosten.betragHinweis": "In euro, exactly as it appears on the receipt.",
      "kosten.abteilung": "Department",
      "kosten.abteilungHinweis": "So the cost sits next to the right hours in the report.",
      "kosten.ohneAbteilung": "None",
      "kosten.menge": "Quantity",
      "kosten.einheit": "Unit",
      "kosten.einheitHinweis": "Pieces, kg, litres, hours. Optional.",
      "kosten.lieferant": "Supplier",
      "kosten.notiz": "Note",
      "kosten.beleg": "Receipt",
      "kosten.belegHinweis": "A photo of the till receipt or the invoice. It also works without.",
      "kosten.weiterberechenbar": "Recharged to the owner",
      "zeit.einsaetze": "Visits",
      "zeit.abstand": "{{meter}} m from the property",
      "zeit.zuWeit": "{{meter}} m away from the property",
      "zeit.ohnePosition": "no position",
      "zeit.ohneKoordinate": "property without coordinates",
      "zeit.arbeitstag": "Working day",
      "zeit.einsatz": "Visit",
      "zeit.ungeplant": "unplanned",
      "zeit.titel": "Working time",
      "zeit.hinweis": "The register under Art. 34.9 ET, to be kept for four years. Clocking in and out happens on My day.",
      "zeit.nichtGestempelt": "You are not clocked in.",
      "zeit.kommen": "Clock in",
      "zeit.gehen": "Clock out",
      "zeit.pause": "Break",
      "zeit.pauseFaellig_one": "{{count}} hour without a break. Time for the break.",
      "zeit.pauseFaellig_other": "{{count}} hours without a break. Time for the break.",
      "zeit.pauseEnde": "End break",
      "zeit.inPause": "on break",
      "zeit.seit": "since {{zeit}}",
      "zeit.heuteBisher": "Today so far {{dauer}}",
      "zeit.objektOptional": "Property",
      "zeit.ohneObjekt": "no property",
      "zeit.wechselAuf": "Switch property to",
      "zeit.wechseln": "Switch",
      "zeit.vergessenTitel": "A shift is still open",
      "zeit.vergessenText": "Started on {{beginn}} and never ended. Enter the real end, nothing is guessed.",
      "zeit.echtesEnde": "Actual end",
      "zeit.grund": "Reason",
      "zeit.grundPflicht": "Required. Appears in the register.",
      "zeit.nachtragen": "Add entry",
      "zugang.titel": "Access",
      "zugang.hinweis": "Keys, gate, alarm. Every lookup is logged.",
      "zugang.neu": "Add entry",
      "zugang.leer": "Nothing stored for this property.",
      "zugang.anzeigen": "Show",
      "zugang.verbergen": "Hide",
      "zugang.verstecktGleich": "Hidden again after ninety seconds.",
      "zugang.artLabel": "Type",
      "zugang.bezeichnung": "Label",
      "zugang.bezeichnungHinweis": "What for, for example gate north entrance",
      "zugang.wert": "Number or code",
      "zugang.wertUnveraendert": "Leave empty to keep the current code",
      "zugang.art.key": "Key",
      "zugang.art.alarm": "Alarm",
      "zugang.art.gate": "Gate",
      "zugang.art.wifi": "Wi-Fi",
      "zugang.art.safe": "Safe",
      "zugang.art.other": "Other",
      "zeit.auszug": "Payroll export",
      "zeit.register": "Print register",
      "zeit.monat": "Month",
      "zeit.orte.titel": "Where clock-ins happened",
      "zeit.orte.hinweis": "Counted is the start of an assignment. Green means within {{meter}} metres of the property, red further away, grey without a position from the phone.",
      "zeit.orte.amObjekt": "At the property",
      "zeit.orte.zuWeit": "Too far away",
      "zeit.orte.ohnePosition": "Without position",
      "zeit.mitarbeiter": "Employee",
      "zeit.alle": "all",
      "zeit.summe": "Total",
      "zeit.leer": "Nothing was recorded this month.",
      "zeit.beginn": "Start",
      "zeit.ende": "End",
      "zeit.korrigieren": "Correct",
      "zeit.korrekturHinweis": "The original value is kept and shown on the row.",
      "zeit.korrigiertAm": "Corrected on {{am}} by {{von}}",
      "zeit.vorher": "before",
      "zeit.manuell": "added later",
      "zeit.pausenSumme": "of which {{dauer}} break",
      "zeit.stornieren": "Void",
      "zeit.storniert": "voided",
      "zeit.storniertAm": "Voided on {{am}} by {{von}}",
      "zeit.stornoHinweis": "The row stays in the register, struck through, and no longer counts. This cannot be undone; a mistaken void is repaired by adding a new entry.",
      "system.sicherung": "Nightly backup",
      "system.sicherungSchutz": "Backup protection",
      "system.verschluesselt": "encrypted",
      "system.unverschluesselt": "not encrypted, passphrase missing",
      "system.sicherungStand": "last {{zeit}} · {{groesse}}",
      "system.sicherung.keine": "There is no backup in storage.",
      "system.sicherung.unbekannt": "Cannot be read, storage is not responding.",
      "system.speicher": "File storage",
      "system.standortdaten": "Location data",
      "system.standortStand": "{{anzahl}} points, deleted after {{tage}} days",
      "system.standortUeberfaellig": "Points older than {{tage}} days are still there. Deletion is not running.",
      "team.auskunft": "Download data export",
      "team.auskunftHinweis": "All stored data of this person as a file, under Art. 15 GDPR.",
      "system.post": "Mail dispatch",
      "system.eingerichtet": "configured",
      "system.fehlt": "not configured",
      "nav.uebernahme": "Migration",
      "uebernahme.titel": "Migration from the old app",
      "uebernahme.hinweis": "Import customers and properties. A dry run first, then you decide.",
      "uebernahme.dateiWaehlen": "Choose the file from the old app",
      "uebernahme.gelesen": "{{datei}} · {{count}} records read",
      "uebernahme.falscheDatei": "This file does not contain customer data from the old app.",
      "uebernahme.probe": "Dry run",
      "uebernahme.probeErgebnis": "Dry run, nothing was written",
      "uebernahme.uebernehmen": "Import now",
      "uebernahme.fertig": "Imported",
      "uebernahme.zusammenfassung": "{{gelesen}} read, {{neu}} new, {{aktualisiert}} updated, {{uebersprungen}} skipped",
      "uebernahme.spalteKunde": "Customer",
      "uebernahme.spalteObjekt": "Property",
      "uebernahme.spalteZustand": "State",
      "uebernahme.spalteHinweise": "Notes",
      "uebernahme.zustand.neu": "New",
      "uebernahme.zustand.aktualisiert": "Updated",
      "uebernahme.zustand.uebersprungen": "Skipped",
      "nav.einstellungen": "Settings",
      "einstellungen.titel": "Settings",
      "einstellungen.hinweis": "These details appear in reports and in mail to the owner.",
      "einstellungen.firma": "Company",
      "einstellungen.telefon": "Phone",
      "einstellungen.email": "Email",
      "einstellungen.emailHinweis": "This address appears in the legal notice and receives whistleblower reports as long as no separate one is set.",
      "einstellungen.rechtTitel": "Mandatory details for the legal and privacy notice",
      "einstellungen.rechtWarnung": "These details appear in the legal notice and the privacy notice. Whatever is left empty here is missing there, and Art. 10 LSSI requires them in full.",
      "einstellungen.firmierung": "Full company name",
      "einstellungen.firmierungHinweis": "As entered in the commercial register, including the legal form. Empty means the company name above applies.",
      "einstellungen.nif": "NIF",
      "einstellungen.anschrift": "Registered address",
      "einstellungen.anschriftHinweis": "Several lines are allowed, as it would appear on a letter.",
      "einstellungen.register": "Entry in the Registro Mercantil",
      "einstellungen.registerHinweis": "Register, tomo, folio, hoja. It is on the deed of incorporation.",
      "einstellungen.datenschutzEmail": "Address for data protection requests",
      "einstellungen.datenschutzEmailHinweis": "Requests for access or erasure go to this address. Empty means the email above applies.",
      "betrieb.urlaubEinheit": "Count holiday in",
      "betrieb.urlaubEinheitHinweis": "Calendar days is the statutory minimum of 30. Working days is usually 22.",
      "betrieb.planTitel": "Planning and travel",
      "betrieb.planHinweis": "The window the weekly proposal plans within, and the assumptions behind the estimated travel time.",
      "betrieb.planBeginn": "Start of work",
      "betrieb.planEnde": "End of work",
      "betrieb.planTeamAb": "Team from (minutes)",
      "betrieb.planTeamAbHinweis": "Above this size the plan proposes two people: one trip instead of two.",
      "betrieb.fahrtTempo": "Average speed (km/h)",
      "betrieb.planPauseNach": "Break due after (minutes)",
      "betrieb.planPauseNachHinweis": "After this many worked minutes the plan places the break. It goes between two appointments; if none fits, it falls inside the running one and the working time is paused for it.",
      "betrieb.planPause": "Break length (minutes)",
      "betrieb.planPauseHinweis": "House rule, not law. Art. 34.4 ET requires the rest only above six hours at a stretch, and then fifteen minutes. Less than fifteen cannot be set.",
      "betrieb.fahrtTempoHinweis": "Basis of the estimate. Whether 45 holds on this island shows after one summer.",
      "betrieb.fahrtUmweg": "Detour factor",
      "betrieb.fahrtUmwegHinweis": "Straight-line distance times this factor gives the assumed road distance.",
      "betrieb.startOrt": "Route starting point",
      "betrieb.streckenKeine": "Travel times are estimated from straight-line distance. No measured routes yet.",
      "betrieb.eichung": "Based on {{paare}} measured routes between two and thirty kilometres, the length that occurs between two appointments in a day, it would be {{tempo}} km/h and factor {{umweg}}.",
      "betrieb.eichungUebernehmen": "Apply",
      "betrieb.streckenStand": "{{anzahl}} of {{moeglich}} routes actually measured, last on {{datum}}. Where no measurement exists, it is estimated.",
      "betrieb.startOrtHinweis": "Where the working day starts and ends, Sineu for example. It does not count as working time; the drive to the first customer is the employee\u2019s own. It only decides the direction: with equal distance the day starts at the nearer customer. The coordinate is looked up when saving.",
      "urlaub.titel": "Holiday account {{jahr}}",
      "urlaub.einheit.natural": "in calendar days",
      "urlaub.einheit.laboral": "in working days",
      "urlaub.anspruch": "Entitlement",
      "urlaub.anspruchHinweis": "Days this year",
      "urlaub.anspruchTitel": "Holiday entitlement",
      "urlaub.anspruchSpeichern": "Save entitlement",
      "urlaub.uebertrag": "Carried over",
      "urlaub.uebertragHinweis": "Days carried over from last year",
      "urlaub.genommen": "Taken",
      "urlaub.beantragt": "Requested",
      "urlaub.verbleibend": "Remaining",
      "urlaub.standChef": "{{genommen}} taken, {{rest}} remaining.",
      "urlaub.ohneAnspruch": "No entitlement stored for this year. The office enters it.",
      "urlaub.ohneAnspruchChef": "No entitlement stored for this year. Enter it per employee under Team.",
      "betrieb.titel": "Operations",
      "betrieb.hinweis": "How the system works. Visible to management only.",
      "betrieb.ortung": "Continuous location tracking during working hours",
      "betrieb.ortungWarnung": "Art. 90 LOPDGDD permits location tracking at work only if employees have been informed explicitly and unambiguously beforehand. Switching it on therefore requires the date on which the signed notice was in place. The change is logged.",
      "betrieb.ortungTage": "Delete location data after",
      "betrieb.ortungTageHinweis": "days. After that only the distance in metres remains on the entry.",
      "betrieb.ortungInfoAm": "Signed employee notice on file since",
      "betrieb.ortungInfoAmHinweis": "Without this date tracking cannot be switched on. The signed sheets stay in the personnel folder, only the date is kept here.",
      "betrieb.maxAbstand": "Flag distances above",
      "betrieb.maxAbstandHinweis": "metres. Clocking in further away shows red in the register.",
      "betrieb.kiAn": "Draft texts by Claude",
      "betrieb.verbrauch": "Spent this month",
      "betrieb.verbrauchStand": "{{verbraucht}} of {{grenze}}",
      "betrieb.kiLimit": "Monthly budget",
      "betrieb.kiLimitHinweis": "Euro per month. Once spent, no further drafts are produced.",
      "betrieb.kiVorschlaege": "Drafts per report",
      "betrieb.kiVorschlaegeHinweis": "How often Claude may be asked for the same report.",
      "betrieb.bueroKopie": "Blind copy to the office",
      "betrieb.bueroKopieHinweis": "Address that receives a copy of every customer mail. Empty means no copy.",
      "einstellungen.gespeichert": "Saved.",
      "nav.baukasten": "Kit",
      "baukasten.titel": "Checkpoints",
      "baukasten.hinweis": "This is where you build your report: first an area as the main heading, then the checkpoints underneath. A change reaches every property at once, deviations are made per property.",
      "baukasten.gruppe": "Sub-heading",
      "baukasten.gruppeHinweis": "Optional. The same heading on consecutive checkpoints forms a section in the app and in the report.",
      "baukasten.gruppeBeispiel": "Outside",
      "baukasten.hilfetext": "Help text for staff",
      "baukasten.hilfetextHinweis": "Optional. Shown in the app under the checkpoint, the same for every property.",
      "baukasten.hoch": "Move up",
      "baukasten.runter": "Move down",
      "checkliste.bereiche": "Areas at this property",
      "checkliste.bereicheHinweis": "Only what is ticked here gets checked. Untick whatever this property does not have.",
      "checkliste.mindestensEinBereich": "At least one area has to remain.",
      "checkliste.ohneBezeichnung": "Property check",
      "checkliste.punktErgaenzen": "Add a single checkpoint",
      "checkliste.punktErgaenzenHinweis": "For the one-off case, a boat jetty for example. A whole area would be too much.",
      "checkliste.fotoStandard": "As in the standard",
      "baukasten.punkte": "Checkpoints",
      "baukasten.punktNeu": "New checkpoint",
      "baukasten.punkteAnzahl_one": "{{count}} checkpoint",
      "baukasten.punkteAnzahl_other": "{{count}} checkpoints",
      "baukasten.keinePunkte": "No checkpoints yet.",
      "baukasten.bereichNeu": "New area",
      "baukasten.bereichUmbenennen": "Rename",
      "baukasten.bereichName": "Name of the area",
      "baukasten.bereichNameHinweis": "The main heading in the report, for example Property, Kitchen, Fleet. Enter German only, Claude translates the rest.",
      "baukasten.bereichBeispiel": "Property",
      "baukasten.keineBereiche": "No area yet. An area is a main heading in the report, the checkpoints go underneath.",
      "vorlage.titel": "Report templates",
      "vorlage.hinweis": "For jobs without a recurring round. The employee picks the template at the appointment, the property comes from the appointment. Nothing needs to be set up at the property.",
      "vorlage.neu": "New template",
      "vorlage.keine": "No template yet. If you only do recurring rounds, you do not need one.",
      "vorlage.bereiche": "Areas in this report",
      "vorlage.bezeichnung": "Name",
      "vorlage.bezeichnungHinweis": "At the appointment the employee sees only this name. It has to tell them which report they are starting.",
      "vorlage.beispiel": "Window installation",
      "vorlage.ohneBereich": "no area selected",
      "unterschrift.titel": "Accepted by the customer",
      "unterschrift.hinweis": "Optional. On an installation job the customer confirms that the work is done. It appears in the PDF below the report.",
      "unterschrift.keine": "Not signed yet.",
      "unterschrift.leisten": "Get a signature",
      "unterschrift.erneut": "Sign again",
      "unterschrift.name": "Name in block letters",
      "unterschrift.nameHinweis": "A signature on a display is often unreadable. Without the name nobody can tell later who signed.",
      "unterschrift.nameFehlt": "Please enter the name in block letters.",
      "unterschrift.leer": "Please sign in the box.",
      "unterschrift.leeren": "Start over",
      "baukasten.vorlagenTitel": "Start from a sample list",
      "baukasten.vorlagenHinweis": "Saves the first hour. Everything loaded is yours afterwards: rename, add, delete. The offer disappears once the first checkpoint exists.",
      "baukasten.vorlagenUmfang": "{{bereiche}} areas, {{punkte}} checkpoints",
      "baukasten.vorlageLaden": "Load",
      "checkliste.keineBereiche": "There are no areas yet. Create them in the checkpoint builder first, then tick them here.",
      "team.keineBereiche": "No areas in the checkpoint builder yet.",
      "baukasten.stilllegen": "Retire",
      "baukasten.wiederAktiv": "Reactivate",
      "baukasten.stillgelegt": "Retired",
      "baukasten.schluessel": "Key",
      "baukasten.schluesselHinweis": "Technical name, cannot be changed later. Lower case and underscore.",
      "baukasten.punktSchluesselHinweis": "Area and name, for example pool.cover.",
      "baukasten.beschriftung": "Label",
      "baukasten.eingabeart": "Input type",
      "baukasten.eingabeartHinweis": "Decides what the employee can tick or enter at the property.",
      "baukasten.art.status": "Check: done, in order, fault, not checked",
      "baukasten.art.number": "Number",
      "baukasten.art.boolean": "Tick off: done or not",
      "baukasten.art.text": "Free text",
      "baukasten.art.photo": "Photo only",
      "baukasten.einheit": "Unit",
      "baukasten.zielVon": "Target from",
      "baukasten.zielBis": "Target to",
      "baukasten.zielHinweis": "If the value is outside, the app asks for a comment right away.",
      "baukasten.fotoPflicht": "Photo required",
      "baukasten.fotoPflichtLang": "The employee must upload a photo for this checkpoint, unless they choose not applicable",
      "baukasten.uebersetztHinweis": "German only. Claude translates English, Spanish and Arabic on save.",
      "checkliste.titel": "Checklists",
      "checkliste.keine": "No checklist has been set up for this property yet.",
      "checkliste.hinzufuegen": "Add checklist",
      "checkliste.bezeichnung": "Label",
      "checkliste.bezeichnungHinweis": "Optional, for example Weekly.",
      "checkliste.zurueckZumObjekt": "To the property",
      "checkliste.vorschau": "What the employee sees",
      "checkliste.vorschauHinweis": "Resolved from template plus deviations, for the chosen month.",
      "checkliste.leer": "Nothing remains for this month.",
      "checkliste.ergaenzt": "added",
      "checkliste.angepasst": "adjusted",
      "checkliste.anpassen": "Adjust",
      "checkliste.abwaehlen": "Remove",
      "checkliste.abgewaehltePunkte": "Checkpoints removed here",
      "checkliste.wiederAufnehmen": "put back",
      "checkliste.fotoPflicht": "Photo required",
      "checkliste.fotoFrei": "No photo needed",
      "checkliste.fotoHinweis": "As in the template means: if the template changes, this property follows.",
      "checkliste.objekthinweis": "Property note",
      "checkliste.objekthinweisHinweis": "Shown next to the checkpoint and replaces on-site training.",
      "checkliste.objekthinweisBeispiel": "Filter unit in the plant room behind the pool house, key number 4",
      "checkliste.anpassungZuruecknehmen": "Undo adjustment",
      "aktion.speichern": "Save",
      "aktion.speichert": "Saving",
      "aktion.abbrechen": "Cancel",
      "aktion.bearbeiten": "Edit",
      "aktion.loeschen": "Delete",
      "aktion.ja": "Yes",
      "aktion.nein": "No",
      "archiv.zeigen": "Show archived",
      "archiv.marke": "Archived",
      "archiv.archivieren": "Archive",
      "archiv.zurueckholen": "Restore",
      "archiv.kundeMitObjekten_one": "This customer still has {{count}} active property. It will be archived as well. Continue?",
      "archiv.kundeMitObjekten_other": "This customer still has {{count}} active properties. They will be archived as well. Continue?",
      "fehler.laden": "Could not load the data",
      "hinweis.hinweis": "Goes to management by email and is not stored anywhere.",
      "hinweis.platzhalter": "What should the boss know?",
      "hinweis.diktieren": "To dictate, use the microphone key on your keyboard.",
      "hinweis.senden": "Send note",
      "hinweis.gesendet": "The note has been sent. Thank you.",
      "hinweis.nochEiner": "Write another note",
      "fehler.speichern": "Saving failed",
      "fehler.seite": "This page does not exist.",
      "kunden.titel": "Customers",
      "kunden.neu": "New customer",
      "kunden.bearbeiten": "Edit customer",
      "kunden.suche": "Search by name, email or phone",
      "kunden.leer": "No customers yet.",
      "kunden.ausgewaehlt_one": "{{count}} customer selected",
      "kunden.ausgewaehlt_other": "{{count}} customers selected",
      "kunden.auswahlAufheben": "Clear selection",
      "kunden.sammelArchivFrage_one": "Archive {{count}} customer and {{objekte}} properties? The properties go with them.",
      "kunden.sammelArchivFrage_other": "Archive {{count}} customers and {{objekte}} properties? The properties go with them.",
      "kunden.sammelZurueckFrage_one": "Restore {{count}} customer?",
      "kunden.sammelZurueckFrage_other": "Restore {{count}} customers?",
      "kunden.anzahl_one": "{{count}} customer",
      "kunden.anzahl_other": "{{count}} customers",
      "kunden.objekte_one": "{{count}} property",
      "kunden.objekte_other": "{{count}} properties",
      "kunden.kontakt": "Contact",
      "kunden.rechnungsadresse": "Billing address",
      "kunden.notizen": "Notes",
      "kunden.art": "Type",
      "kunden.art.private": "Private",
      "kunden.art.company": "Company",
      "kunden.name": "Name",
      "kunden.nameHinweis": "This is how the customer appears in lists and reports.",
      "kunden.firma": "Company name",
      "kunden.steuernummer": "Tax number",
      "kunden.anrede": "Form of address",
      "kunden.briefanrede": "Salutation in the letter",
      "kunden.briefanredeHinweis": "This is how the report text opens. Neutral means nobody is addressed wrongly.",
      "kunden.anredeHelferStarten_one": "Add the salutation for {{count}} customer",
      "kunden.anredeHelferStarten_other": "Add the salutation for {{count}} customers",
      "kunden.anredeHelferStand": "{{fertig}} of {{gesamt}} saved",
      "kunden.anredeHelferBeenden": "Done",
      "kunden.anredeHelferHinweis": "The suggestion is the last word of the display name. The salutation is never guessed, you choose it. Left neutral, the calendar shows the bare name.",
      "kunden.anredeUebernommen": "saved",
      "kunden.anredeKeinVorschlag": "No suggestion, please type it yourself.",
      "kunden.anredename": "Name for the salutation",
      "kunden.anredenameHinweis": "Surname for the formal address, first name for the informal one. Also the heading of the appointment in the calendar.",
      "kunden.anredeNeutral": "Dear Sir or Madam,",
      "kunden.salutation.herr": "Mr",
      "kunden.salutation.frau": "Ms",
      "kunden.salutation.familie": "Family",
      "kunden.salutation.neutral": "Neutral",
      "kunden.anrede.du": "Informal",
      "kunden.anrede.sie": "Formal",
      "kunden.sprache": "Language",
      "kunden.spracheHinweis": "Language of the reports for this customer.",
      "kunden.email": "Email",
      "kunden.emailHinweis": "Separate several addresses with a semicolon. The report then goes to all of them.",
      "kunden.telefon": "Phone",
      "objekte.titel": "Properties",
      "objekte.alle": "All properties",
      "objekte.neu": "New property",
      "objekte.bearbeiten": "Edit property",
      "objekte.suche": "Search by property, town or customer",
      "objekte.leer": "No properties yet.",
      "objekte.leerBeiKunde": "No property has been added for this customer yet.",
      "objekte.anzahl_one": "{{count}} property",
      "objekte.anzahl_other": "{{count}} properties",
      "objekte.name": "Name",
      "objekte.nameHinweis": "For example Villa Son Vida or Finca Andratx.",
      "objekte.kunde": "Customer",
      "objekte.kundeWaehlen": "Please choose",
      "objekte.ohneKoordinate": "no coordinates",
      "objekte.nurOhneKoordinate": "only without coordinates",
      "objekte.koordinateFehlt": "No coordinates stored for this property. Without them the distance when clocking in cannot be calculated.",
      "objekte.koordinateSuchen": "Look up coordinates",
      "objekte.koordinateNichts": "Nothing found on Mallorca for this address. Please enter it manually.",
      "objekte.nurStrasse": "Match without house number, the point sits on the street. Good enough for the distance check.",
      "objekte.koordinateUebernehmen": "Use this",
      "objekte.koordinateAnsehen": "View on the map",
      "objekte.zumKunden": "Go to customer",
      "objekte.lage": "Location",
      "objekte.vertrag": "Contract",
      "objekte.gemeinde": "Municipality",
      "objekte.gemeindeHinweis": "Calvia, Andratx, Pollenca and so on.",
      "objekte.breite": "Latitude",
      "objekte.laenge": "Longitude",
      "objekte.koordinatenHinweis": "Optional. Enables navigation to the property later.",
      "objekte.route": "Start route",
      "objekte.leistung": "Service",
      "objekte.leistungHinweis": "For example full care package.",
      "objekte.beginn": "Contract start",
      "objekte.ende": "Contract end",
      "objekte.poolheizung": "Pool heating available",
      "objekte.poolheizungHinweis": "Records at the property that pool heating is agreed and can be switched on for a stay.",
      "objekte.anfahrt": "Access and directions",
      "objekte.anfahrtHinweis": "Notes for staff. No alarm codes, no key hiding places.",
      "adresse.strasse": "Street and number",
      "adresse.plz": "Postal code",
      "adresse.ort": "Town",
      "adresse.land": "Country",
      "adresse.landHinweis": "Two letters, for example ES or DE.",
      "app.name": "Jornado",
      "recht.datenschutz": "Privacy notice",
      "recht.impressum": "Legal notice",
      "recht.zurueck": "Back to the application",
      "recht.stand": "Version {{datum}}",
      "login.title": "Sign in",
      "login.email": "Email",
      "login.password": "Password",
      "login.zeigen": "Show password",
      "login.verbergen": "Hide password",
      "login.submit": "Sign in",
      "login.pending": "One moment",
      "login.failed": "Email or password is not correct",
      "nav.customers": "Customers",
      "nav.password": "Password",
      "password.title": "Change password",
      "password.hint": "You will need to sign in again afterwards.",
      "password.current": "Current password",
      "password.new": "New password",
      "password.rule": "At least 12 characters, with upper and lower case and a digit.",
      "password.save": "Change",
      "password.cancel": "Cancel",
      "password.failed": "Change not possible",
      "nav.logout": "Sign out",
    }
  },
  es: {
    translation: {
      "objektzahlen.titel": "Cifras de los informes",
      "objektzahlen.hinweis": "Tomadas de los informes aprobados, por lo general uno por semana.",
      "objektzahlen.jeTag": "Consumo por día, para poder comparar los periodos",
      "objektzahlen.tag": "día",
      "objektzahlen.dieseWoche": "Últimos 7 días",
      "objektzahlen.dieserMonat": "Este mes",
      "objektzahlen.vormonat": "Mes anterior",
      "objektzahlen.grundlast": "con la casa vacía",
      "objektzahlen.letzterWert": "Última medición",
      "objektzahlen.legendeVerbrauch": "Consumo por día en {{einheit}}",
      "objektzahlen.legendeWert": "Valor medido",
      "objektzahlen.legendeUeblich": "Habitual en esta casa: {{wert}}",
      "objektzahlen.legendeZiel": "Rango objetivo de {{min}} a {{max}}",
      "objektzahlen.legendeMehr": "Bastante más de lo habitual",
      "objektzahlen.legendeAusserhalb": "Fuera del rango objetivo",
      "objektzahlen.mengeUeberTage_one": "({{menge}} {{einheit}} en {{count}} día)",
      "objektzahlen.mengeUeberTage_other": "({{menge}} {{einheit}} en {{count}} días)",
      "objektzahlen.auffaellig": "Últimamente {{wert}} {{einheit}} al día, cuando aquí lo habitual son unos {{basis}}. En ese periodo había alguien en la casa, lo que suele explicar la diferencia.",
      "objektzahlen.leckverdacht": "Últimamente {{wert}} {{einheit}} al día aunque no había nadie en la casa. Con la casa vacía, aquí lo habitual son unos {{basis}}. Apunta a una fuga.",
      "objektzahlen.tabelleAuf": "Mostrar las cifras",
      "objektzahlen.tabelleZu": "Ocultar las cifras",
      "objektzahlen.ausserhalb": "fuera de rango",
      "einrichtung.ansprache_one": "{{count}} cliente sin tratamiento ni apellido, el calendario muestra entonces solo el nombre mostrado",
      "einrichtung.ansprache_other": "{{count}} clientes sin tratamiento ni apellido, el calendario muestra entonces solo el nombre mostrado",
      "objekte.helferStarten_one": "Proponer coordenadas para {{count}} propiedad",
      "objekte.helferStarten_other": "Proponer coordenadas para las {{count}} propiedades",
      "objekte.helferStand": "{{geprueft}} de {{gesamt}} comprobadas",
      "objekte.helferBeenden": "Listo",
      "objekte.helferWartet": "esperando",
      "objekte.helferUebernommen": "Coordenadas guardadas",
      "einrichtung.titel": "Pendiente de configurar",
      "einrichtung.hinweis": "Ningún programa puede hacer esto por ti. Lo hecho desaparece solo de esta lista.",
      "einrichtung.hin": "ir",
      "einrichtung.vertrag_one": "{{count}} empleado sin horas semanales o fecha de alta",
      "einrichtung.vertrag_other": "{{count}} empleados sin horas semanales o fecha de alta",
      "einrichtung.urlaub_one": "{{count}} empleado sin días de vacaciones para este año",
      "einrichtung.urlaub_other": "{{count}} empleados sin días de vacaciones para este año",
      "einrichtung.baukasten": "Todavía no hay ningún punto de control; sin él el informe en el inmueble queda vacío",
      "einrichtung.fahrzeug": "Ningún vehículo dado de alta, por eso nadie puede registrar repostajes",
      "einrichtung.handbuch": "Todavía no hay ningún artículo del manual",
      "einrichtung.koordinate_one": "{{count}} propiedad sin coordenadas",
      "einrichtung.koordinate_other": "{{count}} propiedades sin coordenadas",
      "einrichtung.zugang_one": "{{count}} propiedad sin datos de acceso",
      "einrichtung.zugang_other": "{{count}} propiedades sin datos de acceso",
      "einrichtung.ortung": "La localización está activada. Debe existir la información firmada al personal según el art. 90 LOPDGDD",
      "einrichtung.firmenangaben_one": "Falta {{count}} dato obligatorio de la empresa, el aviso legal queda incompleto",
      "einrichtung.firmenangaben_other": "Faltan {{count}} datos obligatorios de la empresa, el aviso legal queda incompleto",
      "zeit.empfangenAm": "Recibido por el servidor el {{zeit}}",
      "netz.abmeldenTrotzWartend_one": "{{count}} entrada aún no se ha enviado. Al cerrar sesión se perderá. ¿Cerrar sesión igualmente?",
      "netz.abmeldenTrotzWartend_other": "{{count}} entradas aún no se han enviado. Al cerrar sesión se perderán. ¿Cerrar sesión igualmente?",
      "tag.stempel.tag.start": "Jornada iniciada",
      "tag.stempel.tag.ende": "Jornada finalizada",
      "tag.stempel.einsatz.start": "Servicio iniciado",
      "tag.stempel.einsatz.ende": "Servicio finalizado",
      "tag.stempel.pause": "Pausa iniciada",
      "tag.stempel.pause.ende": "Pausa finalizada",
      "zeit.ohneNetz": "Fichado sin conexión",
      "netz.ohneNetz": "Sin conexión. Lo que introduzcas se guarda en el dispositivo y se envía más tarde.",
      "netz.wartet_one": "{{count}} entrada pendiente",
      "netz.wartet_other": "{{count}} entradas pendientes",
      "netz.sendet": "Enviando",
      "netz.jetztSenden": "Enviar ahora",
      "netz.abgelehnt_one": "{{count}} entrada rechazada",
      "netz.abgelehnt_other": "{{count}} entradas rechazadas",
      "netz.abgelehntTitel": "Entradas rechazadas",
      "netz.nichtsAbgelehnt": "No queda nada.",
      "netz.anzeigen": "Ver",
      "netz.schliessen": "Cerrar",
      "netz.nochmal": "Intentar de nuevo",
      "netz.verwerfen": "Descartar",
      "netz.verwerfenFrage": "¿Descartar esta entrada definitivamente? Se perderá.",
      "netz.versuche_one": "{{count}} intento",
      "netz.versuche_other": "{{count}} intentos",
      "netz.ausAblage": "Sin conexión. Se muestra el estado del {{zeit}}.",
      "netz.gemerkt": "Guardado sin conexión, se enviará más tarde.",
      "app.neueFassung": "Hay una versión nueva lista.",
      "app.neueFassungLaden": "Cargar ahora",
      "nav.pruefungen": "Reports",
      "nav.notizen": "Notas",
      "pruefung.titel": "Reports",
      "pruefung.neu": "Nuevo report",
      "pruefung.neuHinweis": "Elige propiedad y lista. La lista se congela al empezar.",
      "pruefung.starten": "Empezar report",
      "pruefung.status": "Estado",
      "pruefung.alleStatus": "Todos",
      "pruefung.leer": "Todavía no hay reports.",
      "pruefung.zurFreigabe_one": "{{count}} informe pendiente de aprobación",
      "pruefung.zurFreigabe_other": "{{count}} informes pendientes de aprobación",
      "pruefung.leerBeiObjekt": "Esta propiedad aún no tiene reports.",
      "pruefung.keineCheckliste": "Esta propiedad no tiene ninguna lista activa.",
      "pruefung.anzahl_one": "{{count}} report",
      "pruefung.anzahl_other": "{{count}} reports",
      "pruefung.nummer": "Report {{nummer}}",
      "pruefung.fortschritt": "{{erledigt}} de {{gesamt}} registrados",
      "pruefung.maengel_one": "{{count}} defecto",
      "pruefung.maengel_other": "{{count}} defectos",
      "pruefung.status.draft": "Borrador",
      "pruefung.status.submitted": "Enviado",
      "pruefung.status.changes_requested": "Devuelto",
      "pruefung.status.approved": "Aprobado",
      "pruefung.status.sent": "Enviado al cliente",
      "pruefung.status.cancelled": "Retirado",
      "pruefung.einreichen": "Enviar",
      "pruefung.freigeben": "Aprobar",
      "pruefung.zurueckgeben": "Devolver",
      "pruefung.zuruecknehmen": "Retirar",
      "pruefung.loeschen": "Borrar definitivamente",
      "pruefung.loeschenFrage": "¿Borrar de forma definitiva? No se puede deshacer.",
      "pruefung.loeschenJa": "Sí, borrar",
      "pruefung.loeschenFehler": "No se ha podido borrar el report",
      "pruefung.pdf": "PDF",
      "pruefung.pdfFehler": "No se ha podido crear el PDF",
      "sprache.de": "DE",
      "sprache.en": "EN",
      "pruefung.rueckgabeGrund": "¿Qué falta o hay que corregir?",
      "pruefung.zurueckgegeben": "Devuelto por la dirección",
      "pruefung.nochOffen": "Todavía falta",
      "pruefung.grund.offen": "sin registrar",
      "pruefung.grund.mangel_ohne_kommentar": "defecto sin comentario",
      "pruefung.grund.wert_ohne_kommentar": "valor fuera del objetivo sin comentario",
      "pruefung.grund.foto_fehlt": "defecto sin foto",
      "foto.aufnehmen": "Foto",
      "foto.galerie": "De la galería",
      "foto.laedtAnzahl_one": "Subiendo {{count}} foto",
      "foto.laedtAnzahl_other": "Subiendo {{count}} fotos",
      "foto.anderes": "Otra foto",
      "foto.belegAufnehmen": "Fotografiar el ticket",
      "foto.belegPflicht": "Sin foto no se puede guardar",
      "foto.laedt": "Subiendo",
      "foto.entfernen": "Quitar foto",
      "foto.pflicht": "En este punto la foto es obligatoria",
      "foto.fehler": "No se ha podido guardar la foto",
      "pruefung.ergebnis.done": "Hecho",
      "pruefung.ergebnis.ok": "Comprobado, correcto",
      "pruefung.ergebnis.fault": "Comprobado, con defecto",
      "pruefung.ergebnis.na": "No comprobado",
      "pruefung.ja": "Hecho",
      "pruefung.nein": "No aplica",
      "pruefung.wert": "Valor",
      "pruefung.ausserhalb": "Fuera del objetivo",
      "pruefung.kommentar": "Comentario",
      "pruefung.kommentarPflicht": "Comentario obligatorio",
      "pruefung.kommentarFehlt": "Sin comentario no se puede enviar el report.",
      "pruefung.kundentext": "Texto para el cliente",
      "pruefung.kundentextHinweis": "Este texto aparece en el PDF que recibe el propietario.",
      "pruefung.gespeichert": "Guardado",
      "ki.vorschlag": "Propuesta de Claude",
      "ki.denkt": "Claude está escribiendo",
      "ki.marke": "Propuesto por Claude",
      "ki.markeBearbeitet": "De Claude, editado",
      "ki.hinweis": "La propuesta no se guarda ni se envía. Primero leer, luego guardar.",
      "ki.uebersetzen": "Traducir",
      "ki.fehler": "Claude no ha podido ayudar ahora",
      "ki.rest": "restantes: {{n}}",
      "ki.aufgebraucht": "Agotado. El texto se puede seguir editando a mano.",
      "versand.titel": "Envío al propietario",
      "versand.hinweis": "El Jornado Report se envía al cliente en PDF. Aquí es donde sale de la empresa.",
      "versand.an": "Para",
      "versand.kopie": "Copia oculta",
      "versand.betreff": "Asunto",
      "versand.anhang": "Adjunto",
      "versand.anhangPdf": "Jornado Report en PDF ({{sprache}})",
      "versand.senden": "Enviar al cliente",
      "versand.erneut": "Enviar de nuevo",
      "versand.frage": "¿Enviar de verdad a {{an}}?",
      "versand.ja": "Sí, enviar",
      "versand.laeuft": "Enviando",
      "versand.bereits": "Enviado el {{datum}} a {{an}}",
      "versand.fehler": "No se ha podido enviar el report",
      "versand.letzterFehler": "Último intento el {{datum}}: {{fehler}}",
      "nav.auftraege": "Órdenes",
      "auftraege.titel": "Órdenes de trabajo",
      "auftraege.anzahl_one": "{{count}} orden",
      "auftraege.anzahl_other": "{{count}} órdenes",
      "auftraege.leer": "No hay órdenes en este estado.",
      "auftraege.loeschenSicher": "¿Eliminar este encargo definitivamente? El historial y las fotos se van con él. Las horas fichadas se mantienen, solo pierden el vínculo.",
      "auftraege.geloesteZeiten_one": "{{count}} fichaje estaba vinculado a este encargo. Se mantiene en el registro, sin encargo.",
      "auftraege.geloesteZeiten_other": "{{count}} fichajes estaban vinculados a este encargo. Se mantienen en el registro, sin encargo.",
      "auftraege.neu": "Nueva orden",
      "auftraege.nummer": "Orden {{nummer}}",
      "auftraege.offen": "Pendientes",
      "auftraege.alle": "Todas",
      "auftraege.zustand": "Estado",
      "auftraege.objekt": "Propiedad",
      "auftraege.titel1": "Título",
      "auftraege.beschreibung": "Descripción",
      "auftraege.prioritaet": "Prioridad",
      "auftraege.termin": "Fecha",
      "auftraege.zugewiesen": "Asignada a",
      "auftraege.ohneZuweisung": "Sin asignar",
      "auftraege.fotos": "Fotos",
      "auftraege.keineFotos": "Todavía no hay fotos.",
      "auftraege.verlauf": "Historial",
      "auftraege.notiz": "Guardar nota",
      "auftraege.notizPlatzhalter": "Nota breve para los compañeros",
      "auftraege.zurueckZurListe": "Volver a la lista",
      "auftraege.ausMangel": "Crear una orden por este defecto",
      "auftraege.status.open": "Pendiente",
      "auftraege.status.scheduled": "Programada",
      "auftraege.status.in_progress": "En curso",
      "auftraege.status.waiting": "En espera",
      "auftraege.status.done": "Resuelta",
      "auftraege.status.cancelled": "Retirada",
      "auftraege.prio.low": "Baja",
      "auftraege.prio.normal": "Normal",
      "auftraege.prio.high": "Alta",
      "auftraege.prio.urgent": "Urgente",
      "auftraege.fotoart.before": "Antes",
      "auftraege.fotoart.after": "Después",
      "auftraege.fotoart.receipt": "Justificante",
      "auftraege.fotoart.other": "Otros",
      "auftraege.fotoHinzu.before": "Añadir antes",
      "auftraege.fotoHinzu.after": "Añadir después",
      "auftraege.fotoHinzu.receipt": "Añadir justificante",
      "auftraege.ereignis.created": "Creada",
      "auftraege.ereignis.assigned": "Asignación cambiada",
      "auftraege.ereignis.status_changed": "Estado cambiado",
      "auftraege.ereignis.note": "Nota",
      "system.titel": "Estado del sistema",
      "nav.zeiten": "Horario",
      "nav.meinTag": "Mi día",
      "nav.meineWoche": "Mi semana",
      "nav.meineZeit": "Mis horas",
      "nav.antraege": "Solicitudes",
      "nav.team": "Equipo",
      "nav.fuhrpark": "Repostajes",
      "nav.handbuch": "Manual",
      "nav.hinweis": "Aviso al jefe",
      "fuhrpark.titel": "Libro de repostajes",
      "fuhrpark.hinweis": "Vehículo, kilómetros, foto del ticket.",
      "fuhrpark.neuerEintrag": "Añadir repostaje",
      "fuhrpark.neuesFahrzeug": "Añadir vehículo",
      "fuhrpark.fahrzeug": "Vehículo",
      "fuhrpark.kilometerstand": "Kilómetros",
      "fuhrpark.kmHinweis": "El dato que se olvida nada más arrancar.",
      "fuhrpark.literLabel": "Litros",
      "fuhrpark.betrag": "Importe en euros",
      "fuhrpark.notiz": "Nota",
      "fuhrpark.beleg": "Ticket",
      "fuhrpark.belegHinweis": "Foto del ticket, opcional.",
      "fuhrpark.dreiAngaben": "Bastan tres datos. Los litros y el importe se leen del ticket.",
      "fuhrpark.belegPflicht": "Foto del ticket. Sin ticket no se puede registrar nada.",
      "fuhrpark.betragOffen": "importe pendiente",
      "fuhrpark.vomBeleg": "leído del ticket",
      "fuhrpark.berichtigen": "Corregir las cifras",
      "fuhrpark.nochmalLesen": "Leer el ticket otra vez",
      "fuhrpark.ohneBetrag_one": "{{count}} ticket sin importe",
      "fuhrpark.ohneBetrag_other": "{{count}} tickets sin importe",
      "fuhrpark.belegZeigen": "Ver el ticket",
      "fuhrpark.summe": "Total",
      "fuhrpark.liter": "Repostado",
      "fuhrpark.kmStand": "{{km}} km",
      "fuhrpark.leer": "Este mes no se ha registrado nada.",
      "fuhrpark.keineFahrzeuge": "Todavía no hay ningún vehículo. Avisa a la oficina.",
      "fuhrpark.keineFahrzeugeChef": "Añade primero un vehículo, si no nadie puede registrar repostajes.",
      "fuhrpark.kennzeichen": "Matrícula",
      "fuhrpark.bezeichnung": "Nombre",
      "fuhrpark.bezeichnungHinweis": "Como llamáis al coche, p. ej. \"furgoneta blanca\".",
      "fuhrpark.modell": "Modelo",
      "fuhrpark.kraftstoff": "Combustible",
      "handbuch.titel": "Manual",
      "handbuch.hinweis": "Instrucciones de trabajo y normas internas.",
      "handbuch.suche": "Buscar",
      "handbuch.kategorie": "Categoría",
      "handbuch.alleKategorien": "todas",
      "handbuch.leer": "No hay nada.",
      "handbuch.neu": "Añadir artículo",
      "handbuch.kennung": "Clave",
      "handbuch.kennungHinweis": "Corta y sin espacios, p. ej. cierre-invierno-piscina.",
      "handbuch.sichtbarkeit": "Visible para",
      "handbuch.fuerAlle": "todos los empleados",
      "handbuch.nurChef": "solo dirección",
      "handbuch.artikelTitel": "Título",
      "handbuch.artikelText": "Texto",
      "handbuch.archivieren": "Archivar",
      "handbuch.ersatzsprache": "en alemán, todavía no está en tu idioma",
      "handbuch.deutschPflicht": "El título y el texto en alemán son obligatorios, el resto es opcional.",
      "rechte.nurBuero": "Esta página es para la oficina.",
      "rechte.nurBueroHinweis": "Tu acceso no la incluye. Si necesitas algo de aquí, avisa a la oficina.",
      "rechte.zurueck": "Volver a mi día",
      "einladung.titel": "Bienvenido",
      "einladung.hinweis": "Elige una contraseña, mínimo doce caracteres.",
      "einladung.passwort": "Contraseña",
      "einladung.wiederholen": "Repite la contraseña",
      "einladung.ungleich": "Las dos contraseñas no coinciden.",
      "einladung.ungueltig": "Este enlace no es válido, ha caducado o ya se ha usado.",
      "einladung.starten": "Empezar",
      "meinezeit.titel": "Mis horas",
      "meinezeit.ist": "Trabajado",
      "meinezeit.soll": "Previsto",
      "meinezeit.saldoMonat": "Saldo del mes",
      "meinezeit.tage": "Días",
      "meinezeit.nichtGestempelt": "sin fichar",
      "meinezeit.saldoGesamt": "Horas extra en total, desde {{seit}}",
      "meinezeit.rechnung": "{{wochenstunden}} horas semanales · trabajado {{ist}} · previsto {{soll}}",
      "meinezeit.ohneSoll": "Todavía no tienes horas semanales registradas. Sin ellas no se puede calcular el saldo. Avisa a la oficina.",
      "antrag.titel": "Solicitudes",
      "antrag.hinweis": "Vacaciones, baja y corrección de horario.",
      "antrag.hinweisChef": "Solicitudes pendientes de tu equipo.",
      "antrag.neuAbwesenheit": "Vacaciones o baja",
      "antrag.neuKorrektur": "Corrección de horario",
      "antrag.abwesenheiten": "Vacaciones y ausencias",
      "antrag.korrekturen": "Correcciones de horario",
      "antrag.leer": "No hay nada.",
      "antrag.artLabel": "Tipo",
      "antrag.art.vacation": "Vacaciones",
      "antrag.art.sick": "Baja",
      "antrag.art.unpaid": "Sin sueldo",
      "antrag.art.special": "Permiso especial",
      "antrag.art.training": "Formación",
      "antrag.von": "Desde",
      "antrag.bis": "Hasta",
      "antrag.bisHinweis": "Déjalo vacío para un solo día.",
      "antrag.halberErster": "Primer día a medias",
      "antrag.halberLetzter": "Último día a medias",
      "antrag.grund": "Observación",
      "antrag.datum": "Fecha",
      "antrag.einreichen": "Enviar",
      "antrag.genehmigen": "Aprobar",
      "antrag.ablehnen": "Rechazar",
      "antrag.zurueckziehen": "Retirar",
      "antrag.entschieden": "Decidido el {{am}} por {{von}}",
      "antrag.tage_one": "{{count}} día",
      "antrag.tage_other": "{{count}} días",
      "antrag.status.requested": "pendiente",
      "antrag.status.approved": "aprobada",
      "antrag.status.rejected": "rechazada",
      "antrag.status.cancelled": "retirada",
      "antrag.korrekturHinweis": "Indica cuándo trabajaste realmente. La oficina decide; solo entonces cambia el registro.",
      "antrag.keineBuchung": "Ese día no hay ningún registro. La solicitud creará entonces una jornada completa.",
      "antrag.korrigiertBuchung": "Se corrige el registro de {{von}} a {{bis}}.",
      "antrag.welcheBuchung": "Qué registro",
      "antrag.buchungWaehlen": "Elige uno",
      "team.titel": "Equipo",
      "team.hinweis": "Accesos, horas semanales y festivos.",
      "team.einladen": "Invitar a un empleado",
      "team.name": "Nombre",
      "team.email": "Correo",
      "team.emailHinweis": "Con esto inicia sesión. Cámbialo si la dirección ya no está disponible; todos los datos siguen con esta persona.",
      "team.zugangHinweis": "Si alguien ya no puede entrar porque perdió la contraseña o el buzón: corrige la dirección arriba, guarda y envía aquí una nueva invitación. Él mismo elige una contraseña nueva. No se crea una segunda cuenta, los tiempos y los informes se mantienen.",
      "team.zugangNeu": "Volver a crear el acceso",
      "team.zugangGesendet": "Invitación enviada a {{an}}. Vale siete días.",
      "team.zugangOhneMail": "No hay servidor de correo configurado. Pasa este enlace, vale siete días:",
      "team.rolleLabel": "Rol",
      "team.rolle.admin": "Dirección",
      "team.rolle.lead": "Encargado",
      "team.rolle.employee": "Empleado",
      "team.einladungSenden": "Enviar invitación",
      "team.einladenHinweis": "Recibe un enlace por correo y elige su propia contraseña. Tú no la ves.",
      "team.keinVersand": "No se envía correo. Dale este enlace en persona, vale siete días.",
      "team.wochenstunden": "Horas semanales",
      "team.wochenstundenHinweis": "Del contrato. Sin este valor no hay horas extra.",
      "team.wochenstundenWert": "{{stunden}} horas semanales",
      "team.ohneWochenstunden": "Sin horas semanales registradas",
      "team.eintritt": "Fecha de alta",
      "team.eintrittHinweis": "El saldo total cuenta desde aquí.",
      "team.faehrtMit": "Va con",
      "team.faehrtMitHinweis": "Para quien no tiene coche propio. La propuesta semanal nunca lo planifica solo, sino en las citas de su conductor.",
      "team.faehrtSelbst": "Conduce él mismo",
      "team.wohnort": "Localidad",
      "team.wohnortHinweis": "Solo la localidad, no la dirección. El trayecto hasta allí es tiempo propio; solo decide por qué extremo empieza la ruta optimizada. La coordenada se busca al guardar.",
      "team.planPosition": "Orden en el plan de trabajo",
      "team.planPositionHinweis": "Un número bajo va a la izquierda. Vacío significa al final, allí por nombre. Solo visualización: el número no indica rango ni cualificación.",
      "team.imDienstplan": "Columna en el plan de trabajo",
      "team.imDienstplanHinweis": "Quien nunca se planifica no necesita una columna vacía. Ocultar no bloquea nada: si recibe una cita, la columna reaparece ese día.",
      "team.imDienstplanAn": "Mostrar columna propia",
      "team.wohnortOhneTreffer": "No se encontró ninguna coordenada para esta localidad. El sentido de la ruta se mantiene.",
      "team.faehrtMitWert": "va con {{name}}",
      "team.nurAushilfe": "{{abteilung}}: solo como refuerzo",
      "team.abteilungAushilfe": "{{abteilung}} (refuerzo)",
      "team.seit": "desde {{datum}}",
      "team.bis": "hasta {{datum}}",
      "team.austritt": "Baja",
      "team.austrittHinweis": "Finaliza la relación laboral y bloquea el acceso.",
      "team.austrittWarnung": "Se bloquea el acceso, se cierran todos los dispositivos, se eliminan los turnos futuros y las órdenes abiertas quedan libres para reasignar. La jornada registrada y los reports se conservan íntegros.",
      "team.austrittDatum": "Último día trabajado",
      "team.austrittGrund": "Motivo",
      "team.austrittGrundHinweis": "Opcional, solo queda en el registro",
      "team.austrittBestaetigen": "Tramitar la baja",
      "team.austrittFertig": "{{name}} ha causado baja",
      "team.bilanzGeraete_one": "Un dispositivo cerrado",
      "team.bilanzGeraete_other": "{{count}} dispositivos cerrados",
      "team.bilanzDienste_one": "Un turno planificado eliminado",
      "team.bilanzDienste_other": "{{count}} turnos planificados eliminados",
      "team.bilanzAuftraege_one": "Una orden pendiente de reasignar",
      "team.bilanzAuftraege_other": "{{count}} órdenes pendientes de reasignar",
      "team.bilanzZeiten": "La jornada registrada y los reports se conservan.",
      "team.wiedereintritt": "Reincorporar",
      "team.aktiv": "Acceso activo",
      "team.stillgelegt": "desactivado",
      "team.zustand.arbeitet": "trabajando desde las {{zeit}}",
      "team.zustand.pause": "en pausa",
      "team.zustand.vergessen": "olvidó fichar la salida",
      "team.zustand.nichtDa": "sin fichar",
      "team.feiertage": "Festivos",
      "leistung.titel": "Horas previstas por semana",
      "leistung.gesamt": "{{stunden}} en total",
      "leistung.leer": "Todavía no hay horas previstas.",
      "wochentag.1": "Lunes",
      "wochentag.2": "Martes",
      "wochentag.3": "Miércoles",
      "wochentag.4": "Jueves",
      "wochentag.5": "Viernes",
      "wochentag.6": "Sábado",
      "wochentag.7": "Domingo",
      "leistung.festerTag": "Día fijo",
      "leistung.festerTagHinweis": "Solo si el día realmente no se puede mover.",
      "leistung.festeZeit": "Hora fija",
      "leistung.festeZeitHinweis": "Solo junto con un día fijo. Vacío significa: día fijo, hora libre.",
      "leistung.rhythmus": "Ritmo",
      "leistung.rhythmusHinweis": "Para dos casas contiguas que se alternan. Lo que no toca esta semana tampoco aparece en la necesidad. En el informe del cliente cuenta la media: cada dos semanas es la mitad del tiempo al mes.",
      "leistung.jedeWoche": "Cada semana",
      "leistung.alleWochen": "Cada {{wochen}} semanas",
      "leistung.rhythmusAb": "Primera semana con servicio",
      "leistung.rhythmusAbHinweis": "El recuento empieza en esta semana. Basta cualquier día, el sistema toma el lunes de esa semana.",
      "leistung.rhythmusZeile": "Cada {{wochen}} semanas, contando desde la semana del {{ab}}",
      "leistung.freiPlanbar": "Planificable libremente",
      "leistung.festTagZeit": "Fijo: {{tag}} a las {{zeit}}",
      "leistung.festNurTag": "Fijo: {{tag}}, hora libre",
      "leistung.neu": "Añadir horas previstas",
      "leistung.loeschenSicher": "¿Borrar estas horas previstas?",
      "leistung.stundenProWoche": "Horas por semana",
      "leistung.stundenHinweis": "Horas de trabajo, no tiempo de calendario: cuatro horas de jardín son también dos jardineros durante dos horas.",
      "leistung.von": "Válido desde",
      "leistung.bis": "Válido hasta",
      "leistung.zeitraumHinweis": "Vacío significa: siempre válido. Añade una línea para verano y otra para invierno.",
      "leistung.abDatum": "desde {{datum}}",
      "leistung.bisDatum": "hasta {{datum}}",
      "team.abteilungen": "Departamentos",
      "team.abteilungenHinweis": "Para qué se puede asignar a esta persona. Puede echar una mano en cualquier sitio; el plan lo señalará.",
      "team.abteilungenListeHinweis": "Jardín, piscina, limpieza, técnica. Un departamento nunca se borra, solo se desactiva: de él dependen citas y horas previstas del pasado.",
      "team.abteilungName": "Nombre del departamento",
      "team.abteilungHinzu": "Crear departamento",
      "team.abteilungBelegt": "{{menschen}} empleados · {{objekte}} inmuebles",
      "team.stilllegen": "Desactivar",
      "team.wiederAufnehmen": "Reactivar",
      "team.jahr": "Año",
      "team.feiertagName": "Nombre",
      "team.feiertagHinzu": "Añadir",
      "team.feiertageHinweis": "Una lista mantenida a mano, porque en Mallorca conviven los festivos nacionales, los baleares y los locales. Un festivo baja el previsto en un día laborable.",
      "aktion.fertig": "Listo",
      "nav.plan": "Planificación",
      "tag.titel": "Hola {{name}}",
      "tag.nichtBegonnen": "Tu jornada aún no ha empezado.",
      "tag.beginnen": "Empezar jornada",
      "tag.beenden": "Terminar jornada",
      "tag.termine": "Hoy",
      "tag.keineTermine": "Hoy no hay nada planificado.",
      "tag.navigieren": "Navegar",
      "tag.einsatzStart": "Empezar visita",
      "tag.einsatzEnde": "Terminar visita",
      "tag.checkliste": "Lista",
      "tag.checklisteWaehlen": "¿Qué lista de control?",
      "tag.wegfahrtTitel": "Queda un servicio abierto",
      "tag.wegfahrtText": "En {{objekt}} hay un servicio en marcha desde las {{seit}}. ¿Cuándo te fuiste de allí?",
      "tag.wegfahrtFahrt_one": "Unos {{count}} minuto de viaje desde allí hasta aquí",
      "tag.wegfahrtFahrt_other": "Unos {{count}} minutos de viaje desde allí hasta aquí",
      "tag.wegfahrtFrage": "Salida a las",
      "tag.wegfahrtUebernehmen": "Aplicar y empezar",
      "tag.wegfahrtEben": "Estuve allí hasta ahora mismo",
      "tag.wegfahrtUngueltig": "La hora debe ser posterior al inicio y no puede estar en el futuro.",
      "tag.laeuft": "en curso",
      "tag.erledigt": "hecho",
      "tag.imEinsatz": "En {{objekt}}, desde las {{seit}}",
      "tag.gestempelt": "Registrado hoy",
      "tag.ungeplant": "no planificada",
      "tag.ungeplantOeffnen": "Visita no planificada",
      "tag.ungeplantHinweis": "Solo si no hay una cita para ello. La oficina la ve como no planificada.",
      "tag.ungeplantLaeuft": "Visita no planificada en {{objekt}}, desde las {{seit}}",
      "tag.keineCheckliste": "Esta propiedad no tiene ninguna lista configurada.",
      "plan.titel": "Planificación",
      "plan.ansichtTag": "Día",
      "plan.ansichtWoche": "Semana",
      "plan.terminAendern": "Modificar la cita",
      "plan.datum": "Fecha",
      "plan.frei": "libre",
      "plan.loeschenSicher": "¿Eliminar esta cita?",
      "plan.ziehenHinweis": "Arrastrar mueve una cita: al lado, a otro empleado; arriba o abajo, a otra hora; a un día de la barra, a otro día. Al hacer clic se abre para modificarla o eliminarla.",
      "plan.termineZahl_one": "{{count}} cita",
      "plan.termineZahl_other": "{{count}} citas",
      "plan.konflikteZahl_one": "{{count}} conflicto",
      "plan.konflikteZahl_other": "{{count}} conflictos",
      "plan.hinweis": "Lo que está aquí es lo que los empleados ven como su día.",
      "plan.zurueck": "Semana anterior",
      "plan.vor": "Semana siguiente",
      "plan.heute": "Esta semana",
      "plan.neu": "Cita",
      "plan.neuerTermin": "Nueva cita el {{tag}}",
      "plan.wiederholungen": "Semanas",
      "plan.wiederholungenHinweis": "1 significa una vez. 12 crea doce semanas por adelantado.",
      "plan.notiz": "Nota para el empleado",
      "plan.konfliktAbwesenheit": "Ausencia aprobada: {{art}}",
      "plan.konfliktUeberschneidung": "Se solapa con otro turno",
      "plan.konfliktFeiertag": "Festivo: {{name}}",
      "plan.ohneKoordinate": "Propiedad sin coordenadas, sin control de distancia",
      "plan.gestempelt": "Aquí ya se ha fichado",
      "plan.ansichtBedarf": "Necesidad",
      "plan.abteilung": "Departamento",
      "plan.ohneAbteilung": "Sin departamento",
      "plan.team": "Equipo",
      "plan.teamHinweis": "Se pueden elegir varios. Cuatro horas de jardín son dos jardineros durante dos horas.",
      "plan.teamZahl_one": "{{count}} persona",
      "plan.teamZahl_other": "{{count}} personas",
      "plan.gemeinsamMit": "Junto con {{namen}}",
      "plan.arbeitsstunden_one": "{{stunden}} de trabajo, una persona",
      "plan.arbeitsstunden_other": "{{stunden}} de trabajo, {{count}} personas juntas",
      "plan.konfliktFachfremd": "No está dado de alta en {{abteilung}}",
      "plan.bedarfLeer": "Ningún inmueble tiene horas previstas.",
      "plan.bedarfOffen_one": "{{count}} servicio no está planificado del todo esta semana.",
      "plan.bedarfOffen_other": "{{count}} servicios no están planificados del todo esta semana.",
      "plan.bedarfObjekt": "Inmueble",
      "plan.bedarfSoll": "Previsto",
      "plan.bedarfGeplant": "Planificado",
      "plan.bedarfRest": "Pendiente",
      "plan.farbeLaeuft": "Morado: alguien está fichado ahora mismo",
      "plan.farbeBeendet": "Verde: visita terminada",
      "plan.notizHinweis": "Permanente en el inmueble. El empleado la ve en negro.",
      "plan.aenderung": "Cambio para este día",
      "plan.aenderungHinweis": "Aparece en rojo arriba del todo en la cita del empleado. Déjelo vacío si hoy no cambia nada.",
      "plan.aenderungGelesen": "Leído por {{name}} el {{zeit}}.",
      "plan.aenderungUngelesen": "Todavía sin leer.",
      "plan.aenderungUngelesenKurz": "sin leer",
      "tag.aenderung": "Hoy es distinto",
      "tag.aenderungGelesen": "Leído",
      "tag.aenderungQuittiert": "Marcado como leído.",
      "notiz.titel": "Nota interna",
      "pruefung.team": "Están rellenando este informe juntos: {{namen}}. Repártanse la lista, si no uno sobrescribe al otro.",
      "pruefung.nichtGespeichert": "No se ha guardado. Revise la entrada y toque otra vez fuera del campo.",
      "pruefung.fortschrittGesamt": "{{erledigt}} de {{gesamt}} en el informe completo",
      "pruefung.nurMeineBereiche": "Ve las áreas que cubre su departamento hoy. El resto lo rellena su compañero.",
      "pruefung.weitereFotos": "Más fotos",
      "pruefung.weitereFotosHinweis": "Imágenes que no pertenecen a ningún punto concreto: la ronda, el acceso, la impresión general. Aparecen al final del informe, sin encabezado.",
      "team.abteilungBereich": "Áreas en el informe",
      "team.abteilungBereichHinweis": "Qué puntos de control ve este departamento en el informe. Nada marcado significa todos.",
      "muster.titel": "Informes de muestra",
      "wasser.titel": "Consumo de agua",
      "wasser.ruhig": "Ningún inmueble consume ahora mismo bastante más de lo habitual.",
      "wasser.auffaellige_one": "{{count}} inmueble consume bastante más de lo habitual. Merece una revisión.",
      "wasser.auffaellige_other": "{{count}} inmuebles consumen bastante más de lo habitual. Merece una revisión.",
      "wasser.objekt": "Cliente e inmueble",
      "wasser.proTag": "m³ al día",
      "wasser.ueblich": "habitual",
      "wasser.woche": "últimos 7 días",
      "wasser.monat": "mes al día",
      "wasser.vormonat": "mes anterior",
      "wasser.abgelesen": "Lectura",
      "wasser.marke": "llamativo",
      "wasser.tage_one": "en {{count}} día",
      "wasser.tage_other": "en {{count}} días",
      "wasser.alleZeigen": "Ver los {{count}} inmuebles",
      "wasser.hinweis": "Se compara el consumo por día con lo habitual en este inmueble: una casa vacía con semanas vacías anteriores, una ocupada con semanas ocupadas. El rojo con distintivo significa vacía y aun así bastante más de lo habitual, y ese es el caso que conviene revisar. El ámbar solo significa más de lo habitual. Un inmueble sin estancias registradas cuenta como vacío.",
      "wasser.verdacht_one": "{{count}} inmueble estaba vacío y aun así consumió bastante más de lo habitual. Ese es el caso que conviene revisar.",
      "wasser.verdacht_other": "{{count}} inmuebles estaban vacíos y aun así consumieron bastante más de lo habitual. Esos son los casos que conviene revisar.",
      "wasser.haus": "Casa",
      "wasser.hausLeer": "vacía",
      "wasser.hausBelegt_one": "ocupada, {{count}} día",
      "wasser.hausBelegt_other": "ocupada, {{count}} días",
      "wasser.grundlast": "vacía habitual",
      "wasser.markeMehr": "más de lo habitual",
      "wasser.vergleich.leer": "semanas vacías",
      "wasser.vergleich.belegt": "semanas ocupadas",
      "wasser.vergleich.alle": "todas las semanas",
      "muster.hinweis": "Crea informes completos y aprobados para un cliente con un solo inmueble, dos por semana, con contador de agua y valores de piscina. Solo para enseñar: nunca se envían, llevan la nota \"informe de muestra\" dentro de la oficina y se pueden quitar en cualquier momento.",
      "muster.kunde": "Cliente",
      "muster.kundeWaehlen": "Elija uno",
      "muster.monat": "Mes",
      "muster.anzahl": "Cantidad",
      "muster.anzahlHinweis": "Martes y viernes, doce como máximo",
      "muster.anlegen": "Crear informes de muestra",
      "muster.entfernen": "Quitar informes de muestra",
      "muster.angelegt_one": "{{count}} informe de muestra creado para {{kunde}}, {{punkte}} puntos cada uno. Fechas: {{tage}}",
      "muster.angelegt_other": "{{count}} informes de muestra creados para {{kunde}}, {{punkte}} puntos cada uno. Fechas: {{tage}}",
      "muster.entfernt_one": "{{count}} informe de muestra quitado.",
      "muster.entfernt_other": "{{count}} informes de muestra quitados.",
      "notiz.hinweis": "Solo la oficina. No en el informe del propietario.",
      "notiz.platzhalter": "Lo que la oficina debe saber y el cliente no.",
      "notiz.reiter": "Notas internas",
      "notiz.reiterHinweis": "Lo que el equipo anotó en el inmueble. Marcado significa archivado, no borrado.",
      "notiz.zeigeErledigte": "Ver resueltas",
      "notiz.zeigeOffene": "Ver pendientes",
      "notiz.keineOffenen": "No hay notas pendientes.",
      "notiz.keineErledigten": "Todavía no hay ninguna marcada.",
      "notiz.von": "{{name}}, informe {{nummer}}",
      "notiz.zumBericht": "Abrir informe",
      "notiz.erledigt": "Resuelta",
      "notiz.wiederOeffnen": "Reabrir",
      "notiz.abgehakt": "Marcada por {{name}} el {{datum}}.",
      "plan.ablage": "Servicios pendientes",
      "plan.ablageHinweis": "Arrastre a una columna. La opción 1 o 2 vale para todas las líneas del mismo departamento.",
      "plan.ablageLeer": "Esta semana está todo planificado.",
      "plan.ablageZeile": "{{offen}} pendiente, {{dauer}} en el inmueble",
      "plan.ablageEiner": "Va una persona",
      "plan.ablageZwei": "Van dos personas",
      "plan.ablageKeinBeifahrer": "{{name}} no tiene acompañante registrado. Dos personas solo es posible donde alguien va de copiloto.",
      "plan.ablageErgaenzt": "Servicio añadido a la cita existente: {{objekt}}.",
      "plan.ansichtVorschlag": "Propuesta",
      "plan.vorschlagHinweis": "Un borrador ordenado por cercanía. Solo se registra lo que usted acepte.",
      "plan.vorschlagAlle_one": "Aceptar {{count}} cita",
      "plan.vorschlagAlle_other": "Aceptar {{count}} citas",
      "plan.vorschlagLeer": "No hay nada que proponer para esta semana.",
      "plan.vorschlagUebernehmen": "Aceptar",
      "plan.vorschlagVerwerfen": "Descartar",
      "plan.vorschlagOffen": "Queda pendiente",
      "plan.grundKeineFachkraft": "Nadie está asignado a este departamento",
      "plan.grundKeinPlatz": "Sin hueco libre esta semana",
      "plan.grundFesttermin": "La cita fija no encaja: el día o la hora están ocupados",
      "plan.grundNurMitfahrt": "Demasiado corto para un viaje propio, sin visita a la que unirlo",
      "plan.tagAusrichten": "Ajustar el día",
      "plan.routeOptimieren": "Optimizar la ruta",
      "plan.ausrichtenKurz": "Ajustar",
      "plan.routeKurz": "Ruta",
      "plan.vorschlagNurFuer": "Borrador solo para {{name}}. Quien va de acompañante está incluido.",
      "plan.routeKuerzer_one": "{{count}} minuto menos de trayecto",
      "plan.routeKuerzer_other": "{{count}} minutos menos de trayecto",
      "plan.routeSchonKurz": "El orden ya era el más corto",
      "plan.routeFest_one": "{{count}} cita se quedó en su sitio",
      "plan.routeFest_other": "{{count}} citas se quedaron en su sitio",
      "plan.ausgerichtet_one": "{{count}} cita desplazada",
      "plan.ausgerichtet_other": "{{count}} citas desplazadas",
      "plan.pauseGesetzt": "Descanso de {{von}} a {{bis}}",
      "plan.pauseImTermin": "Una cita es demasiado larga para un descanso entre citas. Queda dentro y el tiempo de trabajo se detiene para ello.",
      "plan.ueberzug_one": "{{count}} minuto más allá del fin de jornada",
      "plan.ueberzug_other": "{{count}} minutos más allá del fin de jornada",
      "plan.pause": "Descanso",
      "plan.pauseHinweis": "Planificado, no fichado",
      "tag.pausePlan": "Así está previsto. El descanso se ficha arriba con el botón de descanso.",
      "plan.bereiche": "Áreas de esta visita",
      "plan.bereicheHinweis": "Se pueden elegir varias. Piscina y control de la casa en un viaje son una cita.",
      "plan.minuten": "minutos",
      "plan.bereicheSumme": "{{summe}} de {{dauer}} minutos repartidos",
      "plan.bereichMinuten_one": "{{count}} min",
      "plan.bereichMinuten_other": "{{count}} min",
      "plan.wieGewohnt": "como siempre, {{tag}}",
      "plan.abweichendVomGewohnten": "distinto, normalmente {{tag}}",
      "plan.grundOhneKoordinate": "Inmueble sin coordenadas, tiempo de viaje desconocido",
      "plan.anfahrtMinuten_one": "{{count}} minuto de viaje",
      "plan.anfahrtMinuten_other": "{{count}} minutos de viaje",
      "plan.fahrtKurz": "{{minuten}} min",
      "plan.fahrtLang": "Viaje aprox. {{km}} km, {{minuten}} min",
      "plan.fahrtTitel": "Viaje estimado: {{km}} km, {{minuten}} minutos",
      "plan.fahrtZuKnapp_one": "solo {{count}} minuto de margen",
      "plan.fahrtZuKnapp_other": "solo {{count}} minutos de margen",
      "auswertung.nachMitarbeiter": "Por empleado",
      "auswertung.nachKunden": "Por cliente",
      "auswertung.kunde": "Cliente",
      "auswertung.soll": "Acordado",
      "auswertung.ist": "Realizado",
      "auswertung.differenz": "Diferencia",
      "auswertung.einsaetze": "Servicios",
      "auswertung.summe": "Total",
      "auswertung.leer": "Este mes no hay horas previstas ni servicios.",
      "auswertung.ohneSoll": "Horas sin acuerdo registrado",
      "auswertung.keineEinsaetze": "Este mes no estuvo nadie en el inmueble.",
      "auswertung.ungeplant": "sin cita",
      "auswertung.kosten": "Costes",
      "auswertung.material": "Material",
      "auswertung.fremd": "Servicio externo",
      "auswertung.belege": "Material y costes externos",
      "auswertung.export": "Como Excel",
      "auswertung.exportHinweis": "Facturación, servicios y justificantes en un libro para la contabilidad.",
      "schnittstelle.titel": "Interfaz",
      "schnittstelle.hinweis": "Una clave da a otro programa acceso de solo lectura a clientes, inmuebles, servicios, costes y la base de facturación. Por la interfaz no se escribe nada.",
      "schnittstelle.name": "¿Para qué es la clave?",
      "schnittstelle.nameHinweis": "Por ejemplo la gestoría o el programa de facturación. Una clave por destinatario, así se puede revocar una sin desconectar las demás.",
      "schnittstelle.anlegen": "Crear clave",
      "schnittstelle.einmalig": "Copie esta clave ahora. No se mostrará nunca más.",
      "schnittstelle.verstanden": "Copiada",
      "schnittstelle.leer": "Todavía no hay ninguna clave.",
      "schnittstelle.angelegt": "Creada",
      "schnittstelle.benutzt": "Último uso",
      "schnittstelle.nieBenutzt": "Nunca usada",
      "schnittstelle.widerrufen": "Revocar",
      "schnittstelle.widerrufenAm": "Revocada el",
      "demo.titel": "Ver Jornado",
      "demo.einstiegHinweis": "Una instalación completa con datos inventados. Sin registro, no se envía nada.",
      "demo.code": "Código de acceso",
      "demo.alsBuero": "Abrir como oficina",
      "demo.alsMitarbeiter": "Abrir como técnico",
      "demo.fehler": "Ahora mismo no se puede abrir la demostración.",
      "demo.marke": "Demostración",
      "demo.balken": "Todos los datos aquí son inventados. Áreas, puntos de control, departamentos, logotipo y colores se configuran para cada empresa: lo que ve es un ejemplo, no una plantilla fija.",
      "demo.zuruecksetzen": "Reiniciar demostración",
      "demo.setztZurueck": "Reiniciando …",
      "nav.kosten": "Costes",
      "kosten.titel": "Material y costes externos",
      "kosten.hinweis": "Lo que se ha consumido o comprado para un inmueble. Basta con fotografiar el justificante.",
      "kosten.neuerEintrag": "Nuevo apunte",
      "kosten.objekt": "Inmueble",
      "kosten.alleObjekte": "Todos los inmuebles",
      "kosten.summe": "Total",
      "kosten.material": "Material",
      "kosten.fremd": "Servicio externo",
      "kosten.leer": "Este mes no se ha registrado nada.",
      "kosten.nichtWeiter": "no repercutible",
      "kosten.belegZeigen": "Ver justificante",
      "kosten.wirklichWeg": "¿Borrar este apunte?",
      "kosten.datum": "Fecha",
      "kosten.datumHinweis": "Cuándo se compró o se realizó. Hoy por defecto, se puede retrasar.",
      "kosten.bezeichnung": "Qué",
      "kosten.bezeichnungHinweis": "Breve y reconocible, por ejemplo sal para piscina o electricista de urgencia.",
      "kosten.betrag": "Importe",
      "kosten.betragHinweis": "En euros, tal como figura en el justificante.",
      "kosten.abteilung": "Departamento",
      "kosten.abteilungHinweis": "Para que el coste quede junto a las horas correctas en el informe.",
      "kosten.ohneAbteilung": "Ninguno",
      "kosten.menge": "Cantidad",
      "kosten.einheit": "Unidad",
      "kosten.einheitHinweis": "Unidades, kg, litros, horas. Opcional.",
      "kosten.lieferant": "Proveedor",
      "kosten.notiz": "Nota",
      "kosten.beleg": "Justificante",
      "kosten.belegHinweis": "Una foto del tique o de la factura. También funciona sin ella.",
      "kosten.weiterberechenbar": "Se repercute al propietario",
      "zeit.einsaetze": "Visitas",
      "zeit.abstand": "{{meter}} m de la propiedad",
      "zeit.zuWeit": "a {{meter}} m de la propiedad",
      "zeit.ohnePosition": "sin posición",
      "zeit.ohneKoordinate": "propiedad sin coordenadas",
      "zeit.arbeitstag": "Jornada",
      "zeit.einsatz": "Visita",
      "zeit.ungeplant": "no planificada",
      "zeit.titel": "Jornada laboral",
      "zeit.hinweis": "El registro del art. 34.9 ET, a conservar cuatro años. El fichaje se hace en Mi día.",
      "zeit.nichtGestempelt": "No has fichado la entrada.",
      "zeit.kommen": "Fichar entrada",
      "zeit.gehen": "Fichar salida",
      "zeit.pause": "Pausa",
      "zeit.pauseFaellig_one": "{{count}} hora sin descanso. Es hora del descanso.",
      "zeit.pauseFaellig_other": "{{count}} horas sin descanso. Es hora del descanso.",
      "zeit.pauseEnde": "Terminar pausa",
      "zeit.inPause": "en pausa",
      "zeit.seit": "desde {{zeit}}",
      "zeit.heuteBisher": "Hoy llevas {{dauer}}",
      "zeit.objektOptional": "Propiedad",
      "zeit.ohneObjekt": "sin propiedad",
      "zeit.wechselAuf": "Cambiar de propiedad a",
      "zeit.wechseln": "Cambiar",
      "zeit.vergessenTitel": "Queda una jornada abierta",
      "zeit.vergessenText": "Empezó el {{beginn}} y nunca se cerró. Indica la salida real, no se inventa nada.",
      "zeit.echtesEnde": "La salida fue",
      "zeit.grund": "Motivo",
      "zeit.grundPflicht": "Obligatorio. Queda en el registro.",
      "zeit.nachtragen": "Añadir jornada",
      "zugang.titel": "Acceso",
      "zugang.hinweis": "Llaves, portón, alarma. Cada consulta queda registrada.",
      "zugang.neu": "Añadir entrada",
      "zugang.leer": "No hay nada guardado para este inmueble.",
      "zugang.anzeigen": "Mostrar",
      "zugang.verbergen": "Ocultar",
      "zugang.verstecktGleich": "Se oculta de nuevo a los noventa segundos.",
      "zugang.artLabel": "Tipo",
      "zugang.bezeichnung": "Denominación",
      "zugang.bezeichnungHinweis": "Para qué, por ejemplo portón entrada norte",
      "zugang.wert": "Número o código",
      "zugang.wertUnveraendert": "Déjalo vacío para mantener el código actual",
      "zugang.art.key": "Llave",
      "zugang.art.alarm": "Alarma",
      "zugang.art.gate": "Portón",
      "zugang.art.wifi": "Wifi",
      "zugang.art.safe": "Caja fuerte",
      "zugang.art.other": "Otros",
      "zeit.auszug": "Resumen para la gestoría",
      "zeit.register": "Imprimir registro",
      "zeit.monat": "Mes",
      "zeit.orte.titel": "Dónde se ha fichado",
      "zeit.orte.hinweis": "Se cuenta la entrada al servicio. Verde significa dentro de {{meter}} metros del inmueble, rojo más lejos, gris sin posición del teléfono.",
      "zeit.orte.amObjekt": "En el inmueble",
      "zeit.orte.zuWeit": "Demasiado lejos",
      "zeit.orte.ohnePosition": "Sin posición",
      "zeit.mitarbeiter": "Empleado",
      "zeit.alle": "todos",
      "zeit.summe": "Total",
      "zeit.leer": "Este mes no se ha registrado nada.",
      "zeit.beginn": "Inicio",
      "zeit.ende": "Fin",
      "zeit.korrigieren": "Corregir",
      "zeit.korrekturHinweis": "El valor original se conserva y se muestra en la línea.",
      "zeit.korrigiertAm": "Corregido el {{am}} por {{von}}",
      "zeit.vorher": "antes",
      "zeit.manuell": "añadido después",
      "zeit.pausenSumme": "de los cuales {{dauer}} de pausa",
      "zeit.stornieren": "Anular",
      "zeit.storniert": "anulado",
      "zeit.storniertAm": "Anulado el {{am}} por {{von}}",
      "zeit.stornoHinweis": "La línea permanece en el registro, tachada, y deja de contar. No se puede deshacer; una anulación errónea se corrige añadiendo una jornada nueva.",
      "system.sicherung": "Copia de seguridad nocturna",
      "system.sicherungSchutz": "Protección de la copia",
      "system.verschluesselt": "cifrada",
      "system.unverschluesselt": "sin cifrar, falta la contraseña",
      "system.sicherungStand": "última {{zeit}} · {{groesse}}",
      "system.sicherung.keine": "No hay ninguna copia en el almacenamiento.",
      "system.sicherung.unbekannt": "No se puede consultar, el almacenamiento no responde.",
      "system.speicher": "Almacenamiento de archivos",
      "system.standortdaten": "Datos de ubicación",
      "system.standortStand": "{{anzahl}} puntos, se borran a los {{tage}} días",
      "system.standortUeberfaellig": "Siguen ahí puntos de más de {{tage}} días. El borrado no se está ejecutando.",
      "team.auskunft": "Descargar los datos",
      "team.auskunftHinweis": "Todos los datos guardados de esta persona en un archivo, según el art. 15 RGPD.",
      "system.post": "Envío de correo",
      "system.eingerichtet": "configurado",
      "system.fehlt": "sin configurar",
      "nav.uebernahme": "Migración",
      "uebernahme.titel": "Migración desde la aplicación antigua",
      "uebernahme.hinweis": "Importar clientes y propiedades. Primero una prueba, después decides tú.",
      "uebernahme.dateiWaehlen": "Elegir el archivo de la aplicación antigua",
      "uebernahme.gelesen": "{{datei}} · {{count}} registros leídos",
      "uebernahme.falscheDatei": "Este archivo no contiene datos de clientes de la aplicación antigua.",
      "uebernahme.probe": "Prueba",
      "uebernahme.probeErgebnis": "Prueba, no se ha escrito nada",
      "uebernahme.uebernehmen": "Importar ahora",
      "uebernahme.fertig": "Importado",
      "uebernahme.zusammenfassung": "{{gelesen}} leídos, {{neu}} nuevos, {{aktualisiert}} actualizados, {{uebersprungen}} omitidos",
      "uebernahme.spalteKunde": "Cliente",
      "uebernahme.spalteObjekt": "Propiedad",
      "uebernahme.spalteZustand": "Estado",
      "uebernahme.spalteHinweise": "Notas",
      "uebernahme.zustand.neu": "Nuevo",
      "uebernahme.zustand.aktualisiert": "Actualizado",
      "uebernahme.zustand.uebersprungen": "Omitido",
      "nav.einstellungen": "Ajustes",
      "einstellungen.titel": "Ajustes",
      "einstellungen.hinweis": "Estos datos figuran en los informes y en los correos al propietario.",
      "einstellungen.firma": "Empresa",
      "einstellungen.telefon": "Teléfono",
      "einstellungen.email": "Correo electrónico",
      "einstellungen.emailHinweis": "Esta dirección figura en el aviso legal y recibe las comunicaciones del canal de denuncias mientras no se indique otra.",
      "einstellungen.rechtTitel": "Datos obligatorios del aviso legal y de la política de privacidad",
      "einstellungen.rechtWarnung": "Estos datos figuran en el aviso legal y en la política de privacidad. Lo que quede vacío aquí faltará allí, y el art. 10 LSSI los exige completos.",
      "einstellungen.firmierung": "Denominación social completa",
      "einstellungen.firmierungHinweis": "Tal como consta en el Registro Mercantil, con la forma jurídica. Vacío significa que se usa el nombre de arriba.",
      "einstellungen.nif": "NIF",
      "einstellungen.anschrift": "Domicilio social",
      "einstellungen.anschriftHinweis": "Se admiten varias líneas, como aparecería en una carta.",
      "einstellungen.register": "Inscripción en el Registro Mercantil",
      "einstellungen.registerHinweis": "Registro, tomo, folio y hoja. Consta en la escritura de constitución.",
      "einstellungen.datenschutzEmail": "Dirección para solicitudes de protección de datos",
      "einstellungen.datenschutzEmailHinweis": "A esta dirección llegan las solicitudes de acceso y supresión. Vacío significa que se usa el correo de arriba.",
      "betrieb.urlaubEinheit": "Contar vacaciones en",
      "betrieb.urlaubEinheitHinweis": "Días naturales es el mínimo legal de 30. Días laborables suele ser 22.",
      "betrieb.planTitel": "Planificación y desplazamiento",
      "betrieb.planHinweis": "El marco en el que planifica la propuesta semanal y los supuestos del tiempo de viaje estimado.",
      "betrieb.planBeginn": "Inicio de jornada",
      "betrieb.planEnde": "Fin de jornada",
      "betrieb.planTeamAb": "Equipo a partir de (minutos)",
      "betrieb.planTeamAbHinweis": "A partir de este tamaño la propuesta asigna dos personas: un viaje en lugar de dos.",
      "betrieb.fahrtTempo": "Velocidad media (km/h)",
      "betrieb.planPauseNach": "Descanso tras (minutos)",
      "betrieb.planPauseNachHinweis": "Tras estos minutos trabajados el plan coloca el descanso. Va entre dos citas; si no cabe, queda dentro de la cita en curso y el tiempo de trabajo se detiene.",
      "betrieb.planPause": "Duración del descanso (minutos)",
      "betrieb.planPauseHinweis": "Norma de la casa, no ley. El art. 34.4 ET exige el descanso solo a partir de seis horas seguidas, y entonces quince minutos. Menos de quince no se puede fijar.",
      "betrieb.fahrtTempoHinweis": "Base de la estimación. Si 45 se ajusta a esta isla se verá tras un verano.",
      "betrieb.fahrtUmweg": "Factor de rodeo",
      "betrieb.fahrtUmwegHinweis": "La distancia en línea recta por este factor da la distancia por carretera supuesta.",
      "betrieb.startOrt": "Punto de partida de la ruta",
      "betrieb.streckenKeine": "Los tiempos de trayecto se estiman por línea recta. Aún no hay rutas medidas.",
      "betrieb.eichung": "Según {{paare}} rutas medidas de dos a treinta kilómetros, la longitud que hay entre dos citas de un día, serían {{tempo}} km/h y factor {{umweg}}.",
      "betrieb.eichungUebernehmen": "Aplicar",
      "betrieb.streckenStand": "{{anzahl}} de {{moeglich}} rutas medidas de verdad, la última el {{datum}}. Donde no hay medición, se estima.",
      "betrieb.startOrtHinweis": "Donde empieza y termina la jornada, por ejemplo Sineu. No cuenta como tiempo de trabajo; el trayecto hasta el primer cliente es tiempo propio. Solo decide el sentido: a igual distancia, el día empieza por el cliente más cercano. La coordenada se busca al guardar.",
      "urlaub.titel": "Vacaciones {{jahr}}",
      "urlaub.einheit.natural": "en días naturales",
      "urlaub.einheit.laboral": "en días laborables",
      "urlaub.anspruch": "Derecho",
      "urlaub.anspruchHinweis": "Días de este año",
      "urlaub.anspruchTitel": "Derecho a vacaciones",
      "urlaub.anspruchSpeichern": "Guardar el derecho",
      "urlaub.uebertrag": "Arrastre",
      "urlaub.uebertragHinweis": "Días traídos del año anterior",
      "urlaub.genommen": "Disfrutados",
      "urlaub.beantragt": "Solicitados",
      "urlaub.verbleibend": "Pendientes",
      "urlaub.standChef": "{{genommen}} disfrutados, {{rest}} pendientes.",
      "urlaub.ohneAnspruch": "No hay derecho registrado para este año. La oficina lo introduce.",
      "urlaub.ohneAnspruchChef": "No hay derecho registrado para este año. Introdúcelo por empleado en Equipo.",
      "betrieb.titel": "Operación",
      "betrieb.hinweis": "Cómo trabaja el sistema. Solo visible para la dirección.",
      "betrieb.ortung": "Localización continua durante la jornada",
      "betrieb.ortungWarnung": "El art. 90 LOPDGDD solo permite la geolocalización laboral si se ha informado previamente a la plantilla de forma expresa y clara. Por eso activarlo exige la fecha en la que existía la información firmada. El cambio queda registrado.",
      "betrieb.ortungTage": "Borrar los datos de ubicación tras",
      "betrieb.ortungTageHinweis": "días. Después solo queda la distancia en metros en el fichaje.",
      "betrieb.ortungInfoAm": "Información firmada al personal disponible desde",
      "betrieb.ortungInfoAmHinweis": "Sin esta fecha no se puede activar la localización. Las hojas firmadas quedan en la carpeta de personal, aquí solo consta el día.",
      "betrieb.maxAbstand": "Distancia llamativa a partir de",
      "betrieb.maxAbstandHinweis": "metros. Fichar más lejos aparece en rojo en el registro.",
      "betrieb.kiAn": "Textos propuestos por Claude",
      "betrieb.verbrauch": "Gastado este mes",
      "betrieb.verbrauchStand": "{{verbraucht}} de {{grenze}}",
      "betrieb.kiLimit": "Presupuesto mensual",
      "betrieb.kiLimitHinweis": "euros al mes. Agotado el presupuesto, no se generan más propuestas.",
      "betrieb.kiVorschlaege": "Propuestas por report",
      "betrieb.kiVorschlaegeHinweis": "Cuántas veces se puede consultar a Claude para el mismo report.",
      "betrieb.bueroKopie": "Copia oculta a la oficina",
      "betrieb.bueroKopieHinweis": "Dirección que recibe copia de cada correo al cliente. Vacío significa sin copia.",
      "einstellungen.gespeichert": "Guardado.",
      "nav.baukasten": "Módulos",
      "baukasten.titel": "Puntos de control",
      "baukasten.hinweis": "Aquí construyes tu informe: primero un área como título principal y debajo los puntos de control. Un cambio llega a todos los inmuebles; las excepciones se hacen en cada inmueble.",
      "baukasten.gruppe": "Subtítulo",
      "baukasten.gruppeHinweis": "Opcional. El mismo subtítulo en puntos seguidos forma un apartado en la app y en el informe.",
      "baukasten.gruppeBeispiel": "Exterior",
      "baukasten.hilfetext": "Texto de ayuda para el personal",
      "baukasten.hilfetextHinweis": "Opcional. Aparece en la app debajo del punto, igual para todos los inmuebles.",
      "baukasten.hoch": "Subir",
      "baukasten.runter": "Bajar",
      "checkliste.bereiche": "Áreas de este inmueble",
      "checkliste.bereicheHinweis": "Solo se comprueba lo marcado aquí. Quita la marca de lo que no exista en este inmueble.",
      "checkliste.mindestensEinBereich": "Tiene que quedar al menos un área.",
      "checkliste.ohneBezeichnung": "Control del inmueble",
      "checkliste.punktErgaenzen": "Añadir un punto suelto",
      "checkliste.punktErgaenzenHinweis": "Para casos concretos, por ejemplo un embarcadero. Un área entera sería demasiado.",
      "checkliste.fotoStandard": "Como en el estándar",
      "baukasten.punkte": "Puntos de control",
      "baukasten.punktNeu": "Nuevo punto",
      "baukasten.punkteAnzahl_one": "{{count}} punto",
      "baukasten.punkteAnzahl_other": "{{count}} puntos",
      "baukasten.keinePunkte": "Todavía no hay puntos de control.",
      "baukasten.bereichNeu": "Nueva área",
      "baukasten.bereichUmbenennen": "Renombrar",
      "baukasten.bereichName": "Nombre del área",
      "baukasten.bereichNameHinweis": "El título principal en el informe, por ejemplo Inmueble, Cocina, Flota. Escribe solo en alemán, Claude traduce el resto.",
      "baukasten.bereichBeispiel": "Inmueble",
      "baukasten.keineBereiche": "Todavía no hay ningún área. Un área es un título principal del informe y debajo van los puntos de control.",
      "vorlage.titel": "Plantillas de informe",
      "vorlage.hinweis": "Para trabajos sin ronda periódica. El empleado elige la plantilla en la cita y el inmueble viene de la cita. No hay que preparar nada en el inmueble.",
      "vorlage.neu": "Nueva plantilla",
      "vorlage.keine": "Todavía no hay plantillas. Quien solo hace rondas periódicas no necesita ninguna.",
      "vorlage.bereiche": "Áreas de este informe",
      "vorlage.bezeichnung": "Nombre",
      "vorlage.bezeichnungHinweis": "En la cita el empleado solo ve este nombre. Debe bastarle para saber qué informe empieza.",
      "vorlage.beispiel": "Montaje de ventanas",
      "vorlage.ohneBereich": "ningún área seleccionada",
      "unterschrift.titel": "Conformidad del cliente",
      "unterschrift.hinweis": "Opcional. En un montaje el cliente confirma así que el trabajo está hecho. Aparece en el PDF debajo del informe.",
      "unterschrift.keine": "Todavía sin firmar.",
      "unterschrift.leisten": "Recoger la firma",
      "unterschrift.erneut": "Firmar de nuevo",
      "unterschrift.name": "Nombre en mayúsculas",
      "unterschrift.nameHinweis": "Una firma en la pantalla a menudo no se lee. Sin el nombre después nadie sabe quién firmó.",
      "unterschrift.nameFehlt": "Escribe el nombre en mayúsculas.",
      "unterschrift.leer": "Firma en el recuadro.",
      "unterschrift.leeren": "Repetir",
      "baukasten.vorlagenTitel": "Empezar con una lista de ejemplo",
      "baukasten.vorlagenHinweis": "Ahorra la primera hora. Todo lo cargado pasa a ser tuyo: renombrar, añadir, borrar. La oferta desaparece en cuanto exista el primer punto de control.",
      "baukasten.vorlagenUmfang": "{{bereiche}} áreas, {{punkte}} puntos de control",
      "baukasten.vorlageLaden": "Cargar",
      "checkliste.keineBereiche": "Todavía no hay áreas. Créalas primero en el catálogo de puntos y márcalas aquí.",
      "team.keineBereiche": "Todavía no hay áreas en el catálogo de puntos.",
      "baukasten.stilllegen": "Retirar",
      "baukasten.wiederAktiv": "Reactivar",
      "baukasten.stillgelegt": "Retirado",
      "baukasten.schluessel": "Clave",
      "baukasten.schluesselHinweis": "Nombre técnico, después no se puede cambiar. Minúsculas y guion bajo.",
      "baukasten.punktSchluesselHinweis": "Área y nombre, por ejemplo pool.cubierta.",
      "baukasten.beschriftung": "Etiqueta",
      "baukasten.eingabeart": "Tipo de entrada",
      "baukasten.eingabeartHinweis": "Determina qué puede marcar o anotar el empleado en la propiedad.",
      "baukasten.art.status": "Comprobación: hecho, correcto, defecto, no comprobado",
      "baukasten.art.number": "Número",
      "baukasten.art.boolean": "Marcar: hecho o no",
      "baukasten.art.text": "Texto libre",
      "baukasten.art.photo": "Solo foto",
      "baukasten.einheit": "Unidad",
      "baukasten.zielVon": "Valor desde",
      "baukasten.zielBis": "Valor hasta",
      "baukasten.zielHinweis": "Si el valor queda fuera, la aplicación pide un comentario de inmediato.",
      "baukasten.fotoPflicht": "Foto obligatoria",
      "baukasten.fotoPflichtLang": "El empleado debe subir una foto de este punto, salvo que elija No aplica",
      "baukasten.uebersetztHinweis": "Escribe solo en alemán. Claude traduce al inglés, español y árabe al guardar.",
      "checkliste.titel": "Listas de control",
      "checkliste.keine": "Esta propiedad todavía no tiene ninguna lista.",
      "checkliste.hinzufuegen": "Añadir lista",
      "checkliste.bezeichnung": "Denominación",
      "checkliste.bezeichnungHinweis": "Opcional, por ejemplo Semanal.",
      "checkliste.zurueckZumObjekt": "A la propiedad",
      "checkliste.vorschau": "Lo que ve el empleado",
      "checkliste.vorschauHinweis": "Resultado de la plantilla más las diferencias, para el mes elegido.",
      "checkliste.leer": "Para este mes no queda nada.",
      "checkliste.ergaenzt": "añadido",
      "checkliste.angepasst": "ajustado",
      "checkliste.anpassen": "Ajustar",
      "checkliste.abwaehlen": "Quitar",
      "checkliste.abgewaehltePunkte": "Puntos quitados aquí",
      "checkliste.wiederAufnehmen": "volver a incluir",
      "checkliste.fotoPflicht": "Foto obligatoria",
      "checkliste.fotoFrei": "Sin foto",
      "checkliste.fotoHinweis": "Como en la plantilla significa: si cambia la plantilla, cambia también este inmueble.",
      "checkliste.objekthinweis": "Nota de la propiedad",
      "checkliste.objekthinweisHinweis": "Aparece junto al punto y sustituye la formación en el sitio.",
      "checkliste.objekthinweisBeispiel": "Filtro en el cuarto técnico detrás de la caseta de la piscina, llave número 4",
      "checkliste.anpassungZuruecknehmen": "Deshacer el ajuste",
      "aktion.speichern": "Guardar",
      "aktion.speichert": "Guardando",
      "aktion.abbrechen": "Cancelar",
      "aktion.bearbeiten": "Editar",
      "aktion.loeschen": "Eliminar",
      "aktion.ja": "Sí",
      "aktion.nein": "No",
      "archiv.zeigen": "Mostrar archivados",
      "archiv.marke": "Archivado",
      "archiv.archivieren": "Archivar",
      "archiv.zurueckholen": "Restaurar",
      "archiv.kundeMitObjekten_one": "Este cliente todavía tiene {{count}} inmueble activo. Se archivará también. ¿Continuar?",
      "archiv.kundeMitObjekten_other": "Este cliente todavía tiene {{count}} inmuebles activos. Se archivarán también. ¿Continuar?",
      "fehler.laden": "No se pudieron cargar los datos",
      "hinweis.hinweis": "Se envía por correo a la dirección y no se guarda en ningún sitio.",
      "hinweis.platzhalter": "¿Qué debería saber el jefe?",
      "hinweis.diktieren": "Para dictar, use la tecla del micrófono del teclado.",
      "hinweis.senden": "Enviar aviso",
      "hinweis.gesendet": "El aviso se ha enviado. Gracias.",
      "hinweis.nochEiner": "Escribir otro aviso",
      "fehler.speichern": "No se pudo guardar",
      "fehler.seite": "Esta página no existe.",
      "kunden.titel": "Clientes",
      "kunden.neu": "Nuevo cliente",
      "kunden.bearbeiten": "Editar cliente",
      "kunden.suche": "Buscar por nombre, correo o teléfono",
      "kunden.leer": "Todavía no hay clientes.",
      "kunden.ausgewaehlt_one": "{{count}} cliente seleccionado",
      "kunden.ausgewaehlt_other": "{{count}} clientes seleccionados",
      "kunden.auswahlAufheben": "Quitar la selección",
      "kunden.sammelArchivFrage_one": "¿Archivar {{count}} cliente y {{objekte}} inmuebles? Los inmuebles se archivan con él.",
      "kunden.sammelArchivFrage_other": "¿Archivar {{count}} clientes y {{objekte}} inmuebles? Los inmuebles se archivan con ellos.",
      "kunden.sammelZurueckFrage_one": "¿Restaurar {{count}} cliente?",
      "kunden.sammelZurueckFrage_other": "¿Restaurar {{count}} clientes?",
      "kunden.anzahl_one": "{{count}} cliente",
      "kunden.anzahl_other": "{{count}} clientes",
      "kunden.objekte_one": "{{count}} propiedad",
      "kunden.objekte_other": "{{count}} propiedades",
      "kunden.kontakt": "Contacto",
      "kunden.rechnungsadresse": "Dirección de facturación",
      "kunden.notizen": "Notas",
      "kunden.art": "Tipo",
      "kunden.art.private": "Particular",
      "kunden.art.company": "Empresa",
      "kunden.name": "Nombre",
      "kunden.nameHinweis": "Así aparece el cliente en listas y reports.",
      "kunden.firma": "Nombre de la empresa",
      "kunden.steuernummer": "NIF o CIF",
      "kunden.anrede": "Tratamiento",
      "kunden.briefanrede": "Saludo en la carta",
      "kunden.briefanredeHinweis": "Así empieza el texto del report. Neutral significa que nadie es tratado de forma incorrecta.",
      "kunden.anredeHelferStarten_one": "Completar el tratamiento de {{count}} cliente",
      "kunden.anredeHelferStarten_other": "Completar el tratamiento de {{count}} clientes",
      "kunden.anredeHelferStand": "{{fertig}} de {{gesamt}} guardados",
      "kunden.anredeHelferBeenden": "Listo",
      "kunden.anredeHelferHinweis": "La propuesta es la última palabra del nombre mostrado. El tratamiento no se adivina, lo eliges tú. Si queda neutral, el calendario muestra solo el nombre.",
      "kunden.anredeUebernommen": "guardado",
      "kunden.anredeKeinVorschlag": "Sin propuesta, escríbelo tú.",
      "kunden.anredename": "Nombre para el saludo",
      "kunden.anredenameHinweis": "Apellido para el trato formal, nombre para el informal. También es el título de la cita en el calendario.",
      "kunden.anredeNeutral": "Estimados señores,",
      "kunden.salutation.herr": "Señor",
      "kunden.salutation.frau": "Señora",
      "kunden.salutation.familie": "Familia",
      "kunden.salutation.neutral": "Neutral",
      "kunden.anrede.du": "Tú",
      "kunden.anrede.sie": "Usted",
      "kunden.sprache": "Idioma",
      "kunden.spracheHinweis": "Idioma de los reports para este cliente.",
      "kunden.email": "Correo electrónico",
      "kunden.emailHinweis": "Separa varias direcciones con punto y coma. El informe se envía a todas.",
      "kunden.telefon": "Teléfono",
      "objekte.titel": "Propiedades",
      "objekte.alle": "Todas las propiedades",
      "objekte.neu": "Nueva propiedad",
      "objekte.bearbeiten": "Editar propiedad",
      "objekte.suche": "Buscar por propiedad, población o cliente",
      "objekte.leer": "Todavía no hay propiedades.",
      "objekte.leerBeiKunde": "Este cliente aún no tiene ninguna propiedad.",
      "objekte.anzahl_one": "{{count}} propiedad",
      "objekte.anzahl_other": "{{count}} propiedades",
      "objekte.name": "Denominación",
      "objekte.nameHinweis": "Por ejemplo Villa Son Vida o Finca Andratx.",
      "objekte.kunde": "Cliente",
      "objekte.kundeWaehlen": "Elige una opción",
      "objekte.ohneKoordinate": "sin coordenadas",
      "objekte.nurOhneKoordinate": "solo sin coordenadas",
      "objekte.koordinateFehlt": "Este inmueble no tiene coordenadas. Sin ellas no se puede calcular la distancia al fichar.",
      "objekte.koordinateSuchen": "Buscar coordenadas",
      "objekte.koordinateNichts": "No se ha encontrado nada en Mallorca para esta dirección. Introdúcelas a mano.",
      "objekte.nurStrasse": "Coincidencia sin número, el punto está en la calle. Suficiente para la comprobación de distancia.",
      "objekte.koordinateUebernehmen": "Usar esta",
      "objekte.koordinateAnsehen": "Ver en el mapa",
      "objekte.zumKunden": "Ir al cliente",
      "objekte.lage": "Ubicación",
      "objekte.vertrag": "Contrato",
      "objekte.gemeinde": "Municipio",
      "objekte.gemeindeHinweis": "Calvià, Andratx, Pollença y demás.",
      "objekte.breite": "Latitud",
      "objekte.laenge": "Longitud",
      "objekte.koordinatenHinweis": "Opcional. Permite navegar hasta la propiedad más adelante.",
      "objekte.route": "Iniciar ruta",
      "objekte.leistung": "Servicio",
      "objekte.leistungHinweis": "Por ejemplo atención integral.",
      "objekte.beginn": "Inicio del contrato",
      "objekte.ende": "Fin del contrato",
      "objekte.poolheizung": "Con calefacción de piscina",
      "objekte.poolheizungHinweis": "Deja constancia en el inmueble de que hay calefacción de piscina acordada y se puede encender para una estancia.",
      "objekte.anfahrt": "Acceso e indicaciones",
      "objekte.anfahrtHinweis": "Notas para el personal. Sin códigos de alarma ni escondites de llaves.",
      "adresse.strasse": "Calle y número",
      "adresse.plz": "Código postal",
      "adresse.ort": "Población",
      "adresse.land": "País",
      "adresse.landHinweis": "Dos letras, por ejemplo ES o DE.",
      "app.name": "Jornado",
      "recht.datenschutz": "Política de privacidad",
      "recht.impressum": "Aviso legal",
      "recht.zurueck": "Volver a la aplicación",
      "recht.stand": "Versión {{datum}}",
      "login.title": "Iniciar sesión",
      "login.email": "Correo electrónico",
      "login.password": "Contraseña",
      "login.zeigen": "Mostrar contraseña",
      "login.verbergen": "Ocultar contraseña",
      "login.submit": "Entrar",
      "login.pending": "Un momento",
      "login.failed": "El correo o la contraseña no son correctos",
      "nav.customers": "Clientes",
      "nav.password": "Contraseña",
      "password.title": "Cambiar contraseña",
      "password.hint": "Después tendrás que iniciar sesión de nuevo.",
      "password.current": "Contraseña actual",
      "password.new": "Nueva contraseña",
      "password.rule": "Mínimo 12 caracteres, con mayúscula, minúscula y un número.",
      "password.save": "Cambiar",
      "password.cancel": "Cancelar",
      "password.failed": "No se pudo cambiar",
      "nav.logout": "Salir",
    }
  },
  ar: {
    translation: {
      "objektzahlen.titel": "أرقام من التقارير",
      "objektzahlen.hinweis": "مأخوذة من التقارير المعتمدة، عادة تقرير واحد في الأسبوع.",
      "objektzahlen.jeTag": "الاستهلاك في اليوم، حتى يمكن مقارنة الفترات",
      "objektzahlen.tag": "يوم",
      "objektzahlen.dieseWoche": "آخر ٧ أيام",
      "objektzahlen.dieserMonat": "هذا الشهر",
      "objektzahlen.vormonat": "الشهر السابق",
      "objektzahlen.grundlast": "عند خلو المنزل",
      "objektzahlen.letzterWert": "آخر قياس",
      "objektzahlen.legendeVerbrauch": "الاستهلاك في اليوم بوحدة {{einheit}}",
      "objektzahlen.legendeWert": "القيمة المقاسة",
      "objektzahlen.legendeUeblich": "المعتاد في هذا المنزل: {{wert}}",
      "objektzahlen.legendeZiel": "النطاق المستهدف من {{min}} إلى {{max}}",
      "objektzahlen.legendeMehr": "أكثر من المعتاد بوضوح",
      "objektzahlen.legendeAusserhalb": "خارج النطاق المستهدف",
      "objektzahlen.mengeUeberTage_zero": "({{menge}} {{einheit}} في {{count}} يوم)",
      "objektzahlen.mengeUeberTage_one": "({{menge}} {{einheit}} في يوم واحد)",
      "objektzahlen.mengeUeberTage_two": "({{menge}} {{einheit}} في يومين)",
      "objektzahlen.mengeUeberTage_few": "({{menge}} {{einheit}} في {{count}} أيام)",
      "objektzahlen.mengeUeberTage_many": "({{menge}} {{einheit}} في {{count}} يوماً)",
      "objektzahlen.mengeUeberTage_other": "({{menge}} {{einheit}} في {{count}} يوم)",
      "objektzahlen.auffaellig": "في الفترة الأخيرة {{wert}} {{einheit}} في اليوم، بينما المعتاد هنا نحو {{basis}}. كان أحد في المنزل خلال تلك الفترة، وهذا يفسر الفارق عادة.",
      "objektzahlen.leckverdacht": "في الفترة الأخيرة {{wert}} {{einheit}} في اليوم رغم خلو المنزل. وعند خلوه يكون المعتاد هنا نحو {{basis}}. هذا يشير إلى تسرب.",
      "objektzahlen.tabelleAuf": "إظهار الأرقام",
      "objektzahlen.tabelleZu": "إخفاء الأرقام",
      "objektzahlen.ausserhalb": "خارج النطاق",
      "einrichtung.ansprache_zero": "لا يوجد عميل بلا لقب واسم عائلة",
      "einrichtung.ansprache_one": "عميل واحد بلا لقب واسم عائلة، ويظهر في التقويم الاسم المعروض فقط",
      "einrichtung.ansprache_two": "عميلان بلا لقب واسم عائلة، ويظهر في التقويم الاسم المعروض فقط",
      "einrichtung.ansprache_few": "{{count}} عملاء بلا لقب واسم عائلة، ويظهر في التقويم الاسم المعروض فقط",
      "einrichtung.ansprache_many": "{{count}} عميلا بلا لقب واسم عائلة، ويظهر في التقويم الاسم المعروض فقط",
      "einrichtung.ansprache_other": "{{count}} عميل بلا لقب واسم عائلة، ويظهر في التقويم الاسم المعروض فقط",
      "objekte.helferStarten_zero": "لا توجد عقارات",
      "objekte.helferStarten_one": "اقتراح إحداثيات لعقار واحد",
      "objekte.helferStarten_two": "اقتراح إحداثيات لعقارين",
      "objekte.helferStarten_few": "اقتراح إحداثيات لـ {{count}} عقارات",
      "objekte.helferStarten_many": "اقتراح إحداثيات لـ {{count}} عقارا",
      "objekte.helferStarten_other": "اقتراح إحداثيات لـ {{count}} عقار",
      "objekte.helferStand": "تم فحص {{geprueft}} من {{gesamt}}",
      "objekte.helferBeenden": "تم",
      "objekte.helferWartet": "في الانتظار",
      "objekte.helferUebernommen": "تم حفظ الإحداثيات",
      "einrichtung.titel": "ما زال يحتاج إعدادا",
      "einrichtung.hinweis": "لا يستطيع أي برنامج القيام بهذا عنك. ما يُنجز يختفي من هذه القائمة تلقائيا.",
      "einrichtung.hin": "اذهب",
      "einrichtung.vertrag_zero": "لا يوجد موظف بلا ساعات أسبوعية أو تاريخ بدء",
      "einrichtung.vertrag_one": "موظف واحد بلا ساعات أسبوعية أو تاريخ بدء",
      "einrichtung.vertrag_two": "موظفان بلا ساعات أسبوعية أو تاريخ بدء",
      "einrichtung.vertrag_few": "{{count}} موظفين بلا ساعات أسبوعية أو تاريخ بدء",
      "einrichtung.vertrag_many": "{{count}} موظفا بلا ساعات أسبوعية أو تاريخ بدء",
      "einrichtung.vertrag_other": "{{count}} موظف بلا ساعات أسبوعية أو تاريخ بدء",
      "einrichtung.urlaub_zero": "لا يوجد موظف بلا رصيد إجازة لهذا العام",
      "einrichtung.urlaub_one": "موظف واحد بلا رصيد إجازة لهذا العام",
      "einrichtung.urlaub_two": "موظفان بلا رصيد إجازة لهذا العام",
      "einrichtung.urlaub_few": "{{count}} موظفين بلا رصيد إجازة لهذا العام",
      "einrichtung.urlaub_many": "{{count}} موظفا بلا رصيد إجازة لهذا العام",
      "einrichtung.urlaub_other": "{{count}} موظف بلا رصيد إجازة لهذا العام",
      "einrichtung.baukasten": "لا توجد نقطة فحص بعد، وبدونها يبقى التقرير في العقار فارغا",
      "einrichtung.fahrzeug": "لا توجد مركبة مسجلة، لذلك لا يمكن لأحد تسجيل التزود بالوقود",
      "einrichtung.handbuch": "لم يُكتب أي مقال في الدليل بعد",
      "einrichtung.koordinate_zero": "لا يوجد عقار بلا إحداثيات",
      "einrichtung.koordinate_one": "عقار واحد بلا إحداثيات",
      "einrichtung.koordinate_two": "عقاران بلا إحداثيات",
      "einrichtung.koordinate_few": "{{count}} عقارات بلا إحداثيات",
      "einrichtung.koordinate_many": "{{count}} عقارا بلا إحداثيات",
      "einrichtung.koordinate_other": "{{count}} عقار بلا إحداثيات",
      "einrichtung.zugang_zero": "لا يوجد عقار بلا بيانات دخول",
      "einrichtung.zugang_one": "عقار واحد بلا بيانات دخول",
      "einrichtung.zugang_two": "عقاران بلا بيانات دخول",
      "einrichtung.zugang_few": "{{count}} عقارات بلا بيانات دخول",
      "einrichtung.zugang_many": "{{count}} عقارا بلا بيانات دخول",
      "einrichtung.zugang_other": "{{count}} عقار بلا بيانات دخول",
      "einrichtung.ortung": "التتبع مفعّل. يجب أن يكون إشعار الموظفين الموقّع وفق المادة 90 من قانون حماية البيانات متوفرا",
      "einrichtung.firmenangaben_one": "ينقص {{count}} بيان إلزامي عن الشركة، ويبقى البيان القانوني ناقصاً",
      "einrichtung.firmenangaben_other": "تنقص {{count}} بيانات إلزامية عن الشركة، ويبقى البيان القانوني ناقصاً",
      "zeit.empfangenAm": "وصل إلى الخادم في {{zeit}}",
      "netz.abmeldenTrotzWartend_zero": "لا توجد إدخالات معلقة. هل تريد تسجيل الخروج؟",
      "netz.abmeldenTrotzWartend_one": "لم يتم إرسال إدخال واحد بعد. سيضيع عند تسجيل الخروج. هل تريد المتابعة؟",
      "netz.abmeldenTrotzWartend_two": "لم يتم إرسال إدخالين بعد. سيضيعان عند تسجيل الخروج. هل تريد المتابعة؟",
      "netz.abmeldenTrotzWartend_few": "لم يتم إرسال {{count}} إدخالات بعد. ستضيع عند تسجيل الخروج. هل تريد المتابعة؟",
      "netz.abmeldenTrotzWartend_many": "لم يتم إرسال {{count}} إدخالا بعد. ستضيع عند تسجيل الخروج. هل تريد المتابعة؟",
      "netz.abmeldenTrotzWartend_other": "لم يتم إرسال {{count}} إدخال بعد. ستضيع عند تسجيل الخروج. هل تريد المتابعة؟",
      "tag.stempel.tag.start": "بدأ يوم العمل",
      "tag.stempel.tag.ende": "انتهى يوم العمل",
      "tag.stempel.einsatz.start": "بدأت المهمة",
      "tag.stempel.einsatz.ende": "انتهت المهمة",
      "tag.stempel.pause": "بدأت الاستراحة",
      "tag.stempel.pause.ende": "انتهت الاستراحة",
      "zeit.ohneNetz": "تم التسجيل دون اتصال",
      "netz.ohneNetz": "لا يوجد اتصال. ما تدخله يبقى على الجهاز ويُرسل لاحقا.",
      "netz.wartet_zero": "لا توجد إدخالات معلقة",
      "netz.wartet_one": "إدخال واحد معلق",
      "netz.wartet_two": "إدخالان معلقان",
      "netz.wartet_few": "{{count}} إدخالات معلقة",
      "netz.wartet_many": "{{count}} إدخالا معلقا",
      "netz.wartet_other": "{{count}} إدخال معلق",
      "netz.sendet": "جاري الإرسال",
      "netz.jetztSenden": "أرسل الآن",
      "netz.abgelehnt_zero": "لا توجد إدخالات مرفوضة",
      "netz.abgelehnt_one": "تم رفض إدخال واحد",
      "netz.abgelehnt_two": "تم رفض إدخالين",
      "netz.abgelehnt_few": "تم رفض {{count}} إدخالات",
      "netz.abgelehnt_many": "تم رفض {{count}} إدخالا",
      "netz.abgelehnt_other": "تم رفض {{count}} إدخال",
      "netz.abgelehntTitel": "الإدخالات المرفوضة",
      "netz.nichtsAbgelehnt": "لم يبق شيء.",
      "netz.anzeigen": "عرض",
      "netz.schliessen": "إغلاق",
      "netz.nochmal": "حاول مرة أخرى",
      "netz.verwerfen": "تجاهل",
      "netz.verwerfenFrage": "هل تريد تجاهل هذا الإدخال نهائيا؟ سيضيع.",
      "netz.versuche_zero": "لا محاولات",
      "netz.versuche_one": "محاولة واحدة",
      "netz.versuche_two": "محاولتان",
      "netz.versuche_few": "{{count}} محاولات",
      "netz.versuche_many": "{{count}} محاولة",
      "netz.versuche_other": "{{count}} محاولة",
      "netz.ausAblage": "لا يوجد اتصال. المعروض هو حالة {{zeit}}.",
      "netz.gemerkt": "تم الحفظ دون اتصال، وسيُرسل لاحقا.",
      "app.neueFassung": "تتوفر نسخة جديدة.",
      "app.neueFassungLaden": "تحميلها الآن",
      "nav.pruefungen": "Reports",
      "nav.notizen": "الملاحظات",
      "pruefung.titel": "Reports",
      "pruefung.neu": "Report جديد",
      "pruefung.neuHinweis": "اختر العقار والقائمة. تثبت القائمة عند البدء.",
      "pruefung.starten": "بدء Report",
      "pruefung.status": "الحالة",
      "pruefung.alleStatus": "الكل",
      "pruefung.leer": "لا توجد Reports بعد.",
      "pruefung.zurFreigabe_zero": "لا توجد تقارير بانتظار الاعتماد",
      "pruefung.zurFreigabe_one": "تقرير واحد بانتظار الاعتماد",
      "pruefung.zurFreigabe_two": "تقريران بانتظار الاعتماد",
      "pruefung.zurFreigabe_few": "{{count}} تقارير بانتظار الاعتماد",
      "pruefung.zurFreigabe_many": "{{count}} تقريراً بانتظار الاعتماد",
      "pruefung.zurFreigabe_other": "{{count}} تقرير بانتظار الاعتماد",
      "pruefung.leerBeiObjekt": "لا يوجد Report لهذا العقار بعد.",
      "pruefung.keineCheckliste": "لا توجد قائمة فحص فعالة لهذا العقار.",
      "pruefung.anzahl_zero": "لا توجد Reports",
      "pruefung.anzahl_one": "Report واحد",
      "pruefung.anzahl_two": "{{count}} Reports",
      "pruefung.anzahl_few": "{{count}} Reports",
      "pruefung.anzahl_many": "{{count}} Reports",
      "pruefung.anzahl_other": "{{count}} Reports",
      "pruefung.nummer": "Report {{nummer}}",
      "pruefung.fortschritt": "{{erledigt}} من {{gesamt}} مسجلة",
      "pruefung.maengel_zero": "لا أعطال",
      "pruefung.maengel_one": "عطل واحد",
      "pruefung.maengel_two": "عطلان",
      "pruefung.maengel_few": "{{count}} أعطال",
      "pruefung.maengel_many": "{{count}} عطلا",
      "pruefung.maengel_other": "{{count}} عطل",
      "pruefung.status.draft": "مسودة",
      "pruefung.status.submitted": "مقدم",
      "pruefung.status.changes_requested": "معاد",
      "pruefung.status.approved": "معتمد",
      "pruefung.status.sent": "مرسل",
      "pruefung.status.cancelled": "مسحوب",
      "pruefung.einreichen": "تقديم",
      "pruefung.freigeben": "اعتماد",
      "pruefung.zurueckgeben": "إعادة",
      "pruefung.zuruecknehmen": "سحب",
      "pruefung.loeschen": "حذف نهائي",
      "pruefung.loeschenFrage": "هل تريد الحذف نهائيا؟ لا يمكن التراجع عن ذلك.",
      "pruefung.loeschenJa": "نعم، احذف",
      "pruefung.loeschenFehler": "تعذر حذف الـ Report",
      "pruefung.pdf": "PDF",
      "pruefung.pdfFehler": "تعذر إنشاء ملف PDF",
      "sprache.de": "DE",
      "sprache.en": "EN",
      "pruefung.rueckgabeGrund": "ما الناقص أو ما يجب تصحيحه؟",
      "pruefung.zurueckgegeben": "أعيد من الإدارة",
      "pruefung.nochOffen": "ما زال ناقصا",
      "pruefung.grund.offen": "غير مسجل بعد",
      "pruefung.grund.mangel_ohne_kommentar": "عطل بدون تعليق",
      "pruefung.grund.wert_ohne_kommentar": "قيمة خارج المجال بدون تعليق",
      "pruefung.grund.foto_fehlt": "عيب بدون صورة",
      "foto.aufnehmen": "صورة",
      "foto.galerie": "من المعرض",
      "foto.laedtAnzahl_zero": "لا صور قيد الرفع",
      "foto.laedtAnzahl_one": "جارٍ رفع صورة",
      "foto.laedtAnzahl_two": "جارٍ رفع صورتين",
      "foto.laedtAnzahl_few": "جارٍ رفع {{count}} صور",
      "foto.laedtAnzahl_many": "جارٍ رفع {{count}} صورة",
      "foto.laedtAnzahl_other": "جارٍ رفع {{count}} صورة",
      "foto.anderes": "صورة أخرى",
      "foto.belegAufnehmen": "تصوير الإيصال",
      "foto.belegPflicht": "لا يمكن الحفظ بدون صورة",
      "foto.laedt": "جارٍ الرفع",
      "foto.entfernen": "إزالة الصورة",
      "foto.pflicht": "الصورة إلزامية في هذه النقطة",
      "foto.fehler": "تعذر حفظ الصورة",
      "pruefung.ergebnis.done": "تم",
      "pruefung.ergebnis.ok": "تم الفحص، سليم",
      "pruefung.ergebnis.fault": "تم الفحص، غير سليم",
      "pruefung.ergebnis.na": "لم يُفحص",
      "pruefung.ja": "تم",
      "pruefung.nein": "لا ينطبق",
      "pruefung.wert": "القيمة",
      "pruefung.ausserhalb": "خارج المجال",
      "pruefung.kommentar": "تعليق",
      "pruefung.kommentarPflicht": "التعليق إلزامي",
      "pruefung.kommentarFehlt": "لا يمكن تقديم الـ Report بدون تعليق.",
      "pruefung.kundentext": "نص للعميل",
      "pruefung.kundentextHinweis": "يظهر هذا النص في ملف PDF الذي يستلمه المالك.",
      "pruefung.gespeichert": "تم الحفظ",
      "ki.vorschlag": "اقتراح من كلود",
      "ki.denkt": "كلود يكتب",
      "ki.marke": "اقتراح من كلود",
      "ki.markeBearbeitet": "من كلود، معدّل",
      "ki.hinweis": "الاقتراح لا يُحفظ ولا يُرسل. اقرأ أولا ثم احفظ.",
      "ki.uebersetzen": "ترجمة",
      "ki.fehler": "تعذر على كلود المساعدة الآن",
      "ki.rest": "المتبقي: {{n}}",
      "ki.aufgebraucht": "لم يتبق شيء. يمكن تعديل النص يدويا.",
      "versand.titel": "الإرسال إلى المالك",
      "versand.hinweis": "يُرسل Jornado Report إلى العميل كملف PDF. هنا يغادر الشركة.",
      "versand.an": "إلى",
      "versand.kopie": "نسخة مخفية",
      "versand.betreff": "الموضوع",
      "versand.anhang": "المرفق",
      "versand.anhangPdf": "Jornado Report كملف PDF ({{sprache}})",
      "versand.senden": "إرسال إلى العميل",
      "versand.erneut": "إرسال مرة أخرى",
      "versand.frage": "هل تريد الإرسال فعلا إلى {{an}}؟",
      "versand.ja": "نعم، أرسل",
      "versand.laeuft": "جارٍ الإرسال",
      "versand.bereits": "أُرسل في {{datum}} إلى {{an}}",
      "versand.fehler": "تعذر إرسال الـ Report",
      "versand.letzterFehler": "آخر محاولة في {{datum}}: {{fehler}}",
      "nav.auftraege": "أوامر العمل",
      "auftraege.titel": "أوامر العمل",
      "auftraege.anzahl_zero": "لا توجد أوامر",
      "auftraege.anzahl_one": "أمر واحد",
      "auftraege.anzahl_two": "أمران",
      "auftraege.anzahl_few": "{{count}} أوامر",
      "auftraege.anzahl_many": "{{count}} أمرا",
      "auftraege.anzahl_other": "{{count}} أمر",
      "auftraege.leer": "لا توجد أوامر في هذه الحالة.",
      "auftraege.loeschenSicher": "حذف أمر العمل نهائياً؟ سيُحذف السجل والصور معه. تبقى الساعات المسجلة، لكنها تفقد الارتباط فقط.",
      "auftraege.geloesteZeiten_zero": "لم تكن هناك ساعات مرتبطة بهذا الأمر.",
      "auftraege.geloesteZeiten_one": "كانت هناك ساعة مسجلة مرتبطة بهذا الأمر. تبقى في السجل بدون أمر عمل.",
      "auftraege.geloesteZeiten_two": "كانت هناك ساعتان مسجلتان مرتبطتان بهذا الأمر. تبقيان في السجل بدون أمر عمل.",
      "auftraege.geloesteZeiten_few": "كانت هناك {{count}} ساعات مسجلة مرتبطة بهذا الأمر. تبقى في السجل بدون أمر عمل.",
      "auftraege.geloesteZeiten_many": "كانت هناك {{count}} ساعة مسجلة مرتبطة بهذا الأمر. تبقى في السجل بدون أمر عمل.",
      "auftraege.geloesteZeiten_other": "كانت هناك {{count}} ساعة مسجلة مرتبطة بهذا الأمر. تبقى في السجل بدون أمر عمل.",
      "auftraege.neu": "أمر جديد",
      "auftraege.nummer": "أمر {{nummer}}",
      "auftraege.offen": "قيد المعالجة",
      "auftraege.alle": "الكل",
      "auftraege.zustand": "الحالة",
      "auftraege.objekt": "العقار",
      "auftraege.titel1": "العنوان",
      "auftraege.beschreibung": "الوصف",
      "auftraege.prioritaet": "الأولوية",
      "auftraege.termin": "الموعد",
      "auftraege.zugewiesen": "مسند إلى",
      "auftraege.ohneZuweisung": "غير مسند",
      "auftraege.fotos": "الصور",
      "auftraege.keineFotos": "لا توجد صور بعد.",
      "auftraege.verlauf": "السجل",
      "auftraege.notiz": "حفظ الملاحظة",
      "auftraege.notizPlatzhalter": "ملاحظة قصيرة للزملاء",
      "auftraege.zurueckZurListe": "العودة إلى القائمة",
      "auftraege.ausMangel": "إنشاء أمر من هذا العيب",
      "auftraege.status.open": "مفتوح",
      "auftraege.status.scheduled": "محدد بموعد",
      "auftraege.status.in_progress": "قيد التنفيذ",
      "auftraege.status.waiting": "في الانتظار",
      "auftraege.status.done": "منجز",
      "auftraege.status.cancelled": "مسحوب",
      "auftraege.prio.low": "منخفضة",
      "auftraege.prio.normal": "عادية",
      "auftraege.prio.high": "عالية",
      "auftraege.prio.urgent": "عاجلة",
      "auftraege.fotoart.before": "قبل",
      "auftraege.fotoart.after": "بعد",
      "auftraege.fotoart.receipt": "إيصال",
      "auftraege.fotoart.other": "أخرى",
      "auftraege.fotoHinzu.before": "إضافة صورة قبل",
      "auftraege.fotoHinzu.after": "إضافة صورة بعد",
      "auftraege.fotoHinzu.receipt": "إضافة إيصال",
      "auftraege.ereignis.created": "تم الإنشاء",
      "auftraege.ereignis.assigned": "تغير الإسناد",
      "auftraege.ereignis.status_changed": "تغيرت الحالة",
      "auftraege.ereignis.note": "ملاحظة",
      "system.titel": "حالة النظام",
      "nav.zeiten": "الدوام",
      "nav.meinTag": "يومي",
      "nav.meineWoche": "أسبوعي",
      "nav.meineZeit": "ساعاتي",
      "nav.antraege": "الطلبات",
      "nav.team": "الفريق",
      "nav.fuhrpark": "سجل الوقود",
      "nav.handbuch": "الدليل",
      "nav.hinweis": "ملاحظة إلى المدير",
      "fuhrpark.titel": "سجل الوقود",
      "fuhrpark.hinweis": "المركبة وعداد الكيلومترات وصورة الإيصال.",
      "fuhrpark.neuerEintrag": "إضافة تعبئة",
      "fuhrpark.neuesFahrzeug": "إضافة مركبة",
      "fuhrpark.fahrzeug": "المركبة",
      "fuhrpark.kilometerstand": "عداد الكيلومترات",
      "fuhrpark.kmHinweis": "الرقم الذي يُنسى فور الانطلاق.",
      "fuhrpark.literLabel": "اللترات",
      "fuhrpark.betrag": "المبلغ باليورو",
      "fuhrpark.notiz": "ملاحظة",
      "fuhrpark.beleg": "الإيصال",
      "fuhrpark.belegHinweis": "صورة للإيصال، اختيارية.",
      "fuhrpark.dreiAngaben": "ثلاث بيانات تكفي. تُقرأ اللترات والمبلغ من الإيصال.",
      "fuhrpark.belegPflicht": "صورة للإيصال. بدون إيصال لا يمكن التسجيل.",
      "fuhrpark.betragOffen": "المبلغ لاحقاً",
      "fuhrpark.vomBeleg": "مقروء من الإيصال",
      "fuhrpark.berichtigen": "تصحيح الأرقام",
      "fuhrpark.nochmalLesen": "قراءة الإيصال مرة أخرى",
      "fuhrpark.ohneBetrag_zero": "لا توجد إيصالات بدون مبلغ",
      "fuhrpark.ohneBetrag_one": "إيصال واحد بدون مبلغ",
      "fuhrpark.ohneBetrag_two": "إيصالان بدون مبلغ",
      "fuhrpark.ohneBetrag_few": "{{count}} إيصالات بدون مبلغ",
      "fuhrpark.ohneBetrag_many": "{{count}} إيصالاً بدون مبلغ",
      "fuhrpark.ohneBetrag_other": "{{count}} إيصال بدون مبلغ",
      "fuhrpark.belegZeigen": "عرض الإيصال",
      "fuhrpark.summe": "المجموع",
      "fuhrpark.liter": "المُعبأ",
      "fuhrpark.kmStand": "{{km}} كم",
      "fuhrpark.leer": "لم يُسجَّل شيء هذا الشهر.",
      "fuhrpark.keineFahrzeuge": "لا توجد مركبة مسجلة بعد. أبلغ المكتب.",
      "fuhrpark.keineFahrzeugeChef": "أضف مركبة أولاً، وإلا لن يتمكن أحد من تسجيل التعبئة.",
      "fuhrpark.kennzeichen": "اللوحة",
      "fuhrpark.bezeichnung": "التسمية",
      "fuhrpark.bezeichnungHinweis": "ما تسمون به السيارة، مثلاً \"الشاحنة البيضاء\".",
      "fuhrpark.modell": "الطراز",
      "fuhrpark.kraftstoff": "الوقود",
      "handbuch.titel": "الدليل",
      "handbuch.hinweis": "تعليمات التشغيل والتعليمات الداخلية.",
      "handbuch.suche": "بحث",
      "handbuch.kategorie": "الفئة",
      "handbuch.alleKategorien": "الكل",
      "handbuch.leer": "لا يوجد شيء.",
      "handbuch.neu": "إضافة مقال",
      "handbuch.kennung": "المعرّف",
      "handbuch.kennungHinweis": "قصير وبلا مسافات، مثل pool-winter.",
      "handbuch.sichtbarkeit": "مرئي لـ",
      "handbuch.fuerAlle": "جميع الموظفين",
      "handbuch.nurChef": "الإدارة فقط",
      "handbuch.artikelTitel": "العنوان",
      "handbuch.artikelText": "النص",
      "handbuch.archivieren": "أرشفة",
      "handbuch.ersatzsprache": "بالألمانية، غير متوفر بلغتك بعد",
      "handbuch.deutschPflicht": "العنوان والنص بالألمانية إلزاميان، والباقي اختياري.",
      "rechte.nurBuero": "هذه الصفحة للمكتب.",
      "rechte.nurBueroHinweis": "حسابك لا يشملها. إن احتجت شيئاً منها فأبلغ المكتب.",
      "rechte.zurueck": "العودة إلى يومي",
      "einladung.titel": "أهلاً بك",
      "einladung.hinweis": "اختر كلمة مرور، اثني عشر حرفاً على الأقل.",
      "einladung.passwort": "كلمة المرور",
      "einladung.wiederholen": "أعد كلمة المرور",
      "einladung.ungleich": "كلمتا المرور غير متطابقتين.",
      "einladung.ungueltig": "هذا الرابط غير صالح أو منتهٍ أو مستخدم من قبل.",
      "einladung.starten": "ابدأ",
      "meinezeit.titel": "ساعاتي",
      "meinezeit.ist": "المُنجَز",
      "meinezeit.soll": "المطلوب",
      "meinezeit.saldoMonat": "رصيد الشهر",
      "meinezeit.tage": "الأيام",
      "meinezeit.nichtGestempelt": "لم يُسجَّل",
      "meinezeit.saldoGesamt": "إجمالي الساعات الإضافية منذ {{seit}}",
      "meinezeit.rechnung": "{{wochenstunden}} ساعة أسبوعياً · المُنجَز {{ist}} · المطلوب {{soll}}",
      "meinezeit.ohneSoll": "لم تُسجَّل لك ساعات أسبوعية بعد. بدونها لا يمكن حساب الرصيد. أبلغ المكتب.",
      "antrag.titel": "الطلبات",
      "antrag.hinweis": "إجازة ومرض وتصحيح وقت.",
      "antrag.hinweisChef": "طلبات موظفيك المفتوحة.",
      "antrag.neuAbwesenheit": "إجازة أو مرض",
      "antrag.neuKorrektur": "تصحيح وقت",
      "antrag.abwesenheiten": "الإجازات والغياب",
      "antrag.korrekturen": "تصحيحات الوقت",
      "antrag.leer": "لا يوجد شيء.",
      "antrag.artLabel": "النوع",
      "antrag.art.vacation": "إجازة",
      "antrag.art.sick": "مرض",
      "antrag.art.unpaid": "بدون أجر",
      "antrag.art.special": "إجازة خاصة",
      "antrag.art.training": "تدريب",
      "antrag.von": "من",
      "antrag.bis": "إلى",
      "antrag.bisHinweis": "اتركه فارغاً ليوم واحد.",
      "antrag.halberErster": "اليوم الأول نصف",
      "antrag.halberLetzter": "اليوم الأخير نصف",
      "antrag.grund": "ملاحظة",
      "antrag.datum": "التاريخ",
      "antrag.einreichen": "إرسال",
      "antrag.genehmigen": "موافقة",
      "antrag.ablehnen": "رفض",
      "antrag.zurueckziehen": "سحب",
      "antrag.entschieden": "تم البت في {{am}} بواسطة {{von}}",
      "antrag.tage_zero": "{{count}} يوم",
      "antrag.tage_one": "يوم واحد",
      "antrag.tage_two": "يومان",
      "antrag.tage_few": "{{count}} أيام",
      "antrag.tage_many": "{{count}} يوماً",
      "antrag.tage_other": "{{count}} يوم",
      "antrag.status.requested": "مفتوح",
      "antrag.status.approved": "موافق عليه",
      "antrag.status.rejected": "مرفوض",
      "antrag.status.cancelled": "مسحوب",
      "antrag.korrekturHinweis": "أدخل الوقت الذي عملت فيه فعلاً. المكتب يقرر، وعندها فقط يتغير السجل.",
      "antrag.keineBuchung": "لا يوجد تسجيل في هذا اليوم. عندها ينشئ الطلب يوم عمل كاملاً.",
      "antrag.korrigiertBuchung": "سيتم تصحيح التسجيل من {{von}} إلى {{bis}}.",
      "antrag.welcheBuchung": "أي تسجيل",
      "antrag.buchungWaehlen": "يرجى الاختيار",
      "team.titel": "الفريق",
      "team.hinweis": "الحسابات والساعات الأسبوعية والعطلات.",
      "team.einladen": "دعوة موظف",
      "team.name": "الاسم",
      "team.email": "البريد",
      "team.emailHinweis": "بهذا يسجّل الدخول. غيّره إذا لم يعد العنوان متاحًا؛ تبقى كل البيانات مرتبطة بهذا الشخص.",
      "team.zugangHinweis": "إذا لم يعد أحدهم يستطيع الدخول لفقدان كلمة المرور أو البريد: صحّح العنوان أعلاه، احفظ، ثم أرسل دعوة جديدة من هنا. سيختار كلمة مرور جديدة بنفسه. لا يُنشأ حساب ثانٍ، وتبقى الأوقات والتقارير كما هي.",
      "team.zugangNeu": "إعداد الدخول من جديد",
      "team.zugangGesendet": "أُرسلت الدعوة إلى {{an}}. صالحة سبعة أيام.",
      "team.zugangOhneMail": "لا يوجد خادم بريد. مرّر هذا الرابط، وهو صالح سبعة أيام:",
      "team.rolleLabel": "الدور",
      "team.rolle.admin": "الإدارة",
      "team.rolle.lead": "رئيس عمال",
      "team.rolle.employee": "موظف",
      "team.einladungSenden": "إرسال الدعوة",
      "team.einladenHinweis": "يصله رابط بالبريد ويختار كلمة مروره بنفسه. أنت لا تعرفها.",
      "team.keinVersand": "لا يُرسَل بريد. أعطه هذا الرابط شخصياً، وهو صالح سبعة أيام.",
      "team.wochenstunden": "الساعات الأسبوعية",
      "team.wochenstundenHinweis": "من العقد. بدون هذه القيمة لا توجد ساعات إضافية.",
      "team.wochenstundenWert": "{{stunden}} ساعة أسبوعياً",
      "team.ohneWochenstunden": "لا ساعات أسبوعية مسجلة",
      "team.eintritt": "تاريخ الالتحاق",
      "team.eintrittHinweis": "يُحسب الرصيد الإجمالي من هنا.",
      "team.faehrtMit": "يركب مع",
      "team.faehrtMitHinweis": "لمن لا سيارة له. لا يخطط الاقتراح الأسبوعي له وحده، بل على مواعيد سائقه.",
      "team.faehrtSelbst": "يقود بنفسه",
      "team.wohnort": "مكان السكن",
      "team.wohnortHinweis": "المدينة فقط، لا العنوان. الطريق إليها وقت خاص؛ يحدد فقط من أي طرف يبدأ المسار المحسّن. يُبحث عن الإحداثية عند الحفظ.",
      "team.planPosition": "الترتيب في جدول العمل",
      "team.planPositionHinweis": "الرقم الأصغر يظهر على اليمين. الفراغ يعني في الآخر، مرتبًا بالاسم. للعرض فقط: الرقم لا يدل على رتبة أو مؤهل.",
      "team.imDienstplan": "عمود في جدول العمل",
      "team.imDienstplanHinweis": "من لا يُخطَّط له أبدًا لا يحتاج عمودًا فارغًا. الإخفاء لا يمنع شيئًا: إذا حصل على موعد يظهر العمود في ذلك اليوم.",
      "team.imDienstplanAn": "إظهار عمود خاص",
      "team.wohnortOhneTreffer": "لم يُعثر على إحداثية لهذا المكان. يبقى اتجاه المسار كما هو.",
      "team.faehrtMitWert": "يركب مع {{name}}",
      "team.nurAushilfe": "{{abteilung}}: للمساعدة فقط",
      "team.abteilungAushilfe": "{{abteilung}} (مساعدة)",
      "team.seit": "منذ {{datum}}",
      "team.bis": "حتى {{datum}}",
      "team.austritt": "إنهاء الخدمة",
      "team.austrittHinweis": "ينهي علاقة العمل ويحجب الدخول.",
      "team.austrittWarnung": "يُحجب الحساب، وتُسجَّل جميع الأجهزة خارج النظام، وتُحذف الورديات المقبلة، وتُحرَّر المهام المفتوحة لإعادة توزيعها. تبقى ساعات العمل والـ Reports كاملة.",
      "team.austrittDatum": "آخر يوم عمل",
      "team.austrittGrund": "السبب",
      "team.austrittGrundHinweis": "اختياري، يُحفظ في السجل فقط",
      "team.austrittBestaetigen": "تنفيذ إنهاء الخدمة",
      "team.austrittFertig": "{{name}} أنهى الخدمة",
      "team.bilanzGeraete_zero": "لم يُسجَّل أي جهاز خارج النظام",
      "team.bilanzGeraete_one": "تم تسجيل جهاز واحد خارج النظام",
      "team.bilanzGeraete_two": "تم تسجيل جهازين خارج النظام",
      "team.bilanzGeraete_few": "تم تسجيل {{count}} أجهزة خارج النظام",
      "team.bilanzGeraete_many": "تم تسجيل {{count}} جهازاً خارج النظام",
      "team.bilanzGeraete_other": "تم تسجيل {{count}} جهاز خارج النظام",
      "team.bilanzDienste_zero": "لم تُحذف أي وردية مخطَّطة",
      "team.bilanzDienste_one": "تم حذف وردية مخطَّطة واحدة",
      "team.bilanzDienste_two": "تم حذف ورديتين مخطَّطتين",
      "team.bilanzDienste_few": "تم حذف {{count}} ورديات مخطَّطة",
      "team.bilanzDienste_many": "تم حذف {{count}} وردية مخطَّطة",
      "team.bilanzDienste_other": "تم حذف {{count}} وردية مخطَّطة",
      "team.bilanzAuftraege_zero": "لا توجد مهام تنتظر إعادة التوزيع",
      "team.bilanzAuftraege_one": "مهمة واحدة تنتظر إعادة التوزيع",
      "team.bilanzAuftraege_two": "مهمتان تنتظران إعادة التوزيع",
      "team.bilanzAuftraege_few": "{{count}} مهام تنتظر إعادة التوزيع",
      "team.bilanzAuftraege_many": "{{count}} مهمة تنتظر إعادة التوزيع",
      "team.bilanzAuftraege_other": "{{count}} مهمة تنتظر إعادة التوزيع",
      "team.bilanzZeiten": "تبقى ساعات العمل والـ Reports محفوظة.",
      "team.wiedereintritt": "إعادة التوظيف",
      "team.aktiv": "الحساب نشط",
      "team.stillgelegt": "معطل",
      "team.zustand.arbeitet": "يعمل منذ {{zeit}}",
      "team.zustand.pause": "في استراحة",
      "team.zustand.vergessen": "نسي تسجيل الانصراف",
      "team.zustand.nichtDa": "لم يسجّل الحضور",
      "team.feiertage": "العطلات الرسمية",
      "leistung.titel": "الساعات المقررة أسبوعيا",
      "leistung.gesamt": "{{stunden}} إجمالا",
      "leistung.leer": "لا توجد ساعات مقررة بعد.",
      "wochentag.1": "الاثنين",
      "wochentag.2": "الثلاثاء",
      "wochentag.3": "الأربعاء",
      "wochentag.4": "الخميس",
      "wochentag.5": "الجمعة",
      "wochentag.6": "السبت",
      "wochentag.7": "الأحد",
      "leistung.festerTag": "يوم ثابت",
      "leistung.festerTagHinweis": "لا تحدده إلا إذا كان اليوم غير قابل للتغيير فعلاً.",
      "leistung.festeZeit": "وقت ثابت",
      "leistung.festeZeitHinweis": "فقط مع يوم ثابت. الفراغ يعني: اليوم ثابت والوقت حر.",
      "leistung.rhythmus": "الإيقاع",
      "leistung.rhythmusHinweis": "لبيتين متجاورين يتناوبان. ما لا يحين هذا الأسبوع لا يظهر في قائمة الاحتياج. في تقرير العميل يُحتسب المتوسط: كل أسبوعين يعني نصف الوقت شهريًا.",
      "leistung.jedeWoche": "كل أسبوع",
      "leistung.alleWochen": "كل {{wochen}} أسابيع",
      "leistung.rhythmusAb": "أول أسبوع مستحق",
      "leistung.rhythmusAbHinweis": "يبدأ العد من هذا الأسبوع. أي يوم يكفي، ويأخذ النظام إثنين ذلك الأسبوع.",
      "leistung.rhythmusZeile": "كل {{wochen}} أسابيع، بدءًا من أسبوع {{ab}}",
      "leistung.freiPlanbar": "قابل للجدولة بحرية",
      "leistung.festTagZeit": "ثابت: {{tag}} الساعة {{zeit}}",
      "leistung.festNurTag": "ثابت: {{tag}}، الوقت حر",
      "leistung.neu": "إضافة ساعات مقررة",
      "leistung.loeschenSicher": "هل تحذف هذه الساعات المقررة؟",
      "leistung.stundenProWoche": "ساعات في الأسبوع",
      "leistung.stundenHinweis": "ساعات عمل وليست وقت تقويم: أربع ساعات حديقة تعني أيضا بستانيين لمدة ساعتين.",
      "leistung.von": "صالح من",
      "leistung.bis": "صالح حتى",
      "leistung.zeitraumHinweis": "الفراغ يعني: صالح دائما. أضف سطرا للصيف وآخر للشتاء.",
      "leistung.abDatum": "من {{datum}}",
      "leistung.bisDatum": "حتى {{datum}}",
      "team.abteilungen": "الأقسام",
      "team.abteilungenHinweis": "ما يمكن تكليف هذا الشخص به. يمكنه المساعدة في أي مكان، والخطة تنبه إلى ذلك.",
      "team.abteilungenListeHinweis": "حديقة، مسبح، تنظيف، تقنية. لا يحذف القسم أبدا بل يعطل: ترتبط به مواعيد وساعات مقررة سابقة.",
      "team.abteilungName": "اسم القسم",
      "team.abteilungHinzu": "إنشاء قسم",
      "team.abteilungBelegt": "{{menschen}} موظفين · {{objekte}} عقارات",
      "team.stilllegen": "تعطيل",
      "team.wiederAufnehmen": "إعادة التفعيل",
      "team.jahr": "السنة",
      "team.feiertagName": "الاسم",
      "team.feiertagHinzu": "إضافة",
      "team.feiertageHinweis": "قائمة تُحدَّث يدوياً، لأن في مايوركا تتداخل العطلات الوطنية والبليارية والمحلية. العطلة تخفض المطلوب بيوم عمل واحد.",
      "aktion.fertig": "تم",
      "nav.plan": "جدول العمل",
      "tag.titel": "مرحباً {{name}}",
      "tag.nichtBegonnen": "لم يبدأ يوم عملك بعد.",
      "tag.beginnen": "بدء يوم العمل",
      "tag.beenden": "إنهاء يوم العمل",
      "tag.termine": "اليوم",
      "tag.keineTermine": "لا يوجد شيء مخطط لليوم.",
      "tag.navigieren": "التوجيه",
      "tag.einsatzStart": "بدء الزيارة",
      "tag.einsatzEnde": "إنهاء الزيارة",
      "tag.checkliste": "القائمة",
      "tag.checklisteWaehlen": "أي قائمة فحص؟",
      "tag.wegfahrtTitel": "ما زالت هناك مهمة مفتوحة",
      "tag.wegfahrtText": "هناك مهمة جارية في {{objekt}} منذ {{seit}}. متى غادرت المكان؟",
      "tag.wegfahrtFahrt_zero": "لا طريق من هناك إلى هنا",
      "tag.wegfahrtFahrt_one": "نحو دقيقة طريق من هناك إلى هنا",
      "tag.wegfahrtFahrt_two": "نحو دقيقتين طريق من هناك إلى هنا",
      "tag.wegfahrtFahrt_few": "نحو {{count}} دقائق طريق من هناك إلى هنا",
      "tag.wegfahrtFahrt_many": "نحو {{count}} دقيقة طريق من هناك إلى هنا",
      "tag.wegfahrtFahrt_other": "نحو {{count}} دقيقة طريق من هناك إلى هنا",
      "tag.wegfahrtFrage": "غادرت في",
      "tag.wegfahrtUebernehmen": "اعتماد والبدء",
      "tag.wegfahrtEben": "كنت هناك حتى الآن",
      "tag.wegfahrtUngueltig": "يجب أن يكون الوقت بعد البداية وألا يقع في المستقبل.",
      "tag.laeuft": "جارية",
      "tag.erledigt": "منجزة",
      "tag.imEinsatz": "في {{objekt}} منذ {{seit}}",
      "tag.gestempelt": "المسجل اليوم",
      "tag.ungeplant": "غير مخططة",
      "tag.ungeplantOeffnen": "زيارة غير مخططة",
      "tag.ungeplantHinweis": "فقط إذا لم يكن هناك موعد لها. يراها المكتب كغير مخططة.",
      "tag.ungeplantLaeuft": "زيارة غير مخططة في {{objekt}} منذ {{seit}}",
      "tag.keineCheckliste": "لا توجد قائمة مُعدة لهذا العقار.",
      "plan.titel": "جدول العمل",
      "plan.ansichtTag": "يوم",
      "plan.ansichtWoche": "أسبوع",
      "plan.terminAendern": "تعديل الموعد",
      "plan.datum": "التاريخ",
      "plan.frei": "خالٍ",
      "plan.loeschenSicher": "هل تريد حذف هذا الموعد؟",
      "plan.ziehenHinweis": "السحب ينقل الموعد: جانبا إلى موظف آخر، وإلى أعلى أو أسفل إلى وقت آخر، وإلى يوم في الشريط إلى يوم آخر. والنقر يفتحه للتعديل أو الحذف.",
      "plan.termineZahl_zero": "لا مواعيد",
      "plan.termineZahl_one": "موعد واحد",
      "plan.termineZahl_two": "موعدان",
      "plan.termineZahl_few": "{{count}} مواعيد",
      "plan.termineZahl_many": "{{count}} موعدا",
      "plan.termineZahl_other": "{{count}} موعد",
      "plan.konflikteZahl_zero": "لا تعارضات",
      "plan.konflikteZahl_one": "تعارض واحد",
      "plan.konflikteZahl_two": "تعارضان",
      "plan.konflikteZahl_few": "{{count}} تعارضات",
      "plan.konflikteZahl_many": "{{count}} تعارضا",
      "plan.konflikteZahl_other": "{{count}} تعارض",
      "plan.hinweis": "ما يظهر هنا يراه الموظفون كيومهم.",
      "plan.zurueck": "الأسبوع السابق",
      "plan.vor": "الأسبوع التالي",
      "plan.heute": "هذا الأسبوع",
      "plan.neu": "موعد",
      "plan.neuerTermin": "موعد جديد في {{tag}}",
      "plan.wiederholungen": "أسابيع",
      "plan.wiederholungenHinweis": "1 تعني مرة واحدة. 12 تنشئ اثني عشر أسبوعاً مسبقاً.",
      "plan.notiz": "ملاحظة للموظف",
      "plan.konfliktAbwesenheit": "غياب معتمد: {{art}}",
      "plan.konfliktUeberschneidung": "يتداخل مع وردية أخرى",
      "plan.konfliktFeiertag": "عطلة رسمية: {{name}}",
      "plan.ohneKoordinate": "عقار بلا إحداثيات، لا فحص للمسافة",
      "plan.gestempelt": "تم التسجيل هنا بالفعل",
      "plan.ansichtBedarf": "الاحتياج",
      "plan.abteilung": "القسم",
      "plan.ohneAbteilung": "بدون قسم",
      "plan.team": "الفريق",
      "plan.teamHinweis": "يمكن اختيار أكثر من شخص. أربع ساعات حديقة تعني بستانيين لمدة ساعتين.",
      "plan.teamZahl_zero": "لا أحد",
      "plan.teamZahl_one": "شخص واحد",
      "plan.teamZahl_two": "شخصان",
      "plan.teamZahl_few": "{{count}} أشخاص",
      "plan.teamZahl_many": "{{count}} شخصا",
      "plan.teamZahl_other": "{{count}} شخص",
      "plan.gemeinsamMit": "مع {{namen}}",
      "plan.arbeitsstunden_zero": "{{stunden}} عمل",
      "plan.arbeitsstunden_one": "{{stunden}} عمل، شخص واحد",
      "plan.arbeitsstunden_two": "{{stunden}} عمل، شخصان معا",
      "plan.arbeitsstunden_few": "{{stunden}} عمل، {{count}} أشخاص معا",
      "plan.arbeitsstunden_many": "{{stunden}} عمل، {{count}} شخصا معا",
      "plan.arbeitsstunden_other": "{{stunden}} عمل، {{count}} شخص معا",
      "plan.konfliktFachfremd": "غير مسجل في قسم {{abteilung}}",
      "plan.bedarfLeer": "لا يوجد عقار بساعات مقررة.",
      "plan.bedarfOffen_zero": "كل الخدمات مخططة هذا الأسبوع.",
      "plan.bedarfOffen_one": "خدمة واحدة غير مخططة بالكامل هذا الأسبوع.",
      "plan.bedarfOffen_two": "خدمتان غير مخططتين بالكامل هذا الأسبوع.",
      "plan.bedarfOffen_few": "{{count}} خدمات غير مخططة بالكامل هذا الأسبوع.",
      "plan.bedarfOffen_many": "{{count}} خدمة غير مخططة بالكامل هذا الأسبوع.",
      "plan.bedarfOffen_other": "{{count}} خدمة غير مخططة بالكامل هذا الأسبوع.",
      "plan.bedarfObjekt": "العقار",
      "plan.bedarfSoll": "المقرر",
      "plan.bedarfGeplant": "المخطط",
      "plan.bedarfRest": "المتبقي",
      "plan.farbeLaeuft": "بنفسجي: أحدهم مسجل دخوله الآن",
      "plan.farbeBeendet": "أخضر: انتهت الزيارة",
      "plan.notizHinweis": "دائمة على العقار. يراها الموظف بالأسود.",
      "plan.aenderung": "تغيير لهذا اليوم",
      "plan.aenderungHinweis": "يظهر بالأحمر أعلى الموعد عند الموظف. اتركه فارغا إن لم يتغير شيء اليوم.",
      "plan.aenderungGelesen": "قرأه {{name}} في {{zeit}}.",
      "plan.aenderungUngelesen": "لم يقرأ بعد.",
      "plan.aenderungUngelesenKurz": "غير مقروء",
      "tag.aenderung": "مختلف اليوم",
      "tag.aenderungGelesen": "قرأت",
      "tag.aenderungQuittiert": "سجل كمقروء.",
      "notiz.titel": "ملاحظة داخلية",
      "pruefung.team": "تملأون هذا التقرير معا: {{namen}}. اقتسموا القائمة وإلا كتب أحدكم فوق الآخر.",
      "pruefung.nichtGespeichert": "لم يحفظ. راجع الإدخال ثم انقر خارج الحقل مرة أخرى.",
      "pruefung.fortschrittGesamt": "{{erledigt}} من {{gesamt}} في التقرير كله",
      "pruefung.nurMeineBereiche": "ترى المجالات التي يغطيها قسمك اليوم. أما البقية فيدخلها زميلك.",
      "pruefung.weitereFotos": "صور إضافية",
      "pruefung.weitereFotosHinweis": "صور لا تخص بندًا بعينه: الجولة، المدخل، الانطباع العام. تظهر في نهاية التقرير بلا عنوان.",
      "team.abteilungBereich": "المجالات في التقرير",
      "team.abteilungBereichHinweis": "أي نقاط الفحص يراها هذا القسم في التقرير. عدم التأشير يعني كلها.",
      "muster.titel": "تقارير نموذجية لمعاينة البوابة",
      "wasser.titel": "استهلاك الماء",
      "wasser.ruhig": "لا عقار يستهلك حاليا أكثر من المعتاد بشكل لافت.",
      "wasser.auffaellige_zero": "لا عقار لافت.",
      "wasser.auffaellige_one": "عقار واحد يستهلك أكثر من المعتاد بكثير. يستحق الفحص.",
      "wasser.auffaellige_two": "عقاران يستهلكان أكثر من المعتاد بكثير. يستحق الفحص.",
      "wasser.auffaellige_few": "{{count}} عقارات تستهلك أكثر من المعتاد بكثير. يستحق الفحص.",
      "wasser.auffaellige_many": "{{count}} عقارا تستهلك أكثر من المعتاد بكثير. يستحق الفحص.",
      "wasser.auffaellige_other": "{{count}} عقار يستهلك أكثر من المعتاد بكثير. يستحق الفحص.",
      "wasser.objekt": "العميل والعقار",
      "wasser.proTag": "م³ يوميا",
      "wasser.ueblich": "المعتاد",
      "wasser.woche": "آخر 7 أيام",
      "wasser.monat": "الشهر يوميا",
      "wasser.vormonat": "الشهر السابق",
      "wasser.abgelesen": "تاريخ القراءة",
      "wasser.marke": "لافت",
      "wasser.tage_zero": "خلال أيام",
      "wasser.tage_one": "خلال يوم واحد",
      "wasser.tage_two": "خلال يومين",
      "wasser.tage_few": "خلال {{count}} أيام",
      "wasser.tage_many": "خلال {{count}} يوما",
      "wasser.tage_other": "خلال {{count}} يوم",
      "wasser.alleZeigen": "عرض العقارات الـ{{count}}",
      "wasser.hinweis": "تتم مقارنة الاستهلاك اليومي بما هو معتاد في هذا العقار: المنزل الفارغ يقارن بأسابيع فارغة سابقة، والمشغول بأسابيع مشغولة. الأحمر مع العلامة يعني أنه كان فارغًا واستهلك مع ذلك أكثر بكثير من المعتاد، وهذه هي الحالة التي تستحق المتابعة. الكهرماني يعني فقط أكثر من المعتاد. العقار بلا إقامات مسجلة يُعد فارغًا.",
      "wasser.verdacht_zero": "لا يوجد عقار من هذا النوع",
      "wasser.verdacht_one": "عقار واحد كان فارغًا واستهلك مع ذلك أكثر من المعتاد بوضوح. هذه هي الحالة التي تستحق المتابعة.",
      "wasser.verdacht_two": "عقاران كانا فارغين واستهلكا مع ذلك أكثر من المعتاد بوضوح.",
      "wasser.verdacht_few": "{{count}} عقارات كانت فارغة واستهلكت مع ذلك أكثر من المعتاد بوضوح.",
      "wasser.verdacht_many": "{{count}} عقارًا كانت فارغة واستهلكت مع ذلك أكثر من المعتاد بوضوح.",
      "wasser.verdacht_other": "{{count}} عقار كانت فارغة واستهلكت مع ذلك أكثر من المعتاد بوضوح.",
      "wasser.haus": "المنزل",
      "wasser.hausLeer": "فارغ",
      "wasser.hausBelegt_zero": "مشغول",
      "wasser.hausBelegt_one": "مشغول، يوم واحد",
      "wasser.hausBelegt_two": "مشغول، يومان",
      "wasser.hausBelegt_few": "مشغول، {{count}} أيام",
      "wasser.hausBelegt_many": "مشغول، {{count}} يومًا",
      "wasser.hausBelegt_other": "مشغول، {{count}} يوم",
      "wasser.grundlast": "المعتاد وهو فارغ",
      "wasser.markeMehr": "أكثر من المعتاد",
      "wasser.vergleich.leer": "الأسابيع الفارغة",
      "wasser.vergleich.belegt": "الأسابيع المشغولة",
      "wasser.vergleich.alle": "كل الأسابيع",
      "muster.hinweis": "ينشئ تقارير كاملة ومعتمدة لعميل له عقار واحد فقط، اثنان في الأسبوع، مع عداد الماء وقيم المسبح. للعرض فقط: لا ترسل أبدا، وتحمل داخل المكتب ملاحظة \"تقرير نموذجي\"، ويمكن إزالتها في أي وقت.",
      "muster.kunde": "العميل",
      "muster.kundeWaehlen": "اختر من فضلك",
      "muster.monat": "الشهر",
      "muster.anzahl": "العدد",
      "muster.anzahlHinweis": "الثلاثاء والجمعة، اثنا عشر كحد أقصى",
      "muster.anlegen": "إنشاء تقارير نموذجية",
      "muster.entfernen": "إزالة التقارير النموذجية",
      "muster.angelegt_zero": "لم ينشأ أي تقرير نموذجي لـ {{kunde}}",
      "muster.angelegt_one": "أنشئ تقرير نموذجي واحد لـ {{kunde}}، {{punkte}} نقطة لكل منه. المواعيد: {{tage}}",
      "muster.angelegt_two": "أنشئ تقريران نموذجيان لـ {{kunde}}، {{punkte}} نقطة لكل منهما. المواعيد: {{tage}}",
      "muster.angelegt_few": "أنشئت {{count}} تقارير نموذجية لـ {{kunde}}، {{punkte}} نقطة لكل منها. المواعيد: {{tage}}",
      "muster.angelegt_many": "أنشئ {{count}} تقريرا نموذجيا لـ {{kunde}}، {{punkte}} نقطة لكل منها. المواعيد: {{tage}}",
      "muster.angelegt_other": "أنشئ {{count}} تقرير نموذجي لـ {{kunde}}، {{punkte}} نقطة لكل منها. المواعيد: {{tage}}",
      "muster.entfernt_zero": "لم تزل أي تقارير نموذجية.",
      "muster.entfernt_one": "أزيل تقرير نموذجي واحد.",
      "muster.entfernt_two": "أزيل تقريران نموذجيان.",
      "muster.entfernt_few": "أزيلت {{count}} تقارير نموذجية.",
      "muster.entfernt_many": "أزيل {{count}} تقريرا نموذجيا.",
      "muster.entfernt_other": "أزيل {{count}} تقرير نموذجي.",
      "notiz.hinweis": "للمكتب فقط. ولا في تقرير المالك.",
      "notiz.platzhalter": "ما ينبغي أن يعرفه المكتب ولا يعرفه العميل.",
      "notiz.reiter": "الملاحظات الداخلية",
      "notiz.reiterHinweis": "ما دونه الفريق في الموقع. المؤشر يعني الأرشفة لا الحذف.",
      "notiz.zeigeErledigte": "عرض المنجزة",
      "notiz.zeigeOffene": "عرض المفتوحة",
      "notiz.keineOffenen": "لا ملاحظات مفتوحة.",
      "notiz.keineErledigten": "لم يؤشر على شيء بعد.",
      "notiz.von": "{{name}}، التقرير {{nummer}}",
      "notiz.zumBericht": "فتح التقرير",
      "notiz.erledigt": "منجزة",
      "notiz.wiederOeffnen": "إعادة الفتح",
      "notiz.abgehakt": "أشر عليها {{name}} في {{datum}}.",
      "plan.ablage": "الخدمات المتبقية",
      "plan.ablageHinweis": "اسحبها إلى أحد الأعمدة. اختيار 1 أو 2 يسري على كل سطور القسم نفسه.",
      "plan.ablageLeer": "كل شيء مخطط هذا الأسبوع.",
      "plan.ablageZeile": "{{offen}} متبقية، {{dauer}} في الموقع",
      "plan.ablageEiner": "يذهب شخص واحد",
      "plan.ablageZwei": "يذهب شخصان",
      "plan.ablageKeinBeifahrer": "لا يوجد مرافق مسجل لـ {{name}}. الذهاب باثنين ممكن فقط حيث يرافق أحدهم الآخر.",
      "plan.ablageErgaenzt": "أضيف القسم إلى الموعد القائم: {{objekt}}.",
      "plan.ansichtVorschlag": "اقتراح",
      "plan.vorschlagHinweis": "مسودة مرتبة حسب القرب. لا يسجل إلا ما توافق عليه.",
      "plan.vorschlagAlle_zero": "لا مواعيد للاعتماد",
      "plan.vorschlagAlle_one": "اعتماد موعد واحد",
      "plan.vorschlagAlle_two": "اعتماد موعدين",
      "plan.vorschlagAlle_few": "اعتماد {{count}} مواعيد",
      "plan.vorschlagAlle_many": "اعتماد {{count}} موعدا",
      "plan.vorschlagAlle_other": "اعتماد {{count}} موعد",
      "plan.vorschlagLeer": "لا يوجد ما يقترح لهذا الأسبوع.",
      "plan.vorschlagUebernehmen": "اعتماد",
      "plan.vorschlagVerwerfen": "تجاهل",
      "plan.vorschlagOffen": "يبقى مفتوحا",
      "plan.grundKeineFachkraft": "لا أحد مسجل في هذا القسم",
      "plan.grundKeinPlatz": "لا يوجد وقت متاح هذا الأسبوع",
      "plan.grundFesttermin": "الموعد الثابت غير مناسب: اليوم أو الوقت محجوز",
      "plan.grundNurMitfahrt": "قصير جدا على رحلة خاصة، ولا توجد زيارة لضمه إليها",
      "plan.tagAusrichten": "ضبط اليوم",
      "plan.routeOptimieren": "تحسين المسار",
      "plan.ausrichtenKurz": "ضبط",
      "plan.routeKurz": "مسار",
      "plan.vorschlagNurFuer": "مسودة لـ {{name}} فقط. ومن يركب معه مشمول.",
      "plan.routeKuerzer_zero": "بلا توفير في وقت القيادة",
      "plan.routeKuerzer_one": "دقيقة قيادة أقل",
      "plan.routeKuerzer_two": "دقيقتان قيادة أقل",
      "plan.routeKuerzer_few": "{{count}} دقائق قيادة أقل",
      "plan.routeKuerzer_many": "{{count}} دقيقة قيادة أقل",
      "plan.routeKuerzer_other": "{{count}} دقيقة قيادة أقل",
      "plan.routeSchonKurz": "الترتيب كان بالفعل الأقصر",
      "plan.routeFest_zero": "لم يبق أي موعد في مكانه",
      "plan.routeFest_one": "بقي موعد في مكانه",
      "plan.routeFest_two": "بقي موعدان في مكانهما",
      "plan.routeFest_few": "بقيت {{count}} مواعيد في مكانها",
      "plan.routeFest_many": "بقي {{count}} موعدا في مكانه",
      "plan.routeFest_other": "بقي {{count}} موعد في مكانه",
      "plan.ausgerichtet_zero": "لم يُنقل أي موعد",
      "plan.ausgerichtet_one": "نُقل موعد واحد",
      "plan.ausgerichtet_two": "نُقل موعدان",
      "plan.ausgerichtet_few": "نُقلت {{count}} مواعيد",
      "plan.ausgerichtet_many": "نُقل {{count}} موعدا",
      "plan.ausgerichtet_other": "نُقل {{count}} موعد",
      "plan.pauseGesetzt": "الاستراحة من {{von}} إلى {{bis}}",
      "plan.pauseImTermin": "أحد المواعيد أطول من أن تقع الاستراحة بين المواعيد. تقع داخله ويتوقف وقت العمل خلالها.",
      "plan.ueberzug_zero": "بلا تجاوز لنهاية الدوام",
      "plan.ueberzug_one": "دقيقة بعد نهاية الدوام",
      "plan.ueberzug_two": "دقيقتان بعد نهاية الدوام",
      "plan.ueberzug_few": "{{count}} دقائق بعد نهاية الدوام",
      "plan.ueberzug_many": "{{count}} دقيقة بعد نهاية الدوام",
      "plan.ueberzug_other": "{{count}} دقيقة بعد نهاية الدوام",
      "plan.pause": "استراحة",
      "plan.pauseHinweis": "مخطط لها، وليست مسجلة",
      "tag.pausePlan": "هكذا هو المخطط. تُسجل الاستراحة بالزر في الأعلى.",
      "plan.bereiche": "المجالات في هذه الزيارة",
      "plan.bereicheHinweis": "يمكن اختيار عدة مجالات. المسبح وفحص المنزل في رحلة واحدة موعد واحد.",
      "plan.minuten": "دقيقة",
      "plan.bereicheSumme": "تم توزيع {{summe}} من {{dauer}} دقيقة",
      "plan.bereichMinuten_zero": "بلا دقائق",
      "plan.bereichMinuten_one": "دقيقة",
      "plan.bereichMinuten_two": "دقيقتان",
      "plan.bereichMinuten_few": "{{count}} دقائق",
      "plan.bereichMinuten_many": "{{count}} دقيقة",
      "plan.bereichMinuten_other": "{{count}} دقيقة",
      "plan.wieGewohnt": "كالمعتاد يوم {{tag}}",
      "plan.abweichendVomGewohnten": "مختلف، عادةً {{tag}}",
      "plan.grundOhneKoordinate": "عقار بلا إحداثيات، زمن الطريق غير معروف",
      "plan.anfahrtMinuten_zero": "بلا طريق",
      "plan.anfahrtMinuten_one": "دقيقة طريق",
      "plan.anfahrtMinuten_two": "دقيقتا طريق",
      "plan.anfahrtMinuten_few": "{{count}} دقائق طريق",
      "plan.anfahrtMinuten_many": "{{count}} دقيقة طريق",
      "plan.anfahrtMinuten_other": "{{count}} دقيقة طريق",
      "plan.fahrtKurz": "{{minuten}} د",
      "plan.fahrtLang": "الطريق نحو {{km}} كم، {{minuten}} دقيقة",
      "plan.fahrtTitel": "الطريق المقدر: {{km}} كم، {{minuten}} دقيقة",
      "plan.fahrtZuKnapp_zero": "بلا متسع",
      "plan.fahrtZuKnapp_one": "دقيقة واحدة فقط متسع",
      "plan.fahrtZuKnapp_two": "دقيقتان فقط متسع",
      "plan.fahrtZuKnapp_few": "{{count}} دقائق فقط متسع",
      "plan.fahrtZuKnapp_many": "{{count}} دقيقة فقط متسع",
      "plan.fahrtZuKnapp_other": "{{count}} دقيقة فقط متسع",
      "auswertung.nachMitarbeiter": "حسب الموظف",
      "auswertung.nachKunden": "حسب العميل",
      "auswertung.kunde": "العميل",
      "auswertung.soll": "المتفق عليه",
      "auswertung.ist": "المنجز",
      "auswertung.differenz": "الفرق",
      "auswertung.einsaetze": "المهام",
      "auswertung.summe": "المجموع",
      "auswertung.leer": "لا توجد ساعات مقررة ولا مهام في هذا الشهر.",
      "auswertung.ohneSoll": "ساعات بلا اتفاق مسجل",
      "auswertung.keineEinsaetze": "لم يحضر أحد إلى العقار هذا الشهر.",
      "auswertung.ungeplant": "بلا موعد",
      "auswertung.kosten": "التكاليف",
      "auswertung.material": "المواد",
      "auswertung.fremd": "خدمة خارجية",
      "auswertung.belege": "المواد والتكاليف الخارجية",
      "auswertung.export": "كملف إكسل",
      "auswertung.exportHinweis": "الفوترة والمهام والإيصالات في ملف واحد للمحاسبة.",
      "schnittstelle.titel": "الواجهة البرمجية",
      "schnittstelle.hinweis": "يمنح المفتاح برنامجاً آخر صلاحية القراءة فقط للعملاء والعقارات والمهام والتكاليف وأساس الفوترة. لا يمكن الكتابة عبر الواجهة.",
      "schnittstelle.name": "ما الغرض من المفتاح؟",
      "schnittstelle.nameHinweis": "مثلاً المكتب المحاسبي أو برنامج الفوترة. مفتاح لكل جهة، حتى يمكن إلغاء واحد دون إيقاف الباقي.",
      "schnittstelle.anlegen": "إنشاء مفتاح",
      "schnittstelle.einmalig": "انسخ هذا المفتاح الآن. لن يُعرض مرة أخرى.",
      "schnittstelle.verstanden": "تم النسخ",
      "schnittstelle.leer": "لا يوجد مفتاح بعد.",
      "schnittstelle.angelegt": "أُنشئ",
      "schnittstelle.benutzt": "آخر استخدام",
      "schnittstelle.nieBenutzt": "لم يُستخدم بعد",
      "schnittstelle.widerrufen": "إلغاء",
      "schnittstelle.widerrufenAm": "أُلغي في",
      "demo.titel": "استعراض Jornado",
      "demo.einstiegHinweis": "نظام مُعد بالكامل ببيانات مُختلقة. بلا تسجيل دخول، ولا يُرسل شيء.",
      "demo.code": "رمز الدخول",
      "demo.alsBuero": "الدخول كمكتب",
      "demo.alsMitarbeiter": "الدخول كموظف ميداني",
      "demo.fehler": "تعذّر فتح العرض التوضيحي الآن.",
      "demo.marke": "عرض توضيحي",
      "demo.balken": "كل البيانات هنا مُختلقة. المجالات ونقاط الفحص والأقسام والشعار والألوان تُعد خصيصاً لكل منشأة: ما ترونه مثال وليس قالباً ثابتاً.",
      "demo.zuruecksetzen": "إعادة ضبط العرض",
      "demo.setztZurueck": "جارٍ إعادة الضبط …",
      "nav.kosten": "التكاليف",
      "kosten.titel": "المواد والتكاليف الخارجية",
      "kosten.hinweis": "ما استهلك أو اشتري لعقار ما. تكفي صورة للإيصال.",
      "kosten.neuerEintrag": "إدخال جديد",
      "kosten.objekt": "العقار",
      "kosten.alleObjekte": "كل العقارات",
      "kosten.summe": "المجموع",
      "kosten.material": "المواد",
      "kosten.fremd": "خدمة خارجية",
      "kosten.leer": "لم يسجل شيء هذا الشهر.",
      "kosten.nichtWeiter": "غير قابل لإعادة الفوترة",
      "kosten.belegZeigen": "عرض الإيصال",
      "kosten.wirklichWeg": "هل تحذف هذا الإدخال؟",
      "kosten.datum": "التاريخ",
      "kosten.datumHinweis": "تاريخ الشراء أو التنفيذ. اليوم افتراضيا، ويمكن اختيار تاريخ سابق.",
      "kosten.bezeichnung": "ماذا",
      "kosten.bezeichnungHinweis": "وصف قصير وواضح، مثل ملح المسبح أو كهربائي طوارئ.",
      "kosten.betrag": "المبلغ",
      "kosten.betragHinweis": "باليورو، كما هو مكتوب على الإيصال.",
      "kosten.abteilung": "القسم",
      "kosten.abteilungHinweis": "حتى تظهر التكلفة بجانب الساعات الصحيحة في التقرير.",
      "kosten.ohneAbteilung": "بلا قسم",
      "kosten.menge": "الكمية",
      "kosten.einheit": "الوحدة",
      "kosten.einheitHinweis": "قطعة، كيلوغرام، لتر، ساعة. اختياري.",
      "kosten.lieferant": "المورد",
      "kosten.notiz": "ملاحظة",
      "kosten.beleg": "الإيصال",
      "kosten.belegHinweis": "صورة للإيصال أو الفاتورة. ويمكن الإدخال بدونها.",
      "kosten.weiterberechenbar": "يعاد فوترته على المالك",
      "zeit.einsaetze": "الزيارات",
      "zeit.abstand": "{{meter}} م عن العقار",
      "zeit.zuWeit": "على بعد {{meter}} م من العقار",
      "zeit.ohnePosition": "بلا موقع",
      "zeit.ohneKoordinate": "عقار بلا إحداثيات",
      "zeit.arbeitstag": "يوم العمل",
      "zeit.einsatz": "زيارة",
      "zeit.ungeplant": "غير مخططة",
      "zeit.titel": "ساعات العمل",
      "zeit.hinweis": "السجل وفق المادة 34.9 ET، يُحفظ أربع سنوات. التسجيل يتم في صفحة يومي.",
      "zeit.nichtGestempelt": "لم تسجل الحضور.",
      "zeit.kommen": "تسجيل الحضور",
      "zeit.gehen": "تسجيل الانصراف",
      "zeit.pause": "استراحة",
      "zeit.pauseFaellig_zero": "بلا ساعات عمل بعد",
      "zeit.pauseFaellig_one": "ساعة دون استراحة. حان وقت الاستراحة.",
      "zeit.pauseFaellig_two": "ساعتان دون استراحة. حان وقت الاستراحة.",
      "zeit.pauseFaellig_few": "{{count}} ساعات دون استراحة. حان وقت الاستراحة.",
      "zeit.pauseFaellig_many": "{{count}} ساعة دون استراحة. حان وقت الاستراحة.",
      "zeit.pauseFaellig_other": "{{count}} ساعة دون استراحة. حان وقت الاستراحة.",
      "zeit.pauseEnde": "إنهاء الاستراحة",
      "zeit.inPause": "في استراحة",
      "zeit.seit": "منذ {{zeit}}",
      "zeit.heuteBisher": "اليوم حتى الآن {{dauer}}",
      "zeit.objektOptional": "العقار",
      "zeit.ohneObjekt": "بدون عقار",
      "zeit.wechselAuf": "الانتقال إلى العقار",
      "zeit.wechseln": "انتقال",
      "zeit.vergessenTitel": "ما زالت هناك وردية مفتوحة",
      "zeit.vergessenText": "بدأت في {{beginn}} ولم تُغلق. أدخل وقت الانصراف الحقيقي، لا يُخمَّن شيء.",
      "zeit.echtesEnde": "كان الانصراف",
      "zeit.grund": "السبب",
      "zeit.grundPflicht": "إلزامي. يظهر في السجل.",
      "zeit.nachtragen": "إضافة وردية",
      "zugang.titel": "الدخول",
      "zugang.hinweis": "المفاتيح والبوابة والإنذار. كل اطلاع يُسجَّل.",
      "zugang.neu": "إضافة مدخل",
      "zugang.leer": "لا يوجد شيء محفوظ لهذا العقار.",
      "zugang.anzeigen": "إظهار",
      "zugang.verbergen": "إخفاء",
      "zugang.verstecktGleich": "يُخفى تلقائيًا بعد تسعين ثانية.",
      "zugang.artLabel": "النوع",
      "zugang.bezeichnung": "التسمية",
      "zugang.bezeichnungHinweis": "لماذا، مثلًا بوابة المدخل الشمالي",
      "zugang.wert": "الرقم أو الرمز",
      "zugang.wertUnveraendert": "اتركه فارغًا للإبقاء على الرمز الحالي",
      "zugang.art.key": "مفتاح",
      "zugang.art.alarm": "إنذار",
      "zugang.art.gate": "بوابة",
      "zugang.art.wifi": "واي فاي",
      "zugang.art.safe": "خزنة",
      "zugang.art.other": "أخرى",
      "zeit.auszug": "كشف لمكتب المحاسبة",
      "zeit.register": "طباعة السجل",
      "zeit.monat": "الشهر",
      "zeit.orte.titel": "أين تم التسجيل",
      "zeit.orte.hinweis": "يُحتسب بدء المهمة. الأخضر يعني ضمن {{meter}} متر من العقار، والأحمر أبعد، والرمادي بدون موقع من الهاتف.",
      "zeit.orte.amObjekt": "عند العقار",
      "zeit.orte.zuWeit": "بعيد جدا",
      "zeit.orte.ohnePosition": "بدون موقع",
      "zeit.mitarbeiter": "الموظف",
      "zeit.alle": "الكل",
      "zeit.summe": "المجموع",
      "zeit.leer": "لم يُسجَّل شيء هذا الشهر.",
      "zeit.beginn": "البداية",
      "zeit.ende": "النهاية",
      "zeit.korrigieren": "تصحيح",
      "zeit.korrekturHinweis": "تبقى القيمة الأصلية محفوظة وتظهر في السطر.",
      "zeit.korrigiertAm": "صُحِّح في {{am}} بواسطة {{von}}",
      "zeit.vorher": "قبل ذلك",
      "zeit.manuell": "أُضيف لاحقاً",
      "zeit.pausenSumme": "منها {{dauer}} استراحة",
      "zeit.stornieren": "إلغاء",
      "zeit.storniert": "مُلغى",
      "zeit.storniertAm": "أُلغي في {{am}} بواسطة {{von}}",
      "zeit.stornoHinweis": "يبقى السطر في السجل مشطوباً ولا يُحتسب. لا يمكن التراجع؛ يُصحَّح الإلغاء الخاطئ بإضافة وردية جديدة.",
      "system.sicherung": "النسخ الاحتياطي الليلي",
      "system.sicherungSchutz": "حماية النسخة الاحتياطية",
      "system.verschluesselt": "مشفَّرة",
      "system.unverschluesselt": "غير مشفَّرة، كلمة السر ناقصة",
      "system.sicherungStand": "آخر مرة {{zeit}} · {{groesse}}",
      "system.sicherung.keine": "لا توجد نسخة احتياطية في التخزين.",
      "system.sicherung.unbekannt": "تعذر الاطلاع، التخزين لا يستجيب.",
      "system.speicher": "تخزين الملفات",
      "system.standortdaten": "بيانات الموقع",
      "system.standortStand": "{{anzahl}} نقطة، تُحذف بعد {{tage}} يوماً",
      "system.standortUeberfaellig": "ما زالت هناك نقاط أقدم من {{tage}} يوماً. الحذف لا يعمل.",
      "team.auskunft": "تنزيل البيانات",
      "team.auskunftHinweis": "جميع البيانات المحفوظة عن هذا الشخص كملف، وفق المادة 15 من اللائحة العامة لحماية البيانات.",
      "system.post": "إرسال البريد",
      "system.eingerichtet": "مُعد",
      "system.fehlt": "غير مُعد",
      "nav.uebernahme": "النقل",
      "uebernahme.titel": "النقل من التطبيق القديم",
      "uebernahme.hinweis": "استيراد العملاء والعقارات. تجربة أولا، ثم تقرر أنت.",
      "uebernahme.dateiWaehlen": "اختر ملف التطبيق القديم",
      "uebernahme.gelesen": "{{datei}} · تمت قراءة {{count}} سجلا",
      "uebernahme.falscheDatei": "هذا الملف لا يحتوي على بيانات عملاء من التطبيق القديم.",
      "uebernahme.probe": "تجربة",
      "uebernahme.probeErgebnis": "تجربة، لم يتم حفظ أي شيء",
      "uebernahme.uebernehmen": "استيراد الآن",
      "uebernahme.fertig": "تم الاستيراد",
      "uebernahme.zusammenfassung": "{{gelesen}} مقروء، {{neu}} جديد، {{aktualisiert}} محدث، {{uebersprungen}} متجاوز",
      "uebernahme.spalteKunde": "العميل",
      "uebernahme.spalteObjekt": "العقار",
      "uebernahme.spalteZustand": "الحالة",
      "uebernahme.spalteHinweise": "ملاحظات",
      "uebernahme.zustand.neu": "جديد",
      "uebernahme.zustand.aktualisiert": "محدث",
      "uebernahme.zustand.uebersprungen": "متجاوز",
      "nav.einstellungen": "الإعدادات",
      "einstellungen.titel": "الإعدادات",
      "einstellungen.hinweis": "تظهر هذه البيانات في التقارير وفي الرسائل إلى المالك.",
      "einstellungen.firma": "الشركة",
      "einstellungen.telefon": "الهاتف",
      "einstellungen.email": "البريد الإلكتروني",
      "einstellungen.emailHinweis": "يظهر هذا العنوان في البيان القانوني ويستقبل بلاغات قناة الإبلاغ ما لم يُسجَّل عنوان آخر.",
      "einstellungen.rechtTitel": "البيانات الإلزامية للإشعار القانوني وسياسة الخصوصية",
      "einstellungen.rechtWarnung": "تظهر هذه البيانات في الإشعار القانوني وسياسة الخصوصية. وما يبقى فارغا هنا يبقى ناقصا هناك، والمادة 10 من قانون LSSI تشترط استكماله.",
      "einstellungen.firmierung": "الاسم الكامل للشركة",
      "einstellungen.firmierungHinweis": "كما هو مسجل في السجل التجاري، مع الشكل القانوني. الفراغ يعني اعتماد اسم الشركة أعلاه.",
      "einstellungen.nif": "الرقم الضريبي NIF",
      "einstellungen.anschrift": "عنوان المقر",
      "einstellungen.anschriftHinweis": "يسمح بعدة أسطر، كما يكتب على الرسالة.",
      "einstellungen.register": "القيد في السجل التجاري",
      "einstellungen.registerHinweis": "السجل والمجلد والصفحة ورقم الورقة. مذكورة في عقد التأسيس.",
      "einstellungen.datenschutzEmail": "عنوان طلبات حماية البيانات",
      "einstellungen.datenschutzEmailHinweis": "إلى هذا العنوان تصل طلبات الاطلاع والحذف. الفراغ يعني اعتماد البريد أعلاه.",
      "betrieb.urlaubEinheit": "احتساب الإجازة بـ",
      "betrieb.urlaubEinheitHinweis": "الأيام التقويمية هي الحد الأدنى القانوني وهو 30 يوماً. أيام العمل عادةً 22.",
      "betrieb.planTitel": "التخطيط وزمن الطريق",
      "betrieb.planHinweis": "الإطار الذي يخطط ضمنه الاقتراح الأسبوعي، والافتراضات وراء زمن الطريق المقدر.",
      "betrieb.planBeginn": "بداية الدوام",
      "betrieb.planEnde": "نهاية الدوام",
      "betrieb.planTeamAb": "فريق ابتداء من (دقيقة)",
      "betrieb.planTeamAbHinweis": "ابتداء من هذا الحجم يقترح التخطيط شخصين: رحلة واحدة بدل رحلتين.",
      "betrieb.fahrtTempo": "السرعة المتوسطة (كم/س)",
      "betrieb.planPauseNach": "الاستراحة بعد (دقائق)",
      "betrieb.planPauseNachHinweis": "بعد هذا العدد من دقائق العمل يضع المخطط الاستراحة. تقع بين موعدين؛ وإن لم تجد مكانًا وقعت داخل الموعد الجاري وتوقف وقت العمل خلالها.",
      "betrieb.planPause": "مدة الاستراحة (دقائق)",
      "betrieb.planPauseHinweis": "قاعدة داخلية لا قانون. تشترط المادة 34.4 من قانون العمل الاستراحة فقط فوق ست ساعات متصلة، وعندها خمس عشرة دقيقة. لا يمكن ضبط أقل من خمس عشرة.",
      "betrieb.fahrtTempoHinweis": "أساس التقدير. هل تصلح 45 لهذه الجزيرة يتبين بعد صيف واحد.",
      "betrieb.fahrtUmweg": "معامل الالتفاف",
      "betrieb.fahrtUmwegHinweis": "المسافة المستقيمة مضروبة بهذا المعامل تعطي مسافة الطريق المفترضة.",
      "betrieb.startOrt": "نقطة انطلاق المسار",
      "betrieb.streckenKeine": "تُقدَّر أزمنة القيادة بالخط المستقيم. لا توجد مسارات مقيسة بعد.",
      "betrieb.eichung": "وفق {{paare}} مسارًا مقيسًا بين كيلومترين وثلاثين كيلومترًا، أي الطول الواقع بين موعدين في اليوم، تكون {{tempo}} كم/س ومعامل {{umweg}}.",
      "betrieb.eichungUebernehmen": "اعتماد",
      "betrieb.streckenStand": "{{anzahl}} من {{moeglich}} مسارًا مقيسًا فعليًا، آخرها في {{datum}}. وحيث لا قياس، يجري التقدير.",
      "betrieb.startOrtHinweis": "المكان الذي يبدأ فيه يوم العمل وينتهي، مثل سينيو. لا يُحتسب وقت عمل؛ الطريق إلى أول زبون وقت خاص. يحدد الاتجاه فقط: عند تساوي المسافة يبدأ اليوم بالزبون الأقرب. يُبحث عن الإحداثية عند الحفظ.",
      "urlaub.titel": "رصيد الإجازة {{jahr}}",
      "urlaub.einheit.natural": "بالأيام التقويمية",
      "urlaub.einheit.laboral": "بأيام العمل",
      "urlaub.anspruch": "الاستحقاق",
      "urlaub.anspruchHinweis": "أيام هذه السنة",
      "urlaub.anspruchTitel": "استحقاق الإجازة",
      "urlaub.anspruchSpeichern": "حفظ الاستحقاق",
      "urlaub.uebertrag": "المرحّل",
      "urlaub.uebertragHinweis": "أيام مرحّلة من السنة الماضية",
      "urlaub.genommen": "المستخدم",
      "urlaub.beantragt": "المطلوب",
      "urlaub.verbleibend": "المتبقي",
      "urlaub.standChef": "{{genommen}} مستخدمة، {{rest}} متبقية.",
      "urlaub.ohneAnspruch": "لا يوجد استحقاق مسجَّل لهذه السنة. المكتب يُدخله.",
      "urlaub.ohneAnspruchChef": "لا يوجد استحقاق مسجَّل لهذه السنة. أدخله لكل موظف في الفريق.",
      "betrieb.titel": "التشغيل",
      "betrieb.hinweis": "كيفية عمل النظام. مرئي للإدارة فقط.",
      "betrieb.ortung": "تتبّع الموقع المستمر أثناء ساعات العمل",
      "betrieb.ortungWarnung": "تسمح المادة 90 من قانون حماية البيانات الإسباني بتتبّع الموقع في العمل فقط بعد إبلاغ العاملين مسبقاً بوضوح وصراحة. لذلك يتطلب التفعيل تاريخ توفّر الإشعار الموقّع. يُسجَّل التغيير.",
      "betrieb.ortungTage": "حذف بيانات الموقع بعد",
      "betrieb.ortungTageHinweis": "يوماً. بعدها تبقى المسافة بالأمتار فقط على التسجيل.",
      "betrieb.ortungInfoAm": "الإشعار الموقّع من العاملين متوفر منذ",
      "betrieb.ortungInfoAmHinweis": "بدون هذا التاريخ لا يمكن تفعيل تتبّع الموقع. تبقى الأوراق الموقّعة في ملف شؤون الموظفين، وهنا يُسجَّل التاريخ فقط.",
      "betrieb.maxAbstand": "المسافة اللافتة ابتداءً من",
      "betrieb.maxAbstandHinweis": "متر. التسجيل من مسافة أبعد يظهر بالأحمر في السجل.",
      "betrieb.kiAn": "نصوص مقترحة من كلود",
      "betrieb.verbrauch": "المصروف هذا الشهر",
      "betrieb.verbrauchStand": "{{verbraucht}} من {{grenze}}",
      "betrieb.kiLimit": "الميزانية الشهرية",
      "betrieb.kiLimitHinweis": "يورو شهرياً. عند نفادها لا تُنشأ اقتراحات أخرى.",
      "betrieb.kiVorschlaege": "اقتراحات لكل Report",
      "betrieb.kiVorschlaegeHinweis": "كم مرة يجوز سؤال كلود عن الـ Report نفسه.",
      "betrieb.bueroKopie": "نسخة مخفية إلى المكتب",
      "betrieb.bueroKopieHinweis": "العنوان الذي يتلقى نسخة من كل بريد للعميل. الفراغ يعني بلا نسخة.",
      "einstellungen.gespeichert": "تم الحفظ.",
      "nav.baukasten": "الوحدات",
      "baukasten.titel": "نقاط الفحص",
      "baukasten.hinweis": "هنا تبني تقريرك: أولا مجال كعنوان رئيسي، وتحته نقاط الفحص. أي تغيير يصل إلى كل العقارات فورا، والاستثناءات تُضبط عند العقار نفسه.",
      "baukasten.gruppe": "عنوان فرعي",
      "baukasten.gruppeHinweis": "اختياري. العنوان نفسه في نقاط متتالية يكوّن قسما في التطبيق وفي التقرير.",
      "baukasten.gruppeBeispiel": "الخارج",
      "baukasten.hilfetext": "نص مساعدة للموظفين",
      "baukasten.hilfetextHinweis": "اختياري. يظهر في التطبيق تحت نقطة الفحص، وهو نفسه لكل العقارات.",
      "baukasten.hoch": "إلى الأعلى",
      "baukasten.runter": "إلى الأسفل",
      "checkliste.bereiche": "المجالات في هذا العقار",
      "checkliste.bereicheHinweis": "لا يُفحص إلا ما هو محدد هنا. أزل تحديد ما لا يوجد في هذا العقار.",
      "checkliste.mindestensEinBereich": "يجب أن يبقى مجال واحد على الأقل.",
      "checkliste.ohneBezeichnung": "فحص العقار",
      "checkliste.punktErgaenzen": "إضافة نقطة فحص واحدة",
      "checkliste.punktErgaenzenHinweis": "للحالات الفردية، مثل رصيف قارب. مجال كامل يكون أكثر من اللازم.",
      "checkliste.fotoStandard": "كما في المعيار",
      "baukasten.punkte": "نقاط الفحص",
      "baukasten.punktNeu": "نقطة فحص جديدة",
      "baukasten.punkteAnzahl_zero": "لا توجد نقاط فحص",
      "baukasten.punkteAnzahl_one": "نقطة فحص واحدة",
      "baukasten.punkteAnzahl_two": "نقطتا فحص",
      "baukasten.punkteAnzahl_few": "{{count}} نقاط فحص",
      "baukasten.punkteAnzahl_many": "{{count}} نقطة فحص",
      "baukasten.punkteAnzahl_other": "{{count}} نقطة فحص",
      "baukasten.keinePunkte": "لا توجد نقاط فحص بعد.",
      "baukasten.bereichNeu": "مجال جديد",
      "baukasten.bereichUmbenennen": "إعادة تسمية",
      "baukasten.bereichName": "اسم المجال",
      "baukasten.bereichNameHinweis": "العنوان الرئيسي في التقرير، مثل العقار أو المطبخ أو الأسطول. اكتب بالألمانية فقط، وكلود يترجم الباقي.",
      "baukasten.bereichBeispiel": "العقار",
      "baukasten.keineBereiche": "لا يوجد مجال بعد. المجال عنوان رئيسي في التقرير، وتحته تأتي نقاط الفحص.",
      "vorlage.titel": "قوالب التقارير",
      "vorlage.hinweis": "للمهام التي لا تتكرر. يختار الموظف القالب عند الموعد، ويأتي العقار من الموعد. لا حاجة لإعداد شيء عند العقار.",
      "vorlage.neu": "قالب جديد",
      "vorlage.keine": "لا توجد قوالب بعد. من يقوم بجولات دورية فقط لا يحتاج إليها.",
      "vorlage.bereiche": "المجالات في هذا التقرير",
      "vorlage.bezeichnung": "الاسم",
      "vorlage.bezeichnungHinweis": "يرى الموظف عند الموعد هذا الاسم فقط، ويجب أن يعرف منه أي تقرير يبدأ.",
      "vorlage.beispiel": "تركيب النوافذ",
      "vorlage.ohneBereich": "لم يُحدَّد أي مجال",
      "unterschrift.titel": "موافقة العميل",
      "unterschrift.hinweis": "اختياري. في أعمال التركيب يؤكد العميل بذلك أن العمل تم. يظهر في ملف PDF أسفل التقرير.",
      "unterschrift.keine": "لم يُوقَّع بعد.",
      "unterschrift.leisten": "أخذ التوقيع",
      "unterschrift.erneut": "توقيع من جديد",
      "unterschrift.name": "الاسم بحروف واضحة",
      "unterschrift.nameHinweis": "التوقيع على الشاشة غالبا غير مقروء. بدون الاسم لن يعرف أحد لاحقا من وقّع.",
      "unterschrift.nameFehlt": "يرجى كتابة الاسم بحروف واضحة.",
      "unterschrift.leer": "يرجى التوقيع داخل المربع.",
      "unterschrift.leeren": "من جديد",
      "baukasten.vorlagenTitel": "ابدأ من قائمة نموذجية",
      "baukasten.vorlagenHinweis": "توفر الساعة الأولى. كل ما يُحمَّل يصبح ملكك: إعادة تسمية، إضافة، حذف. يختفي هذا العرض بمجرد وجود أول نقطة فحص.",
      "baukasten.vorlagenUmfang": "{{bereiche}} مجالات، {{punkte}} نقاط فحص",
      "baukasten.vorlageLaden": "تحميل",
      "checkliste.keineBereiche": "لا توجد مجالات بعد. أنشئها أولا في بنك نقاط الفحص ثم حددها هنا.",
      "team.keineBereiche": "لا توجد مجالات في بنك نقاط الفحص بعد.",
      "baukasten.stilllegen": "إيقاف",
      "baukasten.wiederAktiv": "إعادة التفعيل",
      "baukasten.stillgelegt": "موقوف",
      "baukasten.schluessel": "المفتاح",
      "baukasten.schluesselHinweis": "اسم تقني لا يمكن تغييره لاحقا. حروف صغيرة وشرطة سفلية.",
      "baukasten.punktSchluesselHinweis": "المجال والاسم، مثال pool.abdeckung.",
      "baukasten.beschriftung": "التسمية",
      "baukasten.eingabeart": "نوع الإدخال",
      "baukasten.eingabeartHinweis": "يحدد ما يمكن للموظف تحديده أو تسجيله في العقار.",
      "baukasten.art.status": "فحص: تم، سليم، عطل، لم يُفحص",
      "baukasten.art.number": "رقم",
      "baukasten.art.boolean": "تأشير: تم أو لا",
      "baukasten.art.text": "نص حر",
      "baukasten.art.photo": "صورة فقط",
      "baukasten.einheit": "الوحدة",
      "baukasten.zielVon": "القيمة من",
      "baukasten.zielBis": "القيمة إلى",
      "baukasten.zielHinweis": "إذا خرجت القيمة عن المجال يطلب التطبيق تعليقا فورا.",
      "baukasten.fotoPflicht": "الصورة إلزامية",
      "baukasten.fotoPflichtLang": "على الموظف رفع صورة لهذه النقطة، إلا إذا اختار لا ينطبق",
      "baukasten.uebersetztHinweis": "اكتب بالألمانية فقط. يترجم كلود إلى الإنجليزية والإسبانية والعربية عند الحفظ.",
      "checkliste.titel": "قوائم الفحص",
      "checkliste.keine": "لا توجد قائمة فحص لهذا العقار بعد.",
      "checkliste.hinzufuegen": "إضافة قائمة",
      "checkliste.bezeichnung": "التسمية",
      "checkliste.bezeichnungHinweis": "اختياري، مثال أسبوعي.",
      "checkliste.zurueckZumObjekt": "إلى العقار",
      "checkliste.vorschau": "ما يراه الموظف",
      "checkliste.vorschauHinweis": "ناتج القالب مع الاختلافات، للشهر المحدد.",
      "checkliste.leer": "لا يتبقى شيء لهذا الشهر.",
      "checkliste.ergaenzt": "مضاف",
      "checkliste.angepasst": "معدل",
      "checkliste.anpassen": "تعديل",
      "checkliste.abwaehlen": "إزالة",
      "checkliste.abgewaehltePunkte": "نقاط أزيلت هنا",
      "checkliste.wiederAufnehmen": "إعادة الإدراج",
      "checkliste.fotoPflicht": "الصورة إلزامية",
      "checkliste.fotoFrei": "لا حاجة لصورة",
      "checkliste.fotoHinweis": "كما في القالب يعني: إذا تغير القالب يتغير هذا العقار معه.",
      "checkliste.objekthinweis": "ملاحظة العقار",
      "checkliste.objekthinweisHinweis": "تظهر بجانب نقطة الفحص وتغني عن التدريب في الموقع.",
      "checkliste.objekthinweisBeispiel": "وحدة الفلتر في غرفة المعدات خلف بيت المسبح، المفتاح رقم 4",
      "checkliste.anpassungZuruecknehmen": "التراجع عن التعديل",
      "aktion.speichern": "حفظ",
      "aktion.speichert": "جاري الحفظ",
      "aktion.abbrechen": "إلغاء",
      "aktion.bearbeiten": "تعديل",
      "aktion.loeschen": "حذف",
      "aktion.ja": "نعم",
      "aktion.nein": "لا",
      "archiv.zeigen": "إظهار المؤرشف",
      "archiv.marke": "مؤرشف",
      "archiv.archivieren": "أرشفة",
      "archiv.zurueckholen": "استعادة",
      "archiv.kundeMitObjekten_zero": "لا توجد عقارات نشطة لهذا العميل. هل تريد المتابعة؟",
      "archiv.kundeMitObjekten_one": "لدى هذا العميل عقار نشط واحد. سيتم أرشفته أيضا. هل تريد المتابعة؟",
      "archiv.kundeMitObjekten_two": "لدى هذا العميل عقاران نشطان. ستتم أرشفتهما أيضا. هل تريد المتابعة؟",
      "archiv.kundeMitObjekten_few": "لدى هذا العميل {{count}} عقارات نشطة. ستتم أرشفتها أيضا. هل تريد المتابعة؟",
      "archiv.kundeMitObjekten_many": "لدى هذا العميل {{count}} عقارا نشطا. ستتم أرشفتها أيضا. هل تريد المتابعة؟",
      "archiv.kundeMitObjekten_other": "لدى هذا العميل {{count}} عقار نشط. ستتم أرشفتها أيضا. هل تريد المتابعة؟",
      "fehler.laden": "تعذر تحميل البيانات",
      "hinweis.hinweis": "تُرسل بالبريد الإلكتروني إلى الإدارة ولا تُحفظ في أي مكان.",
      "hinweis.platzhalter": "ما الذي ينبغي أن يعرفه المدير؟",
      "hinweis.diktieren": "للإملاء استخدم مفتاح الميكروفون في لوحة المفاتيح.",
      "hinweis.senden": "إرسال الملاحظة",
      "hinweis.gesendet": "تم إرسال الملاحظة. شكرا لك.",
      "hinweis.nochEiner": "كتابة ملاحظة أخرى",
      "fehler.speichern": "تعذر الحفظ",
      "fehler.seite": "هذه الصفحة غير موجودة.",
      "kunden.titel": "العملاء",
      "kunden.neu": "عميل جديد",
      "kunden.bearbeiten": "تعديل العميل",
      "kunden.suche": "البحث بالاسم أو البريد أو الهاتف",
      "kunden.leer": "لا يوجد عملاء بعد.",
      "kunden.ausgewaehlt_zero": "لم يتم اختيار أي عميل",
      "kunden.ausgewaehlt_one": "تم اختيار عميل واحد",
      "kunden.ausgewaehlt_two": "تم اختيار عميلين",
      "kunden.ausgewaehlt_few": "تم اختيار {{count}} عملاء",
      "kunden.ausgewaehlt_many": "تم اختيار {{count}} عميلاً",
      "kunden.ausgewaehlt_other": "تم اختيار {{count}} عميل",
      "kunden.auswahlAufheben": "إلغاء الاختيار",
      "kunden.sammelArchivFrage_zero": "لا يوجد ما يُؤرشف.",
      "kunden.sammelArchivFrage_one": "أرشفة عميل واحد و{{objekte}} عقارات؟ تُؤرشف العقارات معه.",
      "kunden.sammelArchivFrage_two": "أرشفة عميلين و{{objekte}} عقارات؟ تُؤرشف العقارات معهما.",
      "kunden.sammelArchivFrage_few": "أرشفة {{count}} عملاء و{{objekte}} عقارات؟ تُؤرشف العقارات معهم.",
      "kunden.sammelArchivFrage_many": "أرشفة {{count}} عميلاً و{{objekte}} عقارات؟ تُؤرشف العقارات معهم.",
      "kunden.sammelArchivFrage_other": "أرشفة {{count}} عميل و{{objekte}} عقارات؟ تُؤرشف العقارات معهم.",
      "kunden.sammelZurueckFrage_zero": "لا يوجد ما يُستعاد.",
      "kunden.sammelZurueckFrage_one": "استعادة عميل واحد؟",
      "kunden.sammelZurueckFrage_two": "استعادة عميلين؟",
      "kunden.sammelZurueckFrage_few": "استعادة {{count}} عملاء؟",
      "kunden.sammelZurueckFrage_many": "استعادة {{count}} عميلاً؟",
      "kunden.sammelZurueckFrage_other": "استعادة {{count}} عميل؟",
      "kunden.anzahl_zero": "لا يوجد عملاء",
      "kunden.anzahl_one": "عميل واحد",
      "kunden.anzahl_two": "عميلان",
      "kunden.anzahl_few": "{{count}} عملاء",
      "kunden.anzahl_many": "{{count}} عميلا",
      "kunden.anzahl_other": "{{count}} عميل",
      "kunden.objekte_zero": "لا توجد عقارات",
      "kunden.objekte_one": "عقار واحد",
      "kunden.objekte_two": "عقاران",
      "kunden.objekte_few": "{{count}} عقارات",
      "kunden.objekte_many": "{{count}} عقارا",
      "kunden.objekte_other": "{{count}} عقار",
      "kunden.kontakt": "بيانات الاتصال",
      "kunden.rechnungsadresse": "عنوان الفاتورة",
      "kunden.notizen": "ملاحظات",
      "kunden.art": "النوع",
      "kunden.art.private": "فرد",
      "kunden.art.company": "شركة",
      "kunden.name": "الاسم",
      "kunden.nameHinweis": "هكذا يظهر العميل في القوائم والـ Reports.",
      "kunden.firma": "اسم الشركة",
      "kunden.steuernummer": "الرقم الضريبي",
      "kunden.anrede": "صيغة المخاطبة",
      "kunden.briefanrede": "التحية في الرسالة",
      "kunden.briefanredeHinweis": "بهذا يبدأ نص الـ Report. المحايد يعني ألا يُخاطب أحد بشكل خاطئ.",
      "kunden.anredeHelferStarten_zero": "لا يوجد عميل بلا لقب",
      "kunden.anredeHelferStarten_one": "إكمال لقب عميل واحد",
      "kunden.anredeHelferStarten_two": "إكمال لقب {{count}} عملاء",
      "kunden.anredeHelferStarten_few": "إكمال لقب {{count}} عملاء",
      "kunden.anredeHelferStarten_many": "إكمال لقب {{count}} عميلا",
      "kunden.anredeHelferStarten_other": "إكمال لقب {{count}} عميل",
      "kunden.anredeHelferStand": "{{fertig}} من {{gesamt}} محفوظ",
      "kunden.anredeHelferBeenden": "تم",
      "kunden.anredeHelferHinweis": "الاقتراح هو آخر كلمة من الاسم المعروض. اللقب لا يُخمَّن، بل تختاره أنت. وإذا بقي محايدا يظهر في التقويم الاسم وحده.",
      "kunden.anredeUebernommen": "محفوظ",
      "kunden.anredeKeinVorschlag": "لا يوجد اقتراح، اكتبه بنفسك.",
      "kunden.anredename": "الاسم في التحية",
      "kunden.anredenameHinweis": "اسم العائلة للمخاطبة الرسمية، والاسم الأول لغير الرسمية. ويظهر أيضا عنوانا للموعد في التقويم.",
      "kunden.anredeNeutral": "سيداتي سادتي،",
      "kunden.salutation.herr": "السيد",
      "kunden.salutation.frau": "السيدة",
      "kunden.salutation.familie": "عائلة",
      "kunden.salutation.neutral": "محايد",
      "kunden.anrede.du": "غير رسمية",
      "kunden.anrede.sie": "رسمية",
      "kunden.sprache": "اللغة",
      "kunden.spracheHinweis": "لغة الـ Reports لهذا العميل.",
      "kunden.email": "البريد الإلكتروني",
      "kunden.emailHinweis": "افصل بين العناوين بفاصلة منقوطة. يُرسل التقرير إليها جميعا.",
      "kunden.telefon": "الهاتف",
      "objekte.titel": "العقارات",
      "objekte.alle": "كل العقارات",
      "objekte.neu": "عقار جديد",
      "objekte.bearbeiten": "تعديل العقار",
      "objekte.suche": "البحث بالعقار أو المدينة أو العميل",
      "objekte.leer": "لا توجد عقارات بعد.",
      "objekte.leerBeiKunde": "لا يوجد عقار لهذا العميل بعد.",
      "objekte.anzahl_zero": "لا توجد عقارات",
      "objekte.anzahl_one": "عقار واحد",
      "objekte.anzahl_two": "عقاران",
      "objekte.anzahl_few": "{{count}} عقارات",
      "objekte.anzahl_many": "{{count}} عقارا",
      "objekte.anzahl_other": "{{count}} عقار",
      "objekte.name": "التسمية",
      "objekte.nameHinweis": "مثال: فيلا سون فيدا أو فينكا أندراتكس.",
      "objekte.kunde": "العميل",
      "objekte.kundeWaehlen": "الرجاء الاختيار",
      "objekte.ohneKoordinate": "بلا إحداثيات",
      "objekte.nurOhneKoordinate": "بلا إحداثيات فقط",
      "objekte.koordinateFehlt": "لا توجد إحداثيات لهذا العقار. بدونها لا يمكن حساب المسافة عند التسجيل.",
      "objekte.koordinateSuchen": "البحث عن الإحداثيات",
      "objekte.koordinateNichts": "لم يُعثر على شيء في مايوركا لهذا العنوان. أدخلها يدوياً.",
      "objekte.nurStrasse": "نتيجة بدون رقم المنزل، النقطة على الشارع. هذا يكفي للتحقق من المسافة.",
      "objekte.koordinateUebernehmen": "استخدام هذه",
      "objekte.koordinateAnsehen": "عرض على الخريطة",
      "objekte.zumKunden": "إلى العميل",
      "objekte.lage": "الموقع",
      "objekte.vertrag": "العقد",
      "objekte.gemeinde": "البلدية",
      "objekte.gemeindeHinweis": "كالفيا، أندراتكس، بويينسا وغيرها.",
      "objekte.breite": "خط العرض",
      "objekte.laenge": "خط الطول",
      "objekte.koordinatenHinweis": "اختياري. يتيح لاحقا التوجه إلى العقار.",
      "objekte.route": "بدء التوجيه",
      "objekte.leistung": "الخدمة",
      "objekte.leistungHinweis": "مثال: الرعاية الشاملة.",
      "objekte.beginn": "بداية العقد",
      "objekte.ende": "نهاية العقد",
      "objekte.poolheizung": "يوجد تدفئة للمسبح",
      "objekte.poolheizungHinweis": "يثبت في العقار أن تدفئة المسبح متفق عليها ويمكن تشغيلها مع الإقامة.",
      "objekte.anfahrt": "الوصول والدخول",
      "objekte.anfahrtHinweis": "ملاحظات للموظفين. بدون رموز إنذار وبدون أماكن إخفاء المفاتيح.",
      "adresse.strasse": "الشارع والرقم",
      "adresse.plz": "الرمز البريدي",
      "adresse.ort": "المدينة",
      "adresse.land": "الدولة",
      "adresse.landHinweis": "حرفان، مثال ES أو DE.",
      "app.name": "Jornado",
      "recht.datenschutz": "سياسة الخصوصية",
      "recht.impressum": "بيان قانوني",
      "recht.zurueck": "العودة إلى التطبيق",
      "recht.stand": "الإصدار {{datum}}",
      "login.title": "تسجيل الدخول",
      "login.email": "البريد الإلكتروني",
      "login.password": "كلمة المرور",
      "login.zeigen": "إظهار كلمة المرور",
      "login.verbergen": "إخفاء كلمة المرور",
      "login.submit": "دخول",
      "login.pending": "لحظة من فضلك",
      "login.failed": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
      "nav.customers": "العملاء",
      "nav.password": "كلمة المرور",
      "password.title": "تغيير كلمة المرور",
      "password.hint": "سيلزم تسجيل الدخول من جديد بعد ذلك.",
      "password.current": "كلمة المرور الحالية",
      "password.new": "كلمة المرور الجديدة",
      "password.rule": "12 حرفا على الأقل، مع حرف كبير وصغير ورقم.",
      "password.save": "تغيير",
      "password.cancel": "إلغاء",
      "password.failed": "تعذر التغيير",
      "nav.logout": "تسجيل الخروج",
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: "de",
  fallbackLng: "de",
  supportedLngs: [...LOCALES],
  interpolation: { escapeValue: false }
});

/** Setzt Sprache und Leserichtung am Dokument. */
export function applyLocale(locale: string) {
  void i18n.changeLanguage(locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = isRtl(locale) ? "rtl" : "ltr";
}

export default i18n;
